window.GSP = window.GSP || {};
(function($2) {
  GSP.core = {
    _vw_current: 0,
    _devices: {
      xs: 0,
      sm: "576",
      md: "768",
      lg: "992",
      xl: "1200",
      xxl: "1400"
    },
    isDeviceUp: function(device) {
      return window.matchMedia("(min-width: " + GSP.core._devices[device] + "px)").matches;
    },
    isDeviceDown: function(device) {
      return window.matchMedia("(max-width: " + (GSP.core._devices[device] - 1) + "px)").matches;
    },
    init: function() {
      this.changeViewportWidth();
      this.windowResize();
    },
    windowResize: function() {
      window.addEventListener("resize", function() {
        GSP.core.changeViewportWidth();
      });
    },
    changeViewportWidth: function() {
      let vw = document.documentElement.clientWidth;
      $2("body").css("--vw", `${vw}px`);
      if (GSP.core._vw_current !== vw) {
        GSP.core._vw_current = vw;
        $2(document).trigger("gsp_change_viewport");
      }
    }
  };
  $2(document).ready(function() {
    GSP.core.init();
  });
})(jQuery);
(function($2) {
  GSP.config = {
    /**
     * Runtime state
     */
    state: {
      hasLocalStorage: false,
      motionReduced: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
      isRTL: document.documentElement.dir === "rtl",
      isTouch: "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    },
    settings: {
      smoothScroll: window.gspSetting.smoothScroll ?? true,
      compareLimit: window.gspSetting.shop.compare_limit,
      templateName: window.gspSetting.templateName
    },
    device: {
      queries: {
        mobile: null,
        tablet: null,
        laptop: null,
        smallDesktop: null
      },
      mediaQuery: {
        mobile: "screen and (max-width: 767px)",
        tablet: "screen and (max-width: 1023px)",
        laptop: "screen and (max-width: 1279px)",
        smallDesktop: "screen and (max-width: 1535px)"
      },
      mobile: false,
      tablet: false,
      laptop: false,
      smallDesktop: false,
      init() {
        this.bind(
          "Mobile",
          this.mediaQuery.mobile,
          "mobile"
        );
        this.bind(
          "Tablet",
          this.mediaQuery.tablet,
          "tablet"
        );
        this.bind(
          "Laptop",
          this.mediaQuery.laptop,
          "laptop"
        );
        this.bind(
          "SmallDesktop",
          this.mediaQuery.smallDesktop,
          "smallDesktop"
        );
      },
      bind(name, query, key) {
        const mql = window.matchMedia(query);
        this.queries[key] = mql;
        this[key] = mql.matches;
        const handler = (event) => {
          this[key] = event.matches;
          document.dispatchEvent(
            new CustomEvent(
              event.matches ? `match${name}` : `unmatch${name}`
            )
          );
        };
        if (mql.addEventListener) {
          mql.addEventListener("change", handler);
        } else {
          mql.onchange = handler;
        }
      },
      isMobile() {
        return this.mobile;
      },
      isTablet() {
        return this.tablet && !this.mobile;
      },
      isDesktop() {
        return !this.tablet;
      },
      isSafari() {
        const ua = navigator.userAgent;
        return /^((?!chrome|android).)*safari/i.test(ua);
      },
      isIOS() {
        return /iPad|iPhone|iPod/.test(
          navigator.userAgent
        );
      }
    },
    initScrollbarWidth() {
      let lastWidth = 0;
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const currentWidth = entry.borderBoxSize[0].inlineSize;
          if (currentWidth !== lastWidth) {
            lastWidth = currentWidth;
            const outer = document.createElement("div");
            outer.style.visibility = "hidden";
            outer.style.overflow = "scroll";
            outer.style.width = "100px";
            document.body.appendChild(outer);
            const scrollbarWidth = outer.offsetWidth - outer.clientWidth;
            outer.remove();
            document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
          }
        }
      });
      observer.observe(document.documentElement);
    },
    /**
     * Initialize
     */
    init() {
      this.detectLocalStorage();
      this.device.init();
      this.initScrollbarWidth();
    },
    /**
     * Detect LocalStorage
     */
    detectLocalStorage() {
      try {
        const key = "__gsp__";
        localStorage.setItem(key, "1");
        localStorage.removeItem(key);
        this.state.hasLocalStorage = true;
      } catch (e) {
        this.state.hasLocalStorage = false;
      }
    },
    /**
     * Smooth Scroll
     */
    isSmoothScrollEnabled() {
      if (this.state.motionReduced) {
        return false;
      }
      if (this.device.isSafari()) {
        return false;
      }
      if (this.device.isMobile()) {
        return false;
      }
      if (this.state.isTouch) {
        return false;
      }
      return this.settings.smoothScroll;
    }
  };
  GSP.config.init();
})(jQuery);
(function($2) {
  GSP.pubsub = {
    PUB_SUB_EVENTS: {
      cartUpdate: "cart-update",
      cartUpdated: "cart-updated",
      quantityUpdate: "quantity-update",
      quantityRules: "quantity-rules",
      quantityBoundries: "quantity-boundries",
      variantChange: "variant-change",
      cartError: "cart-error",
      facetUpdate: "facet-update",
      optionValueSelectionChange: "option-value-selection-change",
      quickViewShow: "quick-view-show",
      loadPost: "load-post",
      loadPostError: "load-post:error",
      loadPostFinally: "load-post:finally",
      compareAdded: "compare:add",
      compareRemove: "compare:remove",
      compareToggle: "compare:toggle",
      appendElement: "append-element",
      filterProductChange: "filter:product-change",
      hotspotConnectBlockMouseenter: "hotspot:mouseenter",
      hotspotConnectBlockMouseleave: "hotspot:mouseleave"
    },
    subscribers: {},
    subscribe: (eventName, callback) => {
      if (GSP.pubsub.subscribers[eventName] === void 0) {
        GSP.pubsub.subscribers[eventName] = [];
      }
      GSP.pubsub.subscribers[eventName] = [...GSP.pubsub.subscribers[eventName], callback];
      return function unsubscribe() {
        GSP.pubsub.subscribers[eventName] = GSP.pubsub.subscribers[eventName].filter((cb) => {
          return cb !== callback;
        });
      };
    },
    publish: (eventName, data) => {
      if (GSP.pubsub.subscribers[eventName]) {
        GSP.pubsub.subscribers[eventName].forEach((callback) => {
          callback(data);
        });
      }
    }
  };
})(jQuery);
(function($2) {
  GSP.scroll = {
    initialized: false,
    engine: null,
    callbacks: /* @__PURE__ */ new Set(),
    scroll: 0,
    lastScroll: 0,
    direction: "down",
    ticking: false,
    nativeHandler: null,
    init() {
      if (this.initialized) {
        return;
      }
      this.initialized = true;
      if (GSP.config.isSmoothScrollEnabled()) {
        this.initLenis();
      } else {
        this.initNative();
      }
    },
    initLenis() {
      this.engine = new window.Lenis({
        autoRaf: true,
        smoothWheel: true,
        wheelMultiplier: 1,
        lerp: 0.25,
        duration: 0.6,
        prevent(node) {
          return !!node.closest(
            [
              "[data-lenis-prevent]",
              ".offcanvas",
              ".modal",
              ".dropdown-menu"
            ].join(",")
          );
        }
      });
      this.engine.on("scroll", ({ scroll }) => {
        this.scroll = scroll;
        this.requestTick();
      });
      this.scroll = this.engine.scroll;
    },
    initScrollLockManager() {
      const checkScrollLock = () => {
        const shouldLock = document.body.classList.contains("is-show-dropdown-menu");
        if (shouldLock !== this.isLocked) {
          this.isLocked = shouldLock;
          if (this.engine) {
            shouldLock ? this.engine.stop() : this.engine.start();
          }
        }
      };
      const bodyObs = new MutationObserver(checkScrollLock);
      bodyObs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    },
    initNative() {
      this.scroll = window.scrollY;
      this.nativeHandler = () => {
        this.scroll = window.scrollY;
        this.requestTick();
      };
      window.addEventListener(
        "scroll",
        this.nativeHandler,
        {
          passive: true
        }
      );
    },
    requestTick() {
      if (this.ticking) {
        return;
      }
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    },
    update() {
      this.direction = this.scroll >= this.lastScroll ? "down" : "up";
      const payload = {
        scroll: this.scroll,
        direction: this.direction
      };
      this.lastScroll = this.scroll;
      this.callbacks.forEach((callback) => {
        callback(payload);
      });
    },
    getScroll() {
      return this.scroll;
    },
    scrollTo(target, options = {}) {
      if (this.engine) {
        this.engine.scrollTo(target, options);
        return;
      }
      let element = target;
      if (typeof target === "string") {
        element = document.querySelector(target);
      }
      if (element instanceof HTMLElement) {
        element.scrollIntoView({
          behavior: "smooth",
          block: options.block || "start"
        });
        return;
      }
      if (typeof target === "number") {
        window.scrollTo({
          top: target,
          behavior: "smooth"
        });
      }
    },
    start() {
      this.engine?.start();
    },
    stop() {
      this.engine?.stop();
    },
    register(callback) {
      if (typeof callback !== "function") {
        return;
      }
      this.callbacks.add(callback);
    },
    unregister(callback) {
      this.callbacks.delete(callback);
    },
    destroy() {
      this.callbacks.clear();
      if (this.engine) {
        this.engine.destroy();
        this.engine = null;
      }
      if (this.nativeHandler) {
        window.removeEventListener(
          "scroll",
          this.nativeHandler
        );
        this.nativeHandler = null;
      }
      this.initialized = false;
    },
    resize() {
      this.engine?.resize();
    },
    isSmooth() {
      return !!this.engine;
    },
    isScrolling() {
      return this.ticking;
    },
    refresh() {
      this.resize();
      this.requestTick();
    },
    getMaxScroll() {
      return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    }
  };
  $2(document).ready(function() {
    GSP.scroll.init();
  });
})(jQuery);
(function($2) {
  GSP.resize = {
    initialized: false,
    callbacks: /* @__PURE__ */ new Set(),
    resizeHandler: null,
    rafId: null,
    timer: null,
    width: window.innerWidth,
    height: window.innerHeight,
    delay: 150,
    init() {
      if (this.initialized) {
        return;
      }
      this.initialized = true;
      this.resizeHandler = this.onResize.bind(this);
      window.addEventListener(
        "resize",
        this.resizeHandler,
        {
          passive: true
        }
      );
      $2(document).on(
        "after_prevent_transition_resize",
        this.resizeHandler
      );
    },
    onResize() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
      this.timer = setTimeout(() => {
        this.rafId = requestAnimationFrame(() => {
          this.refresh();
        });
      }, this.delay);
    },
    refresh() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const changed = width !== this.width || height !== this.height;
      const widthChanged = width !== this.width;
      const heightChanged = height !== this.height;
      this.width = width;
      this.height = height;
      this.callbacks.forEach((callback) => {
        callback({
          width,
          height,
          changed,
          widthChanged,
          heightChanged
        });
      });
    },
    register(callback) {
      if (typeof callback !== "function") {
        return;
      }
      this.callbacks.add(callback);
    },
    unregister(callback) {
      this.callbacks.delete(callback);
    },
    getWidth() {
      return this.width;
    },
    getHeight() {
      return this.height;
    },
    destroy() {
      if (this.resizeHandler) {
        window.removeEventListener(
          "resize",
          this.resizeHandler
        );
        $2(document).off(
          "after_prevent_transition_resize",
          this.resizeHandler
        );
        this.resizeHandler = null;
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      this.callbacks.clear();
      this.initialized = false;
    }
  };
  $2(document).ready(function() {
    GSP.resize.init();
  });
})(jQuery);
(function($2) {
  GSP.HTMLUpdateUtility = {
    viewTransition: function(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
      if (oldNode === null) {
        return;
      }
      preProcessCallbacks?.forEach((callback) => callback(newContent));
      const newNodeWrapper = document.createElement("div");
      if (newContent) {
        GSP.HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
      }
      const newNode = newNodeWrapper.firstChild;
      const uniqueKey = Date.now();
      oldNode.querySelectorAll("[id], [form]").forEach((element) => {
        element.id && (element.id = `${element.id}-${uniqueKey}`);
        element.form && element.setAttribute("form", `${element.form.getAttribute("id")}-${uniqueKey}`);
      });
      oldNode.parentNode.insertBefore(newNode, oldNode);
      oldNode.style.display = "none";
      postProcessCallbacks?.forEach((callback) => callback(newNode));
      setTimeout(() => oldNode.remove(), 500);
    },
    setInnerHTML: function(element, html) {
      element.innerHTML = html;
      element.querySelectorAll("script").forEach((oldScriptTag) => {
        const newScriptTag = document.createElement("script");
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  };
})(jQuery);
let ModalComponent$1 = class ModalComponent2 extends HTMLElement {
  constructor() {
    super();
    this.overlayEl = this.querySelector(".modal, .offcanvas");
    this.type = this.overlayEl?.classList.contains("modal") ? "modal" : "offcanvas";
    this.instance = this.createInstance();
    this.onShowHandler = this.onShowHandler.bind(this);
    this.onShownHandler = this.onShownHandler.bind(this);
    this.onHideHandler = this.onHideHandler.bind(this);
    this.onHiddenHandler = this.onHiddenHandler.bind(this);
    this.lastTrigger = null;
  }
  get body() {
    if (this.type === "modal") {
      return this.querySelector(".modal-body");
    }
    return this.querySelector(".offcanvas-body");
  }
  get id() {
    return this.overlayEl.id;
  }
  get controls() {
    return Array.from(document.querySelectorAll(`[data-target="#${this.id}"]`));
  }
  createInstance() {
    if (!this.overlayEl) return null;
    if (this.type === "modal") {
      return bootstrap.Modal.getOrCreateInstance(this.overlayEl);
    }
    return bootstrap.Offcanvas.getOrCreateInstance(this.overlayEl);
  }
  get open() {
    return this.instance._isShown;
  }
  connectedCallback() {
    this.abortController = new AbortController();
    gspTheme.helper.addEventDelegate({
      selector: `[data-target="#${this.id}"]`,
      handler: this.onButtonClickHandler.bind(this)
    });
    this.overlayEl.addEventListener(`show.bs.${this.type}`, this.onShowHandler, {
      signal: this.abortController.signal
    });
    this.overlayEl.addEventListener(`shown.bs.${this.type}`, this.onShownHandler, {
      signal: this.abortController.signal
    });
    this.overlayEl.addEventListener(`hide.bs.${this.type}`, this.onHideHandler, {
      signal: this.abortController.signal
    });
    this.overlayEl.addEventListener(`hidden.bs.${this.type}`, this.onHiddenHandler, {
      signal: this.abortController.signal
    });
    this.designMode();
  }
  designMode() {
    if (Shopify.designMode) {
      this.section = this.closest(".shopify-section");
      if (!this.section) return;
      this.section.addEventListener("shopify:section:select", (event) => {
        this.showOnDesignMode();
      }, {
        signal: this.abortController.signal
      });
      this.section.addEventListener("shopify:section:deselect", () => {
        this.hide();
      }, {
        signal: this.abortController.signal
      });
      this.section.addEventListener("shopify:section:load", (event) => {
        this.showOnDesignMode();
      }, {
        signal: this.abortController.signal
      });
      this.section.addEventListener("shopify:section:unload", () => {
        this.hide();
      }, {
        signal: this.abortController.signal
      });
    }
  }
  disconnectedCallback() {
    this.abortController?.abort();
  }
  showOnDesignMode() {
    if (this.type === "offcanvas") {
      this.instance._focustrap._isActive = true;
    }
    this.show();
  }
  show(targetElement = void 0) {
    if (targetElement) {
      this.lastTrigger = targetElement;
    }
    this.instance?.show(this.lastTrigger);
  }
  hide() {
    this.instance?.hide();
  }
  onButtonClick(event, button) {
    if (this.open) {
      this.hide();
    } else {
      this.show();
    }
  }
  onButtonClickHandler(event, button) {
    event.preventDefault();
    if (button.disabled) {
      return;
    }
    this.lastTrigger = button;
    this.onButtonClick(event, button);
  }
  onShowHandler() {
  }
  onShownHandler() {
  }
  onHideHandler() {
  }
  onHiddenHandler() {
    if (this.lastTrigger) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.lastTrigger.focus({ preventScroll: true });
        });
      });
    }
  }
};
window.ModalComponent = ModalComponent$1;
(function($2) {
  GSP.carousel = {
    options: {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        enabled: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        //dynamicBullets: true,
        enabled: true,
        type: "bullets"
        // 'progressbar' | 'bullets' | 'fraction' | 'custom'
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        enabled: true,
        draggable: true
      },
      autoplay: {
        delay: 3e3,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
        enabled: false
      },
      freeMode: false,
      lazyPreloadPrevNext: 2,
      /*grid: {
          rows: 2,
          fill: 'row'
      },*/
      spaceBetween: 0,
      slidesPerView: 1,
      autoHeight: false,
      centeredSlides: false,
      centeredSlidesBounds: false,
      centerInsufficientSlides: false,
      keyboard: {
        enabled: true
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: false,
        thresholdTime: 300,
        thresholdDelta: 10
      }
    },
    init: function() {
      this.initMultiSwiper();
      if (Shopify.designMode) {
        this.designMode();
      }
      document.addEventListener("matchMobile", () => {
        GSP.carousel.initMultiSwiper();
      });
      document.addEventListener("unmatchMobile", () => {
        GSP.carousel.initMultiSwiper();
      });
    },
    designMode() {
      let _self = this;
      let is_pause_auto = false;
      document.addEventListener("shopify:section:load", function(event) {
        _self.initMultiSwiper(event.target);
      });
      document.addEventListener("shopify:block:select", function(event) {
        const slider = event.target.closest(".gsp-swiper");
        if (slider) {
          const slickItem = event.target.closest(".swiper-slide");
          if (!slickItem) return;
          const wrap = slickItem.closest(".swiper-wrapper");
          const slides = wrap.querySelectorAll(".swiper-slide");
          const index = Array.from(slides).indexOf(slickItem);
          const swiperInstance = slider.swiper;
          if (!swiperInstance || index < 0) return;
          if (swiperInstance.autoplay && swiperInstance.autoplay.running) {
            swiperInstance.autoplay.stop();
            is_pause_auto = true;
          }
          if (swiperInstance.params.loop) {
            swiperInstance.slideToLoop(index);
          } else {
            swiperInstance.slideTo(index);
          }
        }
      });
      document.addEventListener("shopify:block:deselect", function(event) {
        const slider = event.target.closest(".gsp-swiper");
        if (!slider) return;
        const swiperInstance = slider.swiper;
        if (!swiperInstance) return;
        if (swiperInstance.autoplay && is_pause_auto) {
          swiperInstance.autoplay.start();
          is_pause_auto = false;
        }
      });
    },
    initMultiSwiper(element = document.body, selector = ".gsp-swiper:not(.manual)") {
      element.querySelectorAll(selector).forEach((wrapper) => {
        if (wrapper.swiper) {
          wrapper.swiper.destroy(true, true);
        }
        GSP.carousel.initSwiper(wrapper);
      });
    },
    initSwiper: function(swiperEl, extend_options) {
      var $this = $2(swiperEl);
      let wrapperEl = GSP.carousel.getWrapperEl(swiperEl);
      var options_default = GSP.carousel.options;
      options_default.navigation = {
        nextEl: wrapperEl.querySelector(".swiper-button-next"),
        prevEl: wrapperEl.querySelector(".swiper-button-prev"),
        enabled: true
      };
      options_default.pagination = {
        el: wrapperEl.querySelector(".swiper-pagination"),
        clickable: true,
        //dynamicBullets: true,
        enabled: true,
        type: "bullets"
        // 'progressbar' | 'bullets' | 'fraction' | 'custom'
      };
      options_default.scrollbar = {
        el: wrapperEl.querySelector(".swiper-scrollbar"),
        enabled: true,
        draggable: true
      };
      var options = $this.data("swiper-options");
      if (typeof options === "undefined") {
        options = {};
      }
      options = $2.extend(true, {}, options_default, options);
      if (extend_options) {
        options = $2.extend(true, {}, options, extend_options);
      }
      if (options.loop) {
        options.rewind = false;
        options.centeredSlidesBounds = false;
      }
      if (options.pagination.type === "timeline") {
        options.pagination.type = "bullets";
        options.pagination.bulletClass = "swiper-pagination-timeline";
        options.pagination.bulletActiveClass = "swiper-pagination-timeline-active";
        options.pagination.renderBullet = GSP.carousel.renderPaginationTimeline;
      }
      const controller = new AbortController();
      options.on = {
        init: function(swiper) {
          GSP.carousel.calcNavButtonsPosition(swiper);
          GSP.carousel.updatePositionClass(swiper);
          GSP.carousel.handlePaginationVisibility(swiper);
        },
        afterInit: function(swiper) {
          swiper.el.dispatchEvent(new CustomEvent("gsp:swiper:afterInit", {
            detail: {
              swiper,
              element: swiper.el
            }
          }));
          GSP.carousel.autoplayProgress(swiper, controller);
          GSP.carousel.observeSlider(swiper);
          if (options.centeredSlides && options.centeredSlidesStart) {
            GSP.carousel.centerMode(swiper);
          }
        },
        resize: function(swiper) {
          GSP.carousel.calcNavButtonsPosition(swiper);
          GSP.carousel.handlePaginationVisibility(swiper);
        },
        slideChangeTransitionStart: function(swiper) {
          GSP.carousel.animateNextSlider(swiper, "before");
          swiper.el.dispatchEvent(new CustomEvent("gsp:swiper:slideChangeTransitionStart", {
            detail: {
              swiper,
              element: swiper.el
            }
          }));
        },
        slideChangeTransitionEnd: function(swiper) {
          GSP.carousel.animateNextSlider(swiper, "after");
          swiper.el.dispatchEvent(new CustomEvent("gsp:swiper:slideChangeTransitionEnd", {
            detail: {
              swiper,
              element: swiper.el
            }
          }));
        },
        sliderMove: function(swiper) {
          swiper.el.dispatchEvent(new CustomEvent("gsp:swiper:sliderMove", {
            detail: {
              swiper,
              element: swiper.el
            }
          }));
        },
        transitionEnd: function(swiper) {
          GSP.carousel.updatePositionClass(swiper);
          swiper.el.dispatchEvent(new CustomEvent("gsp:swiper:transitionEnd", {
            detail: {
              swiper,
              element: swiper.el
            }
          }));
        },
        update: function(swiper) {
          GSP.carousel.handlePaginationVisibility(swiper);
        },
        realIndexChange: function(swiper) {
          swiper.el.dispatchEvent(new CustomEvent("gsp:swiper:realIndexChange", {
            detail: {
              swiper,
              element: swiper.el
            }
          }));
        },
        destroy: function(swiper) {
          controller.abort();
        }
      };
      let thumbs_id = $this.data("thumbs");
      if (typeof thumbs_id !== "undefined") {
        let swiper_thumb = document.getElementById(thumbs_id);
        if (swiper_thumb) {
          options.thumbs = {
            swiper: GSP.carousel.initSwiper(swiper_thumb, {
              watchSlidesProgress: true
            })
          };
        }
      }
      return new GSP.Swiper.Swiper(swiperEl, options);
    },
    autoplayProgress: function(swiper, controller) {
      if ($2(swiper.el).is(":visible") === false) {
        return;
      }
      const paginationEl = swiper.pagination?.el;
      if (!swiper.params.pagination?.enabled || !paginationEl) {
        return;
      }
      paginationEl.style.setProperty("--gsp-swiper-progress", "100%");
      if (!paginationEl.classList.contains("swiper-pagination-bullets-creative") && !paginationEl.classList.contains("swiper-pagination-timeline-classic")) {
        return;
      }
      if (!swiper.params.autoplay?.enabled) {
        paginationEl.style.setProperty("--gsp-swiper-progress", "50%");
        return;
      }
      paginationEl.style.setProperty(
        "--swiper-autoplay-delay",
        `${swiper.params.autoplay.delay}ms`
      );
      if (!swiper.params.autoplay.pauseOnMouseEnter) {
        return;
      }
      swiper.el.addEventListener(
        "mouseenter",
        () => paginationEl.classList.add("swiper-paused"),
        { signal: controller.signal }
      );
      swiper.el.addEventListener(
        "mouseleave",
        () => paginationEl.classList.remove("swiper-paused"),
        { signal: controller.signal }
      );
    },
    calcNavButtonsPosition: function(swiper) {
      if ($2(swiper.el).is(":visible") === false) {
        return;
      }
      let wrapperEl = GSP.carousel.getWrapperEl(swiper.el);
      if (wrapperEl.classList.contains("gsp-swiper-nav-fix")) {
        return;
      }
      if (wrapperEl.querySelector(".gsp-swiper-navigation-center") || wrapperEl.querySelector(".gsp-swiper-navigation-center-inside")) {
        const firstMedia = swiper.el.querySelector(".gsp-card-media");
        this.calcNavButtonsPositionForCard(wrapperEl, firstMedia);
      }
      if (wrapperEl.classList.contains("navigation-center-for-card")) {
        const card = swiper.el.querySelector(".card");
        this.calcNavButtonsPositionForCard(wrapperEl, card);
      }
    },
    calcNavButtonsPositionForCard: function(wrapEl, card) {
      wrapEl.querySelectorAll(".swiper-button").forEach((el) => {
        if (card && card.clientHeight > 0) {
          el.style.setProperty("--swiper-navigation-top-offset", parseInt(card.clientHeight) / 2 + "px");
        }
      });
    },
    animateNextSlider: function(swiper, process = "before") {
      if ($2(swiper.el).is(":visible") === false) {
        return;
      }
      if (!swiper.el.classList.contains("gsp-swiper-has-animate")) {
        return;
      }
      const $slide = $2(swiper.slides[swiper.activeIndex]);
      if (process === "before") {
        GSP.animation.resetAnimation($slide);
      }
      if (process === "after") {
        GSP.animation.initManual($slide);
      }
    },
    appendSlide: function(swiperSelector, item) {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.appendChild(item);
      const swiperElement = document.querySelector(swiperSelector);
      if (swiperElement && swiperElement.swiper) {
        swiperElement.swiper.appendSlide(slide);
      }
    },
    prependSlide: function(swiperSelector, item) {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.appendChild(item);
      const swiperElement = document.querySelector(swiperSelector);
      if (swiperElement && swiperElement.swiper) {
        swiperElement.swiper.prependSlide(slide);
      }
    },
    removeAllSlides: function(swiperSelector) {
      const swiperElement = document.querySelector(swiperSelector);
      if (swiperElement && swiperElement.swiper) {
        swiperElement.swiper.removeAllSlides();
      }
    },
    removeSlide: function(swiperSelector, slideIndex) {
      const swiperElement = document.querySelector(swiperSelector);
      if (swiperElement && swiperElement.swiper) {
        swiperElement.swiper.removeSlide(slideIndex);
      }
    },
    getWrapperEl: function(swiperEl) {
      let wrapperSelector = swiperEl.dataset.wrapperSelector;
      if (typeof wrapperSelector === "undefined") {
        wrapperSelector = ".gsp-swiper-wrapper";
      }
      return swiperEl.closest(wrapperSelector);
    },
    updatePositionClass: function(swiper) {
      let isBeginning = swiper.isBeginning;
      let isEnd = swiper.isEnd;
      let isActive = isBeginning === false && isEnd === false;
      swiper.el.classList.toggle("gsp-swiper--active", isActive);
      swiper.el.classList.toggle("gsp-swiper--start", isBeginning);
      swiper.el.classList.toggle("gsp-swiper--end", isEnd);
    },
    centerMode: function(swiper) {
      const { slides } = swiper;
      let index = Math.ceil(slides.length / 2) - 1;
      if (swiper.params.loop) {
        swiper.slideToLoop(index, 0, false);
      } else {
        swiper.slideTo(index, 0, false);
      }
    },
    renderPaginationTimeline: function(index, className) {
      return `<span class="${className}">
			<span class="swiper-pagination-timeline-text">${String(index + 1).padStart(2, "0")}.</span>
			<span class="swiper-pagination-timeline-track">
					<span class="swiper-pagination-timeline-fill"></span>
				</span>
</span>`;
    },
    handlePaginationVisibility: function(swiper) {
      const paginationWrapper = swiper.el.closest(".gsp-swiper-wrapper")?.querySelector(".gsp-swiper-controls-pagination:not(.scrollbar)");
      if (!paginationWrapper) {
        return;
      }
      const paginationEl = swiper.pagination?.el;
      paginationWrapper.hidden = !paginationEl || paginationEl.classList.contains("swiper-pagination-lock");
    },
    observeSlider: function(swiper) {
      const autoplay = swiper.params.autoplay?.enabled;
      const animate = swiper.el.querySelector("[data-animate]:not(.animate__animated)");
      if (!autoplay && !animate) {
        return;
      }
      swiper.gspLoadAnimate = false;
      if (autoplay) {
        swiper.autoplay.stop();
      }
      GSP.Motion.inView(swiper.el, (element) => {
        if (autoplay) {
          GSP.carousel.observeAutoplay(element);
        }
        if (animate && !swiper.gspLoadAnimate) {
          GSP.carousel.cancelAnimateBeforeNextSlider(element);
          swiper.gspLoadAnimate = true;
        }
        return () => {
          if (autoplay) {
            const instance = element.swiper;
            if (instance && !instance.destroyed) {
              instance.autoplay.stop();
            }
          }
        };
      });
    },
    cancelAnimateBeforeNextSlider: function(element) {
      const instance = element.swiper;
      if (!instance || instance.destroyed) {
        return;
      }
      if (instance.el.classList.contains("gsp-swiper-has-animate")) {
        return;
      }
      const $slide = $2(instance.el);
      GSP.animation.initManual($slide);
    },
    observeAutoplay: function(element) {
      const instance = element.swiper;
      if (!instance || instance.destroyed) {
        return;
      }
      instance.autoplay.start();
      GSP.carousel.restartPaginationAnimation(instance);
      instance.el.dispatchEvent(new CustomEvent("gsp:swiper:autoplay:restart", {
        detail: {
          swiper: instance,
          element: instance.el
        }
      }));
    },
    restartPaginationAnimation: function(swiper) {
      const paginationEl = swiper.pagination?.el;
      if (!paginationEl) {
        return;
      }
      const activeBullet = paginationEl.querySelector(
        ".swiper-pagination-bullet-active, .swiper-pagination-timeline-active"
      );
      if (!activeBullet) {
        return;
      }
      const activeClass = activeBullet.classList.contains("swiper-pagination-timeline-active") ? "swiper-pagination-timeline-active" : "swiper-pagination-bullet-active";
      activeBullet.classList.remove(activeClass);
      void activeBullet.offsetWidth;
      activeBullet.classList.add(activeClass);
    }
  };
  $2(document).ready(function() {
    GSP.carousel.init();
  });
})(jQuery);
(function($2) {
  GSP.animation = {
    delay: 100,
    manualTimers: [],
    itemQueue: [],
    queueTimer: null,
    $wrapper: null,
    init: function(isManual) {
      var _self = this;
      if (typeof isManual === "undefined") {
        isManual = false;
      }
      var timeOut = 200;
      _self.$wrapper = $2("body");
      _self.itemQueue = [];
      _self.queueTimer = null;
      _self.delay = 100;
      _self.itemQueue["animated_0"] = [];
      _self.$wrapper.find("#main").find(">div,>section").each(function(index) {
        $2(this).attr("data-animated-id", index + 1);
        _self.itemQueue["animated_" + (index + 1)] = [];
      });
      if (isManual) {
        timeOut = 50;
      }
      setTimeout(function() {
        _self.registerAnimation(isManual);
      }, timeOut);
    },
    registerAnimation: function(isManual) {
      var _self = this;
      var selector = $2("[data-animate]:not(.animate__animated):not(.manual-animate)", _self.$wrapper);
      if (typeof isManual === "undefined") {
        isManual = false;
      }
      if (isManual) {
        selector = $2("[data-animate]:not(.animate__animated)", _self.$wrapper);
      }
      GSP.Motion.inView(selector, function(element) {
        const $el = $2(element);
        if ($el.is(":visible")) {
          const $wrap = $el.closest("[data-animated-id]");
          const animated_id = $wrap.length ? $wrap.data("animated-id") : "0";
          _self.itemQueue["animated_" + animated_id].push(element);
          _self.processItemQueue();
        } else {
          $el.addClass(`animate__${$el.data("animate")}`).addClass("animate__animated");
        }
      }, {
        margin: "0px 0px 0px 0px",
        once: true
      });
    },
    processItemQueue: function() {
      var _self = this;
      if (_self.queueTimer) return;
      _self.queueTimer = window.setInterval(function() {
        var has_queue = false;
        for (let animated_id in _self.itemQueue) {
          if (_self.itemQueue[animated_id].length) {
            has_queue = true;
            break;
          }
        }
        if (has_queue) {
          for (let animated_id in _self.itemQueue) {
            var $item = $2(_self.itemQueue[animated_id].shift());
            $item.addClass("animate__" + $item.data("animate")).addClass("animate__animated");
          }
          _self.processItemQueue();
        } else {
          window.clearInterval(_self.queueTimer);
          _self.queueTimer = null;
        }
      }, _self.delay);
    },
    initManual: function($wrap) {
      $wrap = $2($wrap);
      let _self = this;
      let timers = $wrap.data("manualTimers") || [];
      timers.forEach(clearTimeout);
      timers = [];
      let animated = $wrap.find("[data-animate]:not(.animate__animated)");
      if (animated.length > 0) {
        let delay = 0;
        animated.each(function() {
          const $el = $2(this);
          const anim = $el.data("animate");
          const timer = setTimeout(() => {
            $el.addClass("animate__" + anim).addClass("animate__animated");
          }, delay);
          timers.push(timer);
          delay += _self.delay;
        });
      }
      $wrap.data("manualTimers", timers);
    },
    resetAnimation: function($wrap) {
      this.manualTimers.forEach(clearTimeout);
      this.manualTimers = [];
      const animated = $wrap.find(".animate__animated");
      if (animated.length === 0) {
        return;
      }
      animated.each(function() {
        const dataAnimate = $2(this).data("animate");
        if (dataAnimate) {
          $2(this).removeClass("animate__animated animate__" + dataAnimate);
        }
      });
    }
  };
  GSP.imageMotion = {
    delay: 100,
    itemQueue: [],
    queueTimer: null,
    $wrapper: null,
    init: function($wrapper) {
      var _self = this;
      _self.$wrapper = $wrapper ? $2($wrapper) : $2("body");
      _self.itemQueue = [];
      _self.queueTimer = null;
      _self.itemQueue["img_motion_0"] = [];
      _self.$wrapper.find("#main").find(">div,>section").each(function(index) {
        $2(this).attr("data-img-motion-id", index + 1);
        _self.itemQueue["img_motion_" + (index + 1)] = [];
      });
      setTimeout(function() {
        _self.registerAnimation();
      }, 200);
    },
    registerAnimation: function() {
      var _self = this;
      const selector = $2(".gsp-img-motion:not(.load-motion)", _self.$wrapper);
      GSP.Motion.inView(selector, function(element) {
        const $el = $2(element);
        if ($el.is(":visible")) {
          const $wrap = $el.closest("[data-img-motion-id]");
          const animated_id = $wrap.length ? $wrap.data("img-motion-id") : "0";
          _self.itemQueue["img_motion_" + animated_id].push(element);
          _self.processItemQueue();
        } else {
          $el.addClass("load-motion");
        }
      }, {
        margin: "0px 0px 0px 0px",
        once: true
      });
    },
    processItemQueue: function() {
      var _self = this;
      if (_self.queueTimer) return;
      _self.queueTimer = window.setInterval(function() {
        var has_queue = false;
        for (let img_motion_id in _self.itemQueue) {
          if (_self.itemQueue[img_motion_id].length) {
            has_queue = true;
            break;
          }
        }
        if (has_queue) {
          for (let img_motion_id in _self.itemQueue) {
            var $item = $2(_self.itemQueue[img_motion_id].shift());
            $item.addClass("load-motion");
          }
          _self.processItemQueue();
        } else {
          window.clearInterval(_self.queueTimer);
          _self.queueTimer = null;
        }
      }, _self.delay);
    },
    initManual: function($wrap) {
      $wrap = $2($wrap);
      let _self = this;
      let motion = $wrap.find(".gsp-img-motion:not(.load-motion)");
      if (motion.length > 0) {
        let delay = 0;
        motion.each(function() {
          const $el = $2(this);
          setTimeout(() => {
            $el.addClass("load-motion");
          }, delay);
          delay += _self.delay;
        });
      }
    },
    resetAnimation: function($wrap) {
      const animated = $wrap.find(".load-motion");
      if (animated.length === 0) {
        return;
      }
      animated.each(function() {
        $2(this).removeClass("load-motion");
      });
    }
  };
  $2(document).ready(function() {
    GSP.animation.init();
    if (window.gspSetting.image_motion) {
      GSP.imageMotion.init();
      document.addEventListener("shopify:section:load", function(event) {
        GSP.imageMotion.init(event.target);
      });
    }
  });
})(jQuery);
(function($2) {
  GSP.htmlShifting = {
    init: function() {
      this.appendElement();
      this.toggleVisibility();
      this.widthElement();
      this.toggleActive();
    },
    widthElement: function() {
      var wrapper = $2("[data-gsp-attr-width]");
      wrapper.each(function() {
        var $this = $2(this);
        var width = $this.width();
        $this.css("--gsp-width-element", width + "px");
        $2(window).on("resize", function() {
          var width2 = $this.width();
          $this.css("--gsp-width-element", width2 + "px");
        });
      });
    },
    appendElement: function() {
      var wrapper = $2("[data-gsp-append]");
      wrapper.each(function() {
        var $this = $2(this);
        var $selector = $this.data("gsp-append");
        var $target = $2($selector);
        if ($target.length > 0) {
          $target.append($this.prop("outerHTML"));
          $this.remove();
          GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.appendElement);
        }
      });
    },
    toggleActive: function() {
      const wrapName = "[data-gsp-toggle-by-click]";
      const classNameActive = "active";
      if (!$2(wrapName).length) return;
      $2(document).on("click", function(e) {
        const $target = $2(e.target);
        let $wrap = null;
        $target.closest(wrapName).each(function() {
          const $current = $2(this);
          const action = $current.data("gsp-action");
          if (action && $target.closest(action).length) {
            $wrap = $current;
          }
        });
        if (!$wrap) {
          $wrap = $target.closest(wrapName + ":not([data-gsp-action])");
        }
        if ($wrap && $wrap.length) {
          $2(wrapName).not($wrap).removeClass(classNameActive);
          $wrap.addClass(classNameActive);
          return;
        }
        $2(wrapName).removeClass(classNameActive);
      });
    },
    toggleVisibility: function() {
      var wrapper = $2("[data-gsp-toggle-visibility]");
      wrapper.each(function() {
        var $this = $2(this);
        if ($this.hasClass("d-none")) {
          $this.removeClass("d-none");
        }
      });
    }
  };
  $2(document).ready(function() {
    GSP.htmlShifting.init();
  });
})(jQuery);
(function($2) {
  GSP.sticky = {
    init: function() {
      this.setSticky(".gsp-main-product-media > .gsp-main-product-media-inner", ".gsp-main-product-media");
      this.setSticky(".gsp-product-info > .gsp-product-info-wrapper", ".gsp-product-info");
      this.setSticky(".gsp-section-ptwic-image.sticky > .gsp-section-ptwic-image-inner", ".gsp-section-ptwic-image.sticky");
      this.setSticky(".secondary-column.sticky > .gsp-dual-column-inner", ".secondary-column.sticky");
      this.setSticky(".article-main__info .gsp-article-featured.sticky > .gsp-image", ".article-main__info .gsp-article-featured.sticky");
      this.setSticky(".gsp-adv-accordion-tab.sticky > .gsp-adv-accordion-tab-inner", ".gsp-adv-accordion-tab.sticky");
      this.setSticky(".gsp-cart__footer.sticky > .gsp-cart__footer-inner", ".gsp-cart__footer.sticky");
      this.setSticky(".gsp-cart__body.sticky > .gsp-cart__body-inner", ".gsp-cart__body.sticky");
      this.setSticky(".quick-order-list__total.sticky > div", ".quick-order-list__total.sticky");
      this.setSticky(".gsp-sidebar.sidebar-sticky > .gsp-sidebar-inner", ".gsp-sidebar.sidebar-sticky");
      this.setSticky(".image-with-feature__image.sticky > .image-with-feature__image-inner", ".image-with-feature__image.sticky");
      this.setSticky(".image-with-feature__content.sticky > .image-with-feature__content-inner", ".image-with-feature__content.sticky");
      this.setSticky(".gsp-section-header__wrap.sticky > .gsp-section-header-inline-inner", ".gsp-section-header__wrap.sticky");
      this.setSticky(".gsp-fc-item.sticky > .gsp-fc-item-inner", ".gsp-fc-item.sticky");
      this.setSticky(".image-with-accordion__image.sticky > .image-with-accordion__image-inner", ".image-with-accordion__image.sticky");
      this.setSticky(".image-with-accordion__content.sticky > .image-with-accordion__content-inner", ".image-with-accordion__content.sticky");
      this.setSticky(".gsp-section-plwi-image.sticky > .gsp-section-plwi-image-inner", ".gsp-section-plwi-image.sticky");
      this.setSticky(".gsp-has-sticky-wrap .gsp-has-sticky-inner", ".gsp-has-sticky-wrap");
    },
    setSticky: function(selector, stickTo) {
      $2(selector).each(function() {
        let $wrap = $2(this);
        let $container = $wrap.closest(stickTo);
        if (!$container.length) return;
        $container.addClass("gsp-sticky-wrap");
        $wrap.addClass("gsp-sticky");
      });
    },
    checkHeaderActive: function(header) {
      const headerDesktop = header.closest(".gsp-header__desktop");
      const headerMobile = header.closest(".gsp-header__mobile");
      if (headerDesktop.length && headerDesktop.css("display") !== "none") {
        return headerDesktop;
      }
      if (headerMobile.length && headerMobile.css("display") !== "none") {
        return headerMobile;
      }
      return null;
    }
  };
  $2(document).ready(function() {
    GSP.sticky.init();
  });
})(jQuery);
(function($2) {
  GSP.driftZoom = {
    init: function() {
      const _self = this;
      var drift = document.querySelectorAll("[data-drift-option]");
      if (!drift.length) return;
      _self.driftProcess(drift);
      var resizeTimer;
      $2(window).on("resize", function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          _self.driftProcess(drift);
        }, 300);
      });
    },
    driftProcess: function(drift) {
      drift.forEach((zoom) => {
        var hideMobile = zoom.dataset.driftHideMobile === "true";
        if (zoom._driftInstance) {
          zoom._driftInstance.destroy();
          zoom._driftInstance = null;
        }
        if (GSP.core.isDeviceDown("md") && hideMobile) {
          return;
        }
        var paneContainer = zoom.dataset.driftTarget;
        var options_default = {
          paneContainer: paneContainer ? document.querySelector(paneContainer) : false,
          inlinePane: false
        };
        if (paneContainer) {
          options_default.hoverBoundingBox = true;
        }
        let option = zoom.dataset.driftOption;
        if (typeof option === "string") {
          option = option.trim() ? JSON.parse(option) : {};
        }
        option = Object.assign({}, options_default, option);
        zoom._driftInstance = new Drift(zoom, option);
      });
    }
  };
  $2(document).ready(function() {
    GSP.driftZoom.init();
  });
})(jQuery);
(function($2) {
  GSP.scrollToTop = {
    offset: 200,
    element: null,
    scrollHandler: null,
    init() {
      this.element = document.querySelector(".gsp-stt");
      if (!this.element) {
        return;
      }
      this.registerScroll();
      this.update(GSP.scroll.getScroll());
      this.element.addEventListener("click", this.onClick.bind(this));
    },
    registerScroll() {
      if (this.scrollHandler) {
        GSP.scroll.unregister(this.scrollHandler);
      }
      this.scrollHandler = ({ scroll }) => {
        this.update(scroll);
      };
      GSP.scroll.register(this.scrollHandler);
    },
    update(scroll) {
      const progress = GSP.scroll.getMaxScroll() ? scroll / GSP.scroll.getMaxScroll() : 0;
      this.element.classList.toggle(
        "active",
        scroll > this.offset
      );
      this.element.style.setProperty(
        "--gsp-stt-degrees",
        `${progress * 360}deg`
      );
    },
    onClick(event) {
      event.preventDefault();
      GSP.scroll.scrollTo(0, {
        duration: 0
      });
    }
  };
  $2(document).ready(function() {
    GSP.scrollToTop.init();
  });
})(jQuery);
(function($2) {
  GSP.bsScript = {
    init: function() {
      this.tooltips();
    },
    tooltips: function(wrap) {
      if (typeof wrap == "undefined") {
        wrap = document;
      }
      const tooltipTriggerList = wrap.querySelectorAll('[data-bs-toggle="tooltip"]');
      [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));
    },
    hide: function(wrap) {
      if (typeof wrap == "undefined") {
        wrap = document;
      }
      const tooltipTriggerList = wrap.querySelectorAll('[data-bs-toggle="tooltip"]');
      [...tooltipTriggerList].map((tooltipTriggerEl) => {
        const tooltip = bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
        tooltip.hide();
      });
    },
    tooltipsDispose: function(wrap) {
      if (typeof wrap == "undefined") {
        wrap = document;
      }
      const tooltipTriggerList = wrap.querySelectorAll('[data-bs-toggle="tooltip"]');
      [...tooltipTriggerList].map((tooltipTriggerEl) => {
        const tooltip = bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
        tooltip.dispose();
      });
    }
  };
  GSP.bsScript.init();
})(jQuery);
(function($2) {
  const HAS_DROPDOWN_CHILD_SHOW_CLASS = "has-child-dropdown-show";
  $2(document).on("show.bs.dropdown", function(event) {
    if ($2(event.target).closest("#offCanvasNavBar").length === 0) {
      return;
    }
    if (!$2(event.target).hasClass("nav-link")) {
      $2(event.target).addClass(HAS_DROPDOWN_CHILD_SHOW_CLASS);
    }
  });
  $2(document).on("hide.bs.dropdown", function(event) {
    if ($2(event.target).closest("#offCanvasNavBar").length === 0) {
      return;
    }
    if ($2(event.target).parent().find("." + HAS_DROPDOWN_CHILD_SHOW_CLASS).length) {
      event.preventDefault();
    }
    $2("#offCanvasNavBar").find("." + HAS_DROPDOWN_CHILD_SHOW_CLASS).removeClass(HAS_DROPDOWN_CHILD_SHOW_CLASS);
    if ($2(event.target).closest(".nav-item") && !$2(event.target).parent().hasClass("nav-item") && (event.clickEvent === void 0 || event.clickEvent && event.clickEvent.target === event.target)) {
      $2(event.target).addClass(HAS_DROPDOWN_CHILD_SHOW_CLASS);
    }
  });
  GSP.dropdown = {
    init: function() {
      const dropdown = $2("gsp-dropdown");
      const _that = this;
      if (dropdown.length) {
        dropdown.each(function(index) {
          _that.setUpDropdown($2(this));
        });
      }
      document.querySelectorAll(".dropdown").forEach((dropdown2) => {
        const toggle = dropdown2.querySelector('[data-bs-toggle="dropdown"]');
        if (toggle) {
          const instance = bootstrap.Dropdown.getOrCreateInstance(toggle);
          if (window.matchMedia("(hover: hover)").matches) {
            dropdown2.addEventListener("mouseenter", () => {
              instance.show();
              toggle.blur();
            });
            dropdown2.addEventListener("mouseleave", () => {
              instance.hide();
            });
          }
        }
      });
    },
    setUpDropdown(dropdown) {
      const selectDropdown = dropdown.find(".dropdown-select");
      const currentSelect = selectDropdown.val();
      const item = dropdown.find(".dropdown-menu .dropdown-item");
      const submit = dropdown.data("submit") === void 0 ? false : dropdown.data("submit");
      const idForm = dropdown.data("form-id");
      item.each(function() {
        const $this = $2(this);
        $this.on("click", function(event) {
          const value = $2(this).data("value");
          selectDropdown.val(value);
          event.preventDefault();
          if (submit && idForm !== void 0 && currentSelect !== value) {
            $2("#" + idForm).submit();
          }
        });
      });
    }
  };
  $2(document).ready(function() {
    GSP.dropdown.init();
  });
})(jQuery);
(function($2) {
  GSP.gallery = {
    init: function() {
      const $singleGallery = "a.view-single-image";
      const $gallery = "a[data-gallery]";
      const $videoGallery = "a.view-video";
      const _self = this;
      if ($2($singleGallery).length || $2($gallery).length || $2($videoGallery).length) {
        _self.lightGallery($singleGallery, $gallery, $videoGallery);
      }
    },
    lightGallery: function($singleGallery, $gallery, $videoGallery) {
      $2(document).on("click", $singleGallery, function(event) {
        event.preventDefault();
        var $this = $2(this), src = $this.attr("href"), title = $this.attr("title");
        lightGallery(this, {
          plugins: [lgThumbnail, lgZoom],
          dynamic: true,
          hash: false,
          dynamicEl: [
            {
              src,
              downloadUrl: src,
              thumb: src,
              subHtml: title
            }
          ],
          index: 0
        }).openGallery();
      });
      $2(document).on("click", $gallery, function(event) {
        event.preventDefault();
        var $this = $2(this), galleryId = $this.data("gallery"), _data = [], currentIndex = 0, current_src = $2(this).attr("href");
        $2('[data-gallery="' + galleryId + '"]').each(function(index) {
          var src = $2(this).attr("href"), thumb = $2(this).data("thumb-src"), subHtml = $2(this).attr("title");
          if (thumb === void 0) {
            thumb = src;
          }
          if (src === current_src) {
            currentIndex = index;
          }
          if (typeof subHtml == "undefined") {
            subHtml = "";
          }
          _data.push({
            "src": src,
            "downloadUrl": src,
            "thumb": thumb,
            "subHtml": subHtml
          });
        });
        lightGallery(this, {
          plugins: [lgThumbnail, lgZoom],
          dynamic: true,
          hash: false,
          galleryId,
          dynamicEl: _data,
          thumbWidth: 80,
          index: currentIndex
        }).openGallery();
      });
      $2(document).on("click", $videoGallery, function(event) {
        event.preventDefault();
        var src = $2(this).attr("href");
        lightGallery(this, {
          dynamic: true,
          plugins: [lgThumbnail, lgZoom, lgVideo, lgVimeoThumbnail],
          dynamicEl: [{
            "src": src,
            "thumb": "",
            "subHtml": ""
          }]
        }).openGallery();
      });
    }
  };
  $2(document).ready(function() {
    GSP.gallery.init();
  });
})(jQuery);
(function() {
  window.GSP = window.GSP || {};
  GSP.isotopeFilter = {
    options_default: {},
    init: function() {
      const isotopeEls = document.querySelectorAll("[data-options-isotope]");
      const filterEls = document.querySelectorAll("[data-isotope-filter]");
      this.designMode();
      if (isotopeEls.length || filterEls.length) {
        this.setupIsotope(isotopeEls);
        this.setupIsotopeFilter(filterEls);
      }
    },
    designMode: function() {
      document.addEventListener("shopify:section:load", function(event) {
        const sectionEl = event.target;
        const isotopeEls = sectionEl.querySelectorAll("[data-options-isotope]");
        if (isotopeEls.length) {
          GSP.isotopeFilter.setupIsotope(isotopeEls);
        }
      });
    },
    setupIsotope: function(elements) {
      const _self = this;
      elements.forEach((el) => {
        let options = el.dataset.optionsIsotope;
        try {
          options = options ? JSON.parse(options) : {};
        } catch (e) {
          options = {};
        }
        options = Object.assign({}, _self.options_default, options);
        new Isotope(el, options);
      });
    },
    setupIsotopeFilter: function(filters) {
      filters.forEach((el) => {
        el.addEventListener("click", function() {
          const targetSelector = el.dataset.isotopeTarget;
          const filterValue = el.dataset.isotopeFilter;
          const grid = document.querySelector(targetSelector);
          if (!grid) return;
          const iso = Isotope.data(grid);
          if (!iso) return;
          iso.arrange({ filter: filterValue });
          const parent = el.closest("[data-isotope-filter-parent]");
          if (parent) {
            parent.querySelectorAll("[data-isotope-filter]").forEach((item) => {
              item.classList.remove("active");
            });
          }
          el.classList.add("active");
        });
      });
    }
  };
  document.addEventListener("DOMContentLoaded", function() {
    GSP.isotopeFilter.init();
  });
})();
(function($2) {
  GSP.counter = {
    init: function() {
      const $counter = $2(".gsp-counter");
      const _self = this;
      if ($counter.length < 1) {
        return;
      }
      _self.processCounter($counter);
    },
    processCounter: function($counter) {
      $counter.each(function() {
        GSP.Motion.inView(this, (element) => {
          const $this = $2(element);
          const el = $this.find(".gsp-counter-number-end");
          const number_start = $this.data("start") ?? 0;
          const number_end = $this.data("end") ?? 100;
          const separator = $this.data("separator") ?? ",";
          const decimal = $this.data("decimal") ?? ".";
          const decimals = $this.data("decimals") ?? 0;
          const duration = $this.data("duration") ?? 2;
          const options = {
            useEasing: true,
            useGrouping: separator !== "",
            duration,
            separator,
            decimal,
            decimalPlaces: decimals,
            startVal: number_start
          };
          var counterup = new CountUp(el[0], number_end, options);
          counterup.start();
        }, {
          margin: "0px 0px 0px 0px",
          once: true
        });
      });
    }
  };
  $2(document).ready(function() {
    GSP.counter.init();
  });
})(jQuery);
(function($2) {
  GSP.preventTransitionResize = {
    resizeTimer: null,
    beforeWindowWidth: 0,
    init: function() {
      this.beforeWindowWidth = window.outerWidth;
      this.resize();
    },
    resize: function() {
      $2(window).resize(function() {
        let currentWidth = window.outerWidth;
        if (currentWidth === GSP.preventTransitionResize.beforeWindowWidth) {
          return;
        }
        GSP.preventTransitionResize.beforeWindowWidth = currentWidth;
        clearTimeout(GSP.preventTransitionResize.resizeTimer);
        $2("body").addClass("disable-transition-all");
        $2(document).trigger("after_prevent_transition_resize");
        GSP.preventTransitionResize.resizeTimer = setTimeout(function() {
          $2("body").removeClass("disable-transition-all");
        }, 400);
      });
    }
  };
  $2(document).ready(function() {
    GSP.preventTransitionResize.init();
  });
})(jQuery);
(function($2) {
  GSP.tabs = {
    init: function() {
      this.tab_accordion();
      this.tab_dropdown();
      this.refresh_slider();
      this.refresh_role_slider();
      document.addEventListener("shopify:block:select", function(event) {
        const tab_pane = event.target.closest(".tab-pane");
        const tab = tab_pane && tab_pane.id ? document.querySelector('[data-bs-target="#' + tab_pane.id + '"]') : false;
        if (tab === false) {
          return;
        }
        const tabInstance = bootstrap.Tab.getInstance(tab);
        if (tabInstance) {
          tabInstance.show();
        } else {
          new bootstrap.Tab(tab).show();
        }
      });
    },
    tab_accordion: function() {
      $2('[data-bs-toggle="tab-accordion"] [data-bs-toggle="tab"]').on("shown.bs.tab", function(event) {
        var $currentTab = $2(event.target), $previousTab = $2(event.relatedTarget), $wrapper = $2(this).closest('[data-bs-toggle="tab-accordion"]'), $currentPanel = $wrapper.find($currentTab.data("bs-target")), $previousPanel = $wrapper.find($previousTab.data("bs-target"));
        $currentPanel.find(".collapse").addClass("show");
        $previousPanel.find(".collapse").removeClass("show");
        $currentPanel.find('[data-bs-toggle="collapse"]').removeClass("collapsed");
        $previousPanel.find('[data-bs-toggle="collapse"]').addClass("collapsed");
      });
      $2('[data-bs-toggle="tab-accordion"] .collapse').on("shown.bs.collapse", function(event) {
        var $currentPane = $2(event.target).closest(".tab-pane");
        if ($currentPane.length) {
          var $currentTab = $2('[data-bs-target="#' + $currentPane.attr("id") + '"]');
          if ($currentTab.length) {
            var $parentTabs = $currentTab.closest(".nav-tabs");
            if ($parentTabs.length) {
              $parentTabs.find('[data-bs-toggle="tab"]').removeClass("active");
              var $tabContent = $parentTabs.next(".tab-content");
              if ($tabContent.length) {
                $tabContent.find(".tab-pane").removeClass("show active");
              }
              $currentPane.addClass("show active");
              $currentTab.addClass("active");
            }
          }
        }
      });
    },
    tab_dropdown: function() {
      $2('[data-bs-toggle="tab-dropdown"] [data-bs-toggle="tab"]').on("shown.bs.tab", function(event) {
        var $currentTab = $2(event.target);
        $2(event.relatedTarget);
        var $wrapper = $2(this).closest('[data-bs-toggle="tab-dropdown"]'), target = $currentTab.data("bs-target");
        $wrapper.find('[data-bs-toggle="tab"]').removeClass("active");
        $wrapper.find('[data-bs-target="' + target + '"]').addClass("active");
        $wrapper.find('[data-bs-toggle="dropdown"]').text($currentTab.text());
      });
    },
    refresh_slider: function() {
      $2('[data-bs-toggle="tab"]').on("shown.bs.tab", function(event) {
        var $navLink = $2(event.target), $tabContent = $2($navLink.data("bs-target"));
        const sliderElements = $tabContent.find(".gsp-swiper");
        if (sliderElements.length > 0) {
          const sliderElement = sliderElements[0];
          if (sliderElement && sliderElement.swiper) {
            sliderElement.swiper.update();
          }
        }
        var hasAnimate = $tabContent.find("[data-animate]");
        $tabContent.siblings().each(function() {
          GSP.animation.resetAnimation($2(this));
        });
        if (hasAnimate.length) {
          GSP.animation.initManual($tabContent);
        }
      });
    },
    refresh_role_slider: function() {
      document.querySelectorAll('button[role="tab"]').forEach((tabBtn) => {
        const slide = tabBtn.closest(".swiper-slide");
        if (!slide) return;
        slide.removeAttribute("role");
        slide.removeAttribute("aria-label");
        const wrapper = slide.closest(".swiper-wrapper");
        if (wrapper && wrapper.hasAttribute("aria-live")) {
          wrapper.removeAttribute("aria-live");
        }
        const swiperContainer = slide.closest(".swiper");
        if (swiperContainer) {
          const notifications = swiperContainer.querySelectorAll(".swiper-notification");
          notifications.forEach((span) => {
            span.removeAttribute("aria-live");
            span.removeAttribute("aria-atomic");
          });
        }
      });
    }
  };
  $2(document).ready(function() {
    GSP.tabs.init();
  });
})(jQuery);
(function($2) {
  GSP.logoScroll = {
    items: [],
    scrollHandler: null,
    init: function() {
      this.items.length = 0;
      this.collect();
      this.register();
      this.designMode();
      this.resizeHandler = () => {
        this.collect();
        this.update(GSP.scroll.getScroll());
      };
      GSP.resize.register(
        this.resizeHandler
      );
      document.addEventListener("shopify:section:load", (event) => {
        if (event.target.classList.contains("shopify-section-group-header-group")) {
          this.resizeHandler();
        }
      });
    },
    collect($wrapper = $2(document)) {
      this.items.length = 0;
      const self = this;
      const sectionHeader = document.querySelector(".shopify-section__header");
      const hasSticky = sectionHeader && sectionHeader.classList.contains("position-sticky");
      if (hasSticky) {
        sectionHeader.classList.remove("position-sticky");
      }
      $wrapper.find(".gsp-logo-scroll .gsp-site-logo").each(function() {
        const $logo = $2(this);
        if (!$logo.is(":visible")) {
          return;
        }
        const navbarBrand = this.closest(".gsp-header-inner");
        const headerLogo = navbarBrand.querySelector(".gsp-site-logo__inner").closest(".gsp-site-logo");
        const logoScrollWrap = this.closest(".gsp-logo-scroll-wrap");
        const heroLogo = this.querySelector(".gsp-site-logo__inner").closest(".gsp-site-logo");
        let startX = 0, startY = 0;
        let targetX = 0, targetY = 0;
        let scaleX = 1, scaleY = 1;
        heroLogo.style.transform = "none";
        const heroRect = heroLogo.getBoundingClientRect();
        const headerRect = headerLogo.getBoundingClientRect();
        const currentScrollY = GSP.scroll.getScroll();
        startX = heroRect.left;
        startY = heroRect.top + currentScrollY;
        targetX = headerRect.left;
        targetY = headerRect.top + currentScrollY;
        scaleX = headerRect.width / heroRect.width;
        scaleY = headerRect.height / heroRect.height;
        const logoScrollWrapTop = logoScrollWrap.getBoundingClientRect().top + currentScrollY;
        let animationDistance = logoScrollWrap.getBoundingClientRect().bottom + currentScrollY;
        if (targetY > logoScrollWrapTop) {
          animationDistance = targetY - logoScrollWrapTop;
        }
        animationDistance = animationDistance > 100 ? animationDistance - 10 : animationDistance;
        animationDistance = animationDistance > 0 ? animationDistance : 1;
        self.items.push({
          element: this,
          heroLogo,
          headerLogo,
          logoScrollWrap,
          animationDistance,
          startX,
          startY,
          targetX,
          targetY,
          scaleX,
          scaleY
        });
      });
      if (hasSticky) {
        sectionHeader.classList.add("position-sticky");
      }
    },
    register() {
      if (this.scrollHandler) {
        GSP.scroll.unregister(this.scrollHandler);
      }
      this.scrollHandler = ({ scroll }) => {
        this.update(scroll);
      };
      GSP.scroll.register(this.scrollHandler);
      this.update(GSP.scroll.getScroll());
    },
    update(scroll) {
      if (!this.items.length) {
        return;
      }
      this.items.forEach((item) => {
        const { heroLogo, animationDistance, startX, startY, targetX, targetY, scaleY } = item;
        if (typeof item.progressBefore === "undefined") {
          item.progressBefore = -1;
        }
        let progress = scroll / animationDistance;
        progress = Math.max(0, Math.min(1, progress));
        if (item.progressBefore !== progress) {
          const deltaX = (targetX - startX) * progress;
          const deltaY = (targetY - startY) * progress;
          const currentScaleY = 1 + (scaleY - 1) * progress;
          heroLogo.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0px) scale(${currentScaleY})`;
          item.progressBefore = progress;
        }
      });
    },
    destroy($wrapper = $2(document)) {
      const elements = $wrapper.find(".gsp-logo-scroll .gsp-site-logo");
      this.items = this.items.filter((item) => {
        return !elements.toArray().includes(item.element);
      });
    },
    designMode() {
      if (!Shopify.designMode) {
        return;
      }
      document.addEventListener(
        "shopify:section:load",
        (event) => {
          if (event.target.classList.contains("shopify-section-group-header-group")) {
            this.collect($2(event.target));
            this.update(GSP.scroll.getScroll());
          }
        }
      );
      document.addEventListener(
        "shopify:section:unload",
        (event) => {
          this.destroy($2(event.target));
        }
      );
    }
  };
  GSP.headerSticky = {
    submenuHoverBound: false,
    items: [],
    init: function() {
      this.collect();
      this.layout();
      this.registerScroll();
      this.processSticky(GSP.scroll.getScroll());
      this.megaMenuHover();
      this.submenuMenuHover();
      this.activeMenuParentMenu();
      this.resizeHandler = () => {
        this.refresh();
        this.calculateMixBlendModeLogoPosition();
      };
      GSP.resize.register(this.resizeHandler);
      document.addEventListener("shopify:section:load", (event) => {
        if (event.target.classList.contains("shopify-section-group-header-group")) {
          this.resizeHandler();
          document.body.classList.remove("has-mix-blend-mode-logo");
          this.processMixBlendModeLogo();
        }
      });
      document.addEventListener("shopify:section:unload", (event) => {
        if (event.target.classList.contains("shopify-section-group-header-group")) {
          setTimeout(() => {
            this.processMixBlendModeLogo();
          }, 100);
        }
      });
      document.addEventListener("overlap-section/init", () => {
        this.processMenuDropdown();
      });
      this.processMixBlendModeLogo();
      const processResizeHandler = () => {
        const sectionOverlap = document.querySelector("#main > .shopify-section:first-child .gsp-header-overlap");
        if (sectionOverlap) {
          const heightSection = sectionOverlap.clientHeight;
          document.documentElement.style.setProperty("--height-section-hero", `${heightSection}px`);
        }
        this.calculateMixBlendModeLogoPosition();
      };
      window.addEventListener("resize", () => {
        const duration = 300;
        const startTime = performance.now();
        function updateLoop(currentTime) {
          const elapsed = currentTime - startTime;
          processResizeHandler();
          if (elapsed < duration) {
            requestAnimationFrame(updateLoop);
          } else {
            processResizeHandler();
          }
        }
        requestAnimationFrame(updateLoop);
      });
    },
    collect: function() {
      const self = this;
      self.items.length = 0;
      const stickyAreas = document.querySelectorAll(
        ".header-sticky .sticky-area"
      );
      stickyAreas.forEach((sticky) => {
        if (sticky.offsetParent === null) {
          return;
        }
        const headerWrap = sticky.closest("header");
        const section = sticky.closest(".shopify-section");
        const headerDevice = sticky.closest(".gsp-header__device");
        const logoScrollWrap = sticky.querySelector(".gsp-logo-scroll-wrap");
        const firstSectionWrap = document.querySelector("#main > .shopify-section:first-child .gsp-section__wrap");
        const firstSectionWrapMarginTop = firstSectionWrap ? parseFloat(window.getComputedStyle(firstSectionWrap).marginTop) : 0;
        this.items.push({
          sticky,
          headerWrap,
          section,
          headerDevice,
          logoScrollWrap,
          firstSectionWrapMarginTop,
          isSticky: false,
          stickyTop: 0,
          height: 0
        });
      });
    },
    layout: function() {
      if (!this.items.length) {
        return;
      }
      const item = this.items[0];
      item.section.classList.remove("position-sticky");
      item.height = item.headerWrap.offsetHeight;
      document.documentElement.style.setProperty(
        "--header-height",
        `${item.height}px`
      );
      document.documentElement.style.setProperty(
        "--first-item-margin-top",
        `${item.firstSectionWrapMarginTop}px`
      );
      if (item.section) {
        document.documentElement.style.setProperty(
          "--header-section-top",
          `${item.section.offsetTop}px`
        );
      }
      if (item.logoScrollWrap) {
        document.documentElement.style.setProperty(
          "--logo-scroll-height",
          `${item.logoScrollWrap.clientHeight}px`
        );
      }
      item.stickyTop = item.section.offsetTop;
      item.section.classList.add("position-sticky");
      this.htmlEl = document.querySelector("html");
      const sectionOverlap = document.querySelector("#main > .shopify-section:first-child .gsp-header-overlap");
      this.sectionOverlap = null;
      if (sectionOverlap) {
        this.sectionOverlap = sectionOverlap;
        const heightSection = this.sectionOverlap.clientHeight;
        this.htmlEl.style.setProperty("--height-section-hero", `${heightSection}px`);
      }
      const headerHeight = parseFloat(this.htmlEl.style.getPropertyValue("--header-height"));
      const heroHeight = parseFloat(this.htmlEl.style.getPropertyValue("--height-section-hero"));
      const headerSectionTop = parseFloat(this.htmlEl.style.getPropertyValue("--header-section-top"));
      item.headerHeight = headerHeight;
      item.heroHeight = heroHeight;
      item.headerSectionTop = headerSectionTop;
    },
    registerScroll: function() {
      if (this.scrollHandler) {
        GSP.scroll.unregister(this.scrollHandler);
      }
      this.scrollHandler = ({ scroll }) => {
        this.processSticky(scroll);
      };
      GSP.scroll.register(this.scrollHandler);
    },
    processMenuDropdown: function(item) {
      const deltaY = item.sticky.getBoundingClientRect().top;
      const window_height = window.innerHeight;
      if (deltaY > window_height / 2) {
        item.headerWrap.classList.add("menu-direction-up");
      } else {
        item.headerWrap.classList.remove("menu-direction-up");
      }
    },
    processSticky: function(scrollTop) {
      if (!this.items.length) {
        return;
      }
      const item = this.items[0];
      const stickyDistance = item.logoScrollWrap ? item.logoScrollWrap.offsetTop + item.logoScrollWrap.clientHeight : item.headerWrap.clientHeight;
      let isSticky = scrollTop > stickyDistance;
      const hasHeaderOverlapBottom = this.sectionOverlap !== null && this.sectionOverlap.classList.contains("gsp-header-overlap-bottom");
      const hasHeaderOverlap = this.sectionOverlap !== null && this.sectionOverlap.classList.contains("gsp-header-overlap");
      if (hasHeaderOverlapBottom) {
        this.processMenuDropdown(item);
        isSticky = item.headerDevice.getBoundingClientRect().top <= 0;
      }
      if (isSticky) {
        if (!item.isSticky) {
          item.isSticky = true;
          this.calculateMixBlendModeLogoPosition();
          document.body.classList.add("is-sticky");
          item.headerWrap.classList.add("is-sticky");
          if (!item.headerWrap.classList.contains("menu-style__button") || !GSP.config.device.isDesktop()) {
            item.headerWrap.classList.add("sticky");
            item.headerWrap.classList.add("has-shadow");
          } else {
            if (!hasHeaderOverlap) {
              item.headerWrap.classList.add("has-shadow");
            }
          }
        }
      } else {
        if (item.isSticky) {
          item.isSticky = false;
          this.calculateMixBlendModeLogoPosition();
          document.body.classList.remove("is-sticky");
          item.headerWrap.classList.remove("is-sticky");
          if (!item.headerWrap.classList.contains("menu-style__button") || !GSP.config.device.isDesktop()) {
            item.headerWrap.classList.remove("sticky");
            item.headerWrap.classList.remove("has-shadow");
          } else {
            if (!hasHeaderOverlap) {
              item.headerWrap.classList.remove("has-shadow");
            }
          }
        }
      }
    },
    refresh: function() {
      this.collect();
      this.layout();
      this.processSticky(GSP.scroll.getScroll());
    },
    megaMenuHover: function() {
      const self = this;
      $2(document).off(".gspMegaMenu").on("mouseenter.gspMegaMenu", ".gsp-menu-item__mega", function() {
        self.megaMenuMouseenter(this);
      }).on("mouseleave.gspMegaMenu", ".gsp-menu-item__mega", function() {
        self.megaMenuMouseleave(this);
      }).on("focusin.gspMegaMenu", ".gsp-menu-item__mega", function() {
        self.megaMenuMouseenter(this);
      }).on("focusout.gspMegaMenu", ".gsp-menu-item__mega", function(e) {
        if (!this.contains(e.relatedTarget)) {
          self.megaMenuMouseleave(this);
        }
      });
      if (!Shopify.designMode) {
        return;
      }
      document.addEventListener("shopify:block:select", (event) => {
        this.toggleMegaMenuBlock(event.detail.blockId, true);
      });
      document.addEventListener("shopify:block:deselect", (event) => {
        this.toggleMegaMenuBlock(event.detail.blockId, false);
      });
    },
    megaMenuMouseenter: function(itemMenu) {
      const $itemMenu = $2(itemMenu);
      const headerDesktop = itemMenu.closest(".gsp-header__desktop");
      if (headerDesktop && !headerDesktop.classList.contains("show-overlay")) {
        headerDesktop.classList.add("show-overlay");
        document.querySelector("body").classList.add("is-show-dropdown-menu");
      }
      this.showStickyHeader();
      GSP.animation.initManual($itemMenu);
    },
    megaMenuMouseleave: function(itemMenu) {
      const $itemMenu = $2(itemMenu);
      const headerDesktop = itemMenu.closest(".gsp-header__desktop");
      if (headerDesktop && headerDesktop.classList.contains("show-overlay")) {
        headerDesktop.classList.remove("show-overlay");
        document.querySelector("body").classList.remove("is-show-dropdown-menu");
      }
      this.hideStickyHeader();
      GSP.animation.resetAnimation($itemMenu);
    },
    submenuMouseenter: function(itemMenu) {
      const headerDesktop = itemMenu.closest(".gsp-header__desktop");
      if (headerDesktop) {
        const wrapAddon = $2(headerDesktop).find(".gsp-header-addons-item__search.layout-form");
        if (wrapAddon.length && wrapAddon.hasClass("focus")) {
          GSP.headerAddonSearch.removeFocusAddon(wrapAddon);
        }
      }
      if (headerDesktop && !headerDesktop.classList.contains("show-overlay")) {
        headerDesktop.classList.add("show-overlay");
        document.querySelector("body").classList.add("is-show-dropdown-menu");
      }
      this.showStickyHeader();
    },
    submenuMouseleave: function(itemMenu) {
      const $itemMenu = $2(itemMenu);
      const headerDesktop = itemMenu.closest(".gsp-header__desktop");
      if (headerDesktop && headerDesktop.classList.contains("show-overlay")) {
        headerDesktop.classList.remove("show-overlay");
        document.querySelector("body").classList.remove("is-show-dropdown-menu");
      }
      this.hideStickyHeader();
      $itemMenu.find("a:focus,.btn:focus, input:focus").blur();
    },
    toggleMegaMenuBlock(blockId, active) {
      const blocks = document.querySelectorAll(`.gsp-megamenu-block-${blockId}`);
      if (!blocks.length) {
        return;
      }
      blocks.forEach((block) => {
        const menu = block.closest(".gsp-menu-item");
        if (!menu) {
          return;
        }
        if (active) {
          if (menu.classList.contains("active-mega")) {
            return;
          }
          menu.classList.add("active-mega");
          this.submenuMouseenter(menu);
        } else {
          if (!menu.classList.contains("active-mega")) {
            return;
          }
          menu.classList.remove("active-mega");
          this.submenuMouseleave(menu);
        }
      });
    },
    submenuMenuHover() {
      if (this.submenuHoverBound) {
        return;
      }
      this.submenuHoverBound = true;
      const self = this;
      $2(document).on(
        "mouseenter",
        ".gsp-header__desktop .gsp-menu-item.gsp-menu-has-children",
        function() {
          self.submenuMouseenter(this);
        }
      ).on(
        "mouseleave",
        ".gsp-header__desktop .gsp-menu-item.gsp-menu-has-children",
        function() {
          self.submenuMouseleave(this);
        }
      ).on(
        "focusin",
        ".gsp-header__desktop .gsp-menu-item.gsp-menu-has-children",
        function() {
          self.submenuMouseenter(this);
        }
      ).on(
        "focusout",
        ".gsp-header__desktop .gsp-menu-item.gsp-menu-has-children",
        function(e) {
          if (!this.contains(e.relatedTarget)) {
            self.submenuMouseleave(this);
          }
        }
      );
    },
    showStickyHeader() {
      if (!this.items.length) {
        return;
      }
      const item = this.items[0];
      if (!item.isSticky) {
        item.headerWrap.classList.add("is-sticky");
        if (!item.headerWrap.classList.contains("menu-style__button") || !GSP.config.device.isDesktop()) {
          item.headerWrap.classList.add("sticky");
        }
      }
    },
    hideStickyHeader() {
      if (!this.items.length) {
        return;
      }
      const item = this.items[0];
      if (!item.isSticky) {
        item.headerWrap.classList.remove("is-sticky");
        if (!item.headerWrap.classList.contains("menu-style__button") || !GSP.config.device.isDesktop()) {
          item.headerWrap.classList.remove("sticky");
        }
      }
    },
    activeMenuParentMenu: function() {
      $2(".gsp-submenu-link.gsp-menu-link-active").each(function() {
        const submenuParent = $2(this).closest(".gsp-submenu").closest(".gsp-submenu-item").children(".gsp-submenu-link");
        const menuParent = $2(this).closest(".gsp-menu-item").children(".gsp-menu-link");
        if (submenuParent.length && !submenuParent.hasClass("gsp-menu-link-active")) {
          submenuParent.addClass("gsp-menu-link-active");
        }
        if (menuParent.length && !menuParent.hasClass("gsp-menu-link-active")) {
          menuParent.addClass("gsp-menu-link-active");
        }
      });
    },
    processMixBlendModeLogo: function() {
      if (document.querySelector(".header.menu-style__button") == null || document.querySelector("#main > .shopify-section:first-child .gsp-header-overlap") === null || document.querySelector(".header.is-mix-blend-mode-logo") === null) {
        document.body.classList.remove("has-mix-blend-mode-logo");
        const mixModeLogoWrap = document.querySelector(".gsp-mix-mode-logo__wrap");
        if (mixModeLogoWrap) {
          mixModeLogoWrap.remove();
        }
        this.logoDesktop = null;
        this.logoMobile = null;
        this.mixBlendModeLogoDesktop = null;
        this.mixBlendModeLogoMobile = null;
      } else {
        if (document.body.classList.contains("has-mix-blend-mode-logo")) {
          return;
        }
        document.body.classList.add("has-mix-blend-mode-logo");
        const pageMain = document.querySelector("#main");
        const mixModeLogoWrapOld = document.querySelector(".gsp-mix-mode-logo__wrap");
        if (mixModeLogoWrapOld) {
          mixModeLogoWrapOld.remove();
        }
        const mixModeLogoWrap = document.createElement("div");
        mixModeLogoWrap.classList.add("gsp-mix-mode-logo__wrap");
        pageMain.appendChild(mixModeLogoWrap);
        document.querySelectorAll(".gsp-header-inner .gsp-site-logo:not(.logo-scroll)").forEach((logo) => {
          if (logo.closest(".gsp-header__desktop")) {
            this.logoDesktop = logo;
            this.mixBlendModeLogoDesktop = logo.cloneNode(true);
            this.mixBlendModeLogoDesktop.classList.add("is-desktop-logo");
            mixModeLogoWrap.appendChild(this.mixBlendModeLogoDesktop);
          } else {
            this.logoMobile = logo;
            this.mixBlendModeLogoMobile = logo.cloneNode(true);
            this.mixBlendModeLogoMobile.classList.add("is-mobile-logo");
            mixModeLogoWrap.appendChild(this.mixBlendModeLogoMobile);
          }
        });
        this.calculateMixBlendModeLogoPosition();
      }
    },
    calculateMixBlendModeLogoPosition() {
      if (!this.mixBlendModeLogoMobile || !this.mixBlendModeLogoDesktop) return;
      if (GSP.config.device.isTablet() || GSP.config.device.isMobile()) {
        if (this.logoMobile) {
          const logoMobileClientRect = this.logoMobile.getBoundingClientRect();
          this.mixBlendModeLogoMobile.style.top = `${logoMobileClientRect.top}px`;
          this.mixBlendModeLogoMobile.style.left = `${logoMobileClientRect.left}px`;
          this.mixBlendModeLogoMobile.style.height = `${logoMobileClientRect.height}px`;
          this.mixBlendModeLogoMobile.style.opacity = 1;
          this.mixBlendModeLogoDesktop.style.opacity = 0;
        }
      } else {
        if (this.logoDesktop) {
          const logoDesktopClientRect = this.logoDesktop.getBoundingClientRect();
          this.mixBlendModeLogoDesktop.style.top = `${logoDesktopClientRect.top}px`;
          this.mixBlendModeLogoDesktop.style.left = `${logoDesktopClientRect.left}px`;
          this.mixBlendModeLogoDesktop.style.height = `${logoDesktopClientRect.height}px`;
          this.mixBlendModeLogoDesktop.style.opacity = 1;
          this.mixBlendModeLogoMobile.style.opacity = 0;
        }
      }
    }
  };
  GSP.header = {
    init: function() {
      document.querySelectorAll(".gsp-main-menu").forEach((el) => {
        let $items = $2(el).find("> .gsp-menu-item:not(.gsp-menu-item__more)");
        $items.each(function() {
          $2(this).data("original-class", this.className);
        });
        $items.find("> a").each(function() {
          $2(this).data("original-class", this.className);
        });
      });
      this.processMenuItems();
      document.addEventListener("shopify:section:load", function(event) {
        const sectionEl = event.target;
        if (sectionEl.classList.contains("shopify-section-group-header-group")) {
          GSP.header.processMenuItems();
        }
      });
      this.resizeHandler = (event) => {
        const { widthChanged } = event;
        if (widthChanged) {
          this.processMenuItems();
        }
      };
      GSP.resize.register(this.resizeHandler);
    },
    processMenuItems: function(event) {
      $2(".gsp-main-menu").parents("[data-overflow-menu]").addClass("overflow-hidden");
      document.querySelectorAll(".gsp-main-menu").forEach((el) => {
        let $mainMenu = $2(el);
        let $parentMainMenu = $mainMenu.closest("[data-overflow-menu]");
        let $moreMenuItem = $mainMenu.find(".gsp-menu-item__more");
        let $subMenuMoreMenuItem = $moreMenuItem.find(">.gsp-submenu");
        let subMenuClass = "gsp-submenu-item gsp-menu-has-children position-relative py-6px px-5";
        let subMenuItemClass = "gsp-submenu-link gsp-submenu-link__hover gsp-reversed-link gsp-reversed-link__text text-decoration-none";
        $parentMainMenu.addClass("overflow-hidden");
        $moreMenuItem.addClass("d-none");
        $subMenuMoreMenuItem.find("> .gsp-submenu-item").each(function() {
          let $this = $2(this);
          let $aLink = $this.find("> a");
          $aLink.attr("class", $aLink.data("original-class"));
          $aLink.find("> span").attr("class", "");
          $this.attr("class", $this.data("original-class")).insertBefore($moreMenuItem);
          $this.find("> .gsp-submenu").addClass("start-0");
        });
        let parentMainMenuRight = Math.floor($parentMainMenu.innerWidth() + $parentMainMenu.offset().left);
        let hasMoreItem = false;
        let $items = $mainMenu.find("> .gsp-menu-item:not(.gsp-menu-item__more)");
        for (let i = $items.length - 1; i > 0; i--) {
          let $item = $2($items[i]);
          let itemLastRight = hasMoreItem ? $moreMenuItem.innerWidth() + $moreMenuItem.offset().left : $item.innerWidth() + $item.offset().left;
          if (Math.floor(itemLastRight) <= parentMainMenuRight + 15) {
            break;
          }
          hasMoreItem = true;
          $item.attr("class", subMenuClass);
          $item.find("> a").attr("class", subMenuItemClass).find("> span").addClass("gsp-reversed-link__text");
          $moreMenuItem.removeClass("d-none");
          $item.find("> .gsp-submenu").removeClass("start-0");
          $item.prependTo($subMenuMoreMenuItem);
        }
      });
      $2(".gsp-main-menu").parents("[data-overflow-menu]").removeClass("overflow-hidden");
    }
  };
  GSP.headerAddonSearch = {
    init: function() {
      this.headerAddonSearch();
    },
    headerAddonSearch: function() {
      const wrap = $2(".gsp-header-addons-item__search.layout-form");
      const _self = this;
      const body = $2("body");
      if (wrap.length) {
        const form = wrap.find(".gsp-search-form");
        const btnSubmit = form.find('[type="submit"]');
        const input = form.find(".search-input");
        btnSubmit.on("click", function(e) {
          e.preventDefault();
          const value = input.val().trim();
          if (value) {
            form.submit();
          } else {
            input.focus();
          }
        });
        if (wrap.hasClass("layout-form")) {
          input.on("focus", function() {
            wrap.addClass("focus");
            if (!body.hasClass("search-offcanvas-open")) {
              body.addClass("search-offcanvas-open");
            }
            const $headerDesktop = wrap.closest(".gsp-header__desktop");
            if ($headerDesktop.length) {
              $headerDesktop.addClass("search-offcanvas-active");
              $headerDesktop.addClass("show-overlay");
              document.querySelector("body").classList.add("is-show-dropdown-menu");
              GSP.headerSticky.showStickyHeader();
            }
          });
        }
        wrap.find(".btn-close").on("click", function() {
          _self.removeFocusAddon(wrap);
        });
        $2(document).on("keydown", function(e) {
          if (e.key === "Escape" || e.keyCode === 27) {
            if (wrap.hasClass("focus")) {
              _self.removeFocusAddon(wrap);
            }
          }
        });
        $2(".offcanvas-backdrop").on("click", function() {
          _self.focusAddon(wrap);
        });
        let insideClick = false;
        wrap.on("pointerdown", () => insideClick = true);
        wrap.on("focusout", (e) => {
          if (insideClick) return insideClick = false;
          const next = e.relatedTarget || document.activeElement;
          if (!wrap.has(next).length) _self.removeFocusAddon(wrap);
        });
      }
    },
    focusAddon: function(wrap) {
      const body = $2("body");
      wrap.removeClass("focus");
      if (body.hasClass("search-offcanvas-open")) {
        body.removeClass("search-offcanvas-open");
      }
      if (wrap.closest(".gsp-header__desktop").length) {
        wrap.closest(".gsp-header__desktop").removeClass("search-offcanvas-active");
        for (let i = 0; i < GSP.headerSticky.items.length; i++) {
          const item = GSP.headerSticky.items[i];
          if (!item.isSticky) {
            item.headerWrap.classList.remove("sticky");
          }
        }
      }
    },
    removeFocusAddon: function(wrap) {
      if (wrap.length) {
        const body = $2("body");
        wrap.removeClass("focus");
        const $input = wrap.find(".search-input");
        if ($input.is(":focus")) $input.blur();
        if (body.hasClass("search-offcanvas-open")) {
          body.removeClass("search-offcanvas-open");
        }
        const $headerDesktop = wrap.closest(".gsp-header__desktop");
        if ($headerDesktop.length) {
          $headerDesktop.removeClass("search-offcanvas-active");
          $headerDesktop.removeClass("show-overlay");
          document.querySelector("body").classList.remove("is-show-dropdown-menu");
          for (let i = 0; i < GSP.headerSticky.items.length; i++) {
            const item = GSP.headerSticky.items[i];
            if (!item.isSticky) {
              item.headerWrap.classList.remove("sticky");
            }
          }
        }
      }
    }
  };
  GSP.headerMobile = {
    init: function() {
      this.activeSubmenu();
      this.eventActiveToggle();
      this.heightOffCanvasHeader();
      this.offCanvasMenuMobileTabFocus();
    },
    offCanvasMenuMobileTabFocus: function() {
      $2("#offcanvasMenuMobile").find(".gsp-submenu").each(function() {
        this.setAttribute("inert", "");
      });
    },
    heightOffCanvasHeader: function() {
      const offCanvas = $2("#offcanvasMenuMobile");
      const header = offCanvas.find(".offcanvas-header");
      if (header.length) {
        const heightHeader = header.outerHeight();
        offCanvas.css("--gsp-height-offcanvas-header", `${heightHeader}px`);
      }
    },
    activeSubmenu: function() {
      $2(".gsp-menu-link-item").each(function() {
        $2(this).on("click", function(event) {
          const $linkItem = $2(this);
          const $menuItem = $linkItem.closest(".gsp-menu-item,.gsp-submenu-item");
          const $subMenu = $menuItem.find(" > .gsp-submenu");
          const $mainMenu = $linkItem.closest(".gsp-main-menu-mobile");
          if ($subMenu.length) {
            event.preventDefault();
            $menuItem.addClass("active");
            $mainMenu.addClass("active");
            $subMenu.removeAttr("inert");
          }
          const $sliderElements = $linkItem.closest(".gsp-menu-item.gsp-menu-item__mega").find(".gsp-swiper");
          if ($sliderElements.length > 0) {
            const sliderElement = $sliderElements[0];
            if (sliderElement && sliderElement.swiper) {
              sliderElement.swiper.update();
            }
          }
        });
      });
      $2(".gsp-submenu-header").on("click", function(event) {
        const $this = $2(this);
        const $subMenu = $this.closest(".gsp-submenu");
        const $menuItem = $this.closest(".gsp-menu-item,.gsp-submenu-item");
        const $mainMenu = $this.closest(".gsp-main-menu-mobile");
        $menuItem.removeClass("active");
        $mainMenu.removeClass("active");
        $subMenu.attr("inert", "");
      });
    },
    eventActiveToggle: function() {
      $2(".gsp-header__menu-toggle").each(function() {
        var $this = $2(this);
        const target = $this.data("bs-target");
        if (target === void 0) return;
        $2(target).on("show.bs.offcanvas", function(event) {
          $this.addClass("active");
        });
        $2(target).on("hide.bs.offcanvas", function(event) {
          $this.removeClass("active");
        });
      });
    }
  };
  $2(document).ready(function() {
    GSP.headerSticky.init();
    GSP.logoScroll.init();
    GSP.headerMobile.init();
    GSP.headerAddonSearch.init();
    GSP.header.init();
  });
})(jQuery);
(function($2) {
  GSP.search = {
    init: function() {
      this.headerSearchFocus();
    },
    headerSearchFocus: function() {
      let $input = $2(".gsp-header-addons-item-link__show-full input");
      const clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
      });
      $input.on("focus", function() {
        this.closest("a").dispatchEvent(clickEvent);
      });
      $input.on("keydown", function(event) {
        event.preventDefault();
        this.closest("a").dispatchEvent(clickEvent);
      });
    }
  };
  $2(document).ready(function() {
    GSP.search.init();
  });
})(jQuery);
var APP = APP || {};
(function($2) {
  APP.collapseShowByHash = {
    init: function() {
      const collapseHash = $2("[data-show-collapse-by-hash]");
      if (collapseHash.length < 1) {
        return;
      }
      var hash = window.location.hash;
      if (hash) {
        if (collapseHash.hasClass("show")) {
          collapseHash.removeClass("show");
        }
        const collapseShow = $2(hash + ".collapse[data-show-collapse-by-hash]");
        if (collapseShow.length) {
          collapseShow.addClass("show");
        }
      }
    }
  };
  $2(document).ready(function() {
    APP.collapseShowByHash.init();
  });
})(jQuery);
(function($2) {
  GSP.loading = {
    init: function() {
      this.pageLoading();
    },
    pageLoading: function() {
      var that = this;
      var window_load = false;
      $2(window).on("load", function() {
        that.fadePageIn();
        window_load = true;
      });
      setTimeout(function() {
        if (!window_load) {
          that.fadePageIn();
        }
      }, 2e3);
    },
    fadePageIn: function() {
      var preloadTime = 1e3, $loading = $2(".gsp-loading-page");
      if ($loading.length) {
        $loading.animate({
          opacity: 0,
          delay: 200
        }, preloadTime, "linear", function() {
          $loading.css("display", "none");
        });
      }
    }
  };
  $2(document).ready(function() {
    GSP.loading.init();
  });
})(jQuery);
(function($2) {
  GSP.collectionBounded = {
    cartUpdateUnsubscriber: void 0,
    init: function() {
      const mql = GSP.config.device.queries.mobile;
      const tql = GSP.config.device.queries.tablet;
      mql.addEventListener("change", () => this.setup());
      tql.addEventListener("change", () => this.setup());
      this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
        GSP.pubsub.PUB_SUB_EVENTS.cartUpdated,
        (event) => {
          if (event.cart.item_count === 0) {
            this.setup(event.element);
          }
        }
      );
      this.setup();
    },
    setup: function(wrapper) {
      if (typeof wrapper === "undefined") {
        wrapper = document;
      }
      const cards = wrapper.querySelectorAll(".gsp-collection-card-skin-bounded");
      cards.forEach((card) => {
        const image = card.querySelector(".gsp-image");
        if (image) {
          image.style.removeProperty("--image-height");
          const imageHeight = image.getBoundingClientRect().height;
          image.style.setProperty("--image-height", `${imageHeight}px`);
        }
        const title = card.querySelector(".gsp-collection-card-title");
        if (title) {
          card.style.removeProperty("--title-height");
          const titleHeight = title.getBoundingClientRect().height;
          card.style.setProperty("--title-height", `${titleHeight}px`);
        }
        const count = card.querySelector(".gsp-collection-card-count");
        if (count) {
          card.style.removeProperty("--count-height");
          const countStyle = window.getComputedStyle(count);
          const countHeight = count.offsetHeight + parseFloat(countStyle.marginTop) + parseFloat(countStyle.marginBottom);
          card.style.setProperty("--count-height", `${countHeight}px`);
        }
      });
    }
  };
  $2(document).ready(function() {
    GSP.collectionBounded.init();
  });
})(jQuery);
const gspTheme$4 = window.gspTheme || {};
class gspHelper {
  constructor() {
    this.requestDefaultConfigs = {
      mode: "same-origin",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json" }
    };
    this.sectionCache = /* @__PURE__ */ new Map();
  }
  getRequestDefaultConfigs() {
    return JSON.parse(JSON.stringify(this.requestDefaultConfigs));
  }
  getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }
  setCookie(cookieName, cookieValue, expirationDays) {
    var d = /* @__PURE__ */ new Date();
    d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1e3);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }
  generateDomFromString(e, t = "div") {
    const i = document.createElement(t);
    return i.innerHTML = e, i;
  }
  fetchJSON(url, options = this.getRequestDefaultConfigs()) {
    return fetch(url, options).then((response) => {
      if (!response.ok) throw response;
      return response.json();
    });
  }
  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: `application/${type}` }
    };
  }
  cache2() {
    return /* @__PURE__ */ new Map();
  }
  fetchJsonCache(url, options = requestDefaultConfigs) {
    const map2 = this.cache2();
    return new Promise((resolve, reject) => {
      if (map2.get(url)) return resolve(map2.get(url));
      fetch(url, options).then((response) => {
        if (response.ok) {
          const jsonResponse = response.json();
          resolve(jsonResponse);
          map2.set(url, jsonResponse);
          return jsonResponse;
        }
        reject(response);
      }).catch(reject);
    });
  }
  fetchSection(sectionId, options = {}) {
    const {
      url: sectionUrl,
      pushState = false,
      fromCache: useCache = false,
      params: queryParams = {},
      paramVars = {},
      deleteParams = [],
      signal = void 0
    } = options;
    return new Promise((resolve, reject) => {
      const url = new URL(sectionUrl || window.location.href);
      let currentUrl = new URL(sectionUrl || window.location.href);
      url.searchParams.set("section_id", sectionId);
      if (deleteParams.length > 0) {
        deleteParams.forEach((param) => {
          url.searchParams.delete(param);
          currentUrl.searchParams.delete(param);
        });
      }
      Object.entries(queryParams).forEach(([param, value]) => {
        url.searchParams.set(param, value);
        if (pushState) {
          currentUrl.searchParams.set(param, value);
        }
      });
      if (Object.keys(paramVars).length > 0) {
        currentUrl.searchParams.delete(paramVars.param);
        url.searchParams.delete(paramVars.param);
        paramVars.values.forEach((value) => {
          url.searchParams.append(paramVars.param, value);
          if (pushState) {
            currentUrl.searchParams.append(paramVars.param, value);
          }
        });
      }
      if (useCache) {
        const cachedSection = this.sectionCache.get(url);
        if (cachedSection) {
          return resolve(cachedSection);
        }
      }
      fetch(url, this.getRequestDefaultConfigs(), signal).then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error(`Failed to load section: ${sectionId}`);
      }).then((htmlContent) => {
        const sectionDom = this.generateDomFromString(htmlContent);
        resolve(sectionDom);
      }).catch((error) => {
        if (error.name === "AbortError") {
          return;
        }
        reject(error);
      }).finally((() => {
        if (pushState) {
          var title = document.title;
          if (typeof window.history.pushState === "function") {
            window.history.pushState(null, title, currentUrl);
          }
        }
      }));
    });
  }
  addEventDelegate({
    context: element = document.documentElement,
    event: eventType = "click",
    selector: targetSelector,
    handler: eventHandler,
    capture: useCapture = false
  }) {
    const delegateFunction = function(event) {
      for (let targetElement = event.target; targetElement && targetElement !== this; targetElement = targetElement.parentNode) {
        if (targetElement.matches(targetSelector)) {
          eventHandler.call(targetElement, event, targetElement);
          break;
        }
      }
    };
    element.addEventListener(eventType, delegateFunction, useCapture);
    return () => {
      element.removeEventListener(eventType, delegateFunction, useCapture);
    };
  }
  debounce(originalFunction, delayTime) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => originalFunction.apply(this, args), delayTime);
    };
  }
  getIconSvg(icon) {
    let iconBase = {
      circle_xmark: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>',
      circle_check: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"/></svg>',
      instagram: ' <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>'
    };
    return icon !== "" ? iconBase[icon] : false;
  }
  ExtendObject(objectDefault, object) {
    return { ...objectDefault, ...object };
  }
  queryDomNodes(selectors = {}, context = document) {
    return Object.entries(selectors).reduce((result, [key, value]) => {
      const isStringSelector = typeof value === "string";
      const queryMethod = isStringSelector ? "querySelector" : "querySelectorAll";
      const selectorValue = isStringSelector ? value : value[0];
      if (context) {
        result[key] = context[queryMethod](selectorValue);
      }
      if (!isStringSelector && result[key]) {
        result[key] = [...result[key]];
      }
      return result;
    }, {});
  }
  getVariantFromOptionArray(product, optionsArray) {
    this._validateProductStructure(product);
    this._validateOptionsArray(optionsArray);
    return product.variants.filter(function(variant) {
      return optionsArray.every(function(option, index) {
        return variant.options[index] === option;
      });
    })[0] || null;
  }
  _validateOptionsArray(optionsArray) {
    if (Array.isArray(optionsArray) && typeof optionsArray[0] === "object") {
      throw new Error(optionsArray + " is not a valid array of options.");
    }
  }
  _validateProductStructure(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }
    if (Object.keys(product).length === 0 && product.constructor === Object) {
      throw new Error(product + " is empty.");
    }
  }
  formatMoney(amount, template) {
    if (typeof amount === "string") {
      amount = amount.replace(".", "");
    }
    let formattedAmount = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const defaultTemplate = template || "${{amount}}";
    switch (defaultTemplate.match(placeholderRegex)[1]) {
      case "amount":
        formattedAmount = this.formatNumberWithCommas(amount, 2);
        break;
      case "amount_no_decimals":
        formattedAmount = this.formatNumberWithCommas(amount, 0);
        break;
      case "amount_with_comma_separator":
        formattedAmount = this.formatNumberWithCommas(amount, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formattedAmount = this.formatNumberWithCommas(amount, 0, ".", ",");
        break;
    }
    return defaultTemplate.replace(placeholderRegex, formattedAmount);
  }
  formatMoney2(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  formatNumberWithCommas(number, decimals = 2, thousandsSeparator = ",", decimalSeparator = ".") {
    if (isNaN(number) || number === null) {
      return 0;
    }
    const roundedNumber = (number / 100).toFixed(decimals);
    const parts = roundedNumber.split(".");
    return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousandsSeparator}`) + (parts[1] ? decimalSeparator + parts[1] : "");
  }
  loadAssetsNew(namespace = "", callback = (() => {
  })) {
    var assets = [];
    var handle = window.gspThemeAssets[namespace];
    if (typeof handle === "undefined" && !Object.keys(handle).length) {
      return;
    }
    for (const key in handle) {
      assets.push(handle[key]);
    }
    this.callFilesAsset(assets, namespace, callback);
  }
  callFilesAsset(assets = [], namespace, callback = (() => {
  })) {
    const namespaceIdentifier = namespace || Math.random().toString(36).slice(2);
    if (!window.gspThemeLibs.loadjs.isDefined(namespace)) {
      window.gspThemeLibs.loadjs(assets, namespaceIdentifier);
    }
    window.gspThemeLibs.loadjs.ready(namespaceIdentifier, callback);
  }
  loadFileAssets() {
    var noop = function() {
    }, loadedScripts = {}, scriptCallbacks = {}, pendingCallbacks = {};
    function executeCallbacks(nameSpace, status) {
      if (nameSpace) {
        var callbacks = pendingCallbacks[nameSpace];
        if (scriptCallbacks[nameSpace] = status, callbacks) {
          while (callbacks.length) {
            callbacks[0](nameSpace, status);
            callbacks.splice(0, 1);
          }
        }
      }
    }
    function handleLoadResult(callback, errors) {
      if (callback.call) {
        callback = { success: callback };
      }
      errors.length ? (callback.error || noop)(errors) : (callback.success || noop)(callback);
    }
    function loadScript(url, onComplete, options, attempt) {
      var element, isCss = false, documentRef = document, asyncLoading = options.async, maxRetries = (options.numRetries || 0) + 1, beforeLoad = options.before || noop, cleanUrl = url.replace(/[\?|#].*$/, ""), actualUrl = url.replace(/^(css|img)!/, "");
      attempt = attempt || 0;
      if (/(^css!|\.css$)/.test(cleanUrl)) {
        element = documentRef.createElement("link");
        element.rel = "stylesheet";
        element.href = actualUrl;
        isCss = "hideFocus" in element && element.relList;
        if (isCss) {
          element.rel = "preload";
          element.as = "style";
        }
      } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(cleanUrl)) {
        element = documentRef.createElement("img");
        element.src = actualUrl;
      } else {
        element = documentRef.createElement("script");
        element.src = url;
        element.async = asyncLoading === void 0 || asyncLoading;
      }
      element.onload = element.onerror = element.onbeforeload = function(event) {
        var eventType = event.type[0];
        if (isCss) {
          try {
            if (!element.sheet.cssText.length) {
              eventType = "e";
            }
          } catch (error) {
            if (error.code !== 18) {
              eventType = "e";
            }
          }
        }
        if (eventType === "e") {
          if ((attempt += 1) < maxRetries) return loadScript(url, onComplete, options, attempt);
        } else if (element.rel === "preload" && element.as === "style") {
          element.rel = "stylesheet";
        }
        onComplete(url, eventType, event.defaultPrevented);
      };
      if (beforeLoad(url, element) !== false) {
        documentRef.head.appendChild(element);
      }
    }
    function loadResources(resources, namespace, options) {
      var resourceName, config;
      if (namespace && namespace.trim) {
        resourceName = namespace;
      }
      config = (resourceName ? options : namespace) || {};
      if (resourceName) {
        if (resourceName in loadedScripts) throw "LoadJS";
        loadedScripts[resourceName] = true;
      }
      function handleCompletion(successCallback, errorCallback) {
        function processResources(scripts, callback, settings) {
          var pendingScripts = scripts.push ? scripts : [scripts], remaining = pendingScripts.length, failedScripts = [];
          function scriptHandler(script, status, preventDefault) {
            if (status === "e") {
              failedScripts.push(script);
            } else if (status === "b" && !preventDefault) {
              failedScripts.push(script);
            }
            if (--remaining === 0) {
              callback(failedScripts);
            }
          }
          for (var i = 0; i < pendingScripts.length; i++) {
            loadScript(pendingScripts[i], scriptHandler, settings);
          }
        }
        processResources(resources, function(errors) {
          handleLoadResult(config, errors);
          if (successCallback) {
            handleLoadResult({ success: successCallback, error: errorCallback }, errors);
          }
          executeCallbacks(resourceName, errors);
        }, config);
      }
      if (config.returnPromise) {
        return new Promise(handleCompletion);
      }
      handleCompletion();
    }
    loadResources.ready = function(resources, callback) {
      function checkReady(scripts, onReady) {
        scripts = scripts.push ? scripts : [scripts];
        var remaining = scripts.length, failedScripts = [];
        function scriptHandler(script, status2) {
          if (status2.length) {
            failedScripts.push(script);
          }
          if (--remaining === 0) {
            onReady(failedScripts);
          }
        }
        for (var i = 0; i < scripts.length; i++) {
          var nameSpace = scripts[i];
          var status = scriptCallbacks[nameSpace];
          if (status) {
            scriptHandler(nameSpace, status);
          } else {
            pendingCallbacks[nameSpace] = pendingCallbacks[nameSpace] || [];
            pendingCallbacks[nameSpace].push(scriptHandler);
          }
        }
      }
      checkReady(resources, function(errors) {
        handleLoadResult(callback, errors);
      });
      return loadResources;
    };
    loadResources.done = function(nameSpace) {
      executeCallbacks(nameSpace, []);
    };
    loadResources.reset = function() {
      loadedScripts = {};
      scriptCallbacks = {};
      pendingCallbacks = {};
    };
    loadResources.isDefined = function(nameSpace) {
      return nameSpace in loadedScripts;
    };
    return loadResources;
  }
  postLink(path, options) {
    options = options || {};
    const method = options["method"] || "post";
    const params = options["parameters"] || {};
    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (const key in params) {
      for (const index in params[key]) {
        for (const key2 in params[key][index]) {
          const hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
          hiddenField.setAttribute("value", params[key][index][key2]);
          form.appendChild(hiddenField);
        }
      }
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
  getSectionId(element) {
    if (element.hasAttribute("data-section-id")) {
      return element.dataset.sectionId;
    } else {
      if (!element.classList.contains("shopify-section")) {
        element = element.closest(".shopify-section");
      }
      return element.id.replace("shopify-section-", "");
    }
  }
  getSection(element) {
    if (!element.classList.contains("shopify-section")) {
      return element.closest(".shopify-section");
    }
  }
  enableLoadingSpiner(element) {
    if (element.tagName === "BUTON") {
      element.setAttribute("aria-disabled", true);
    }
    const loader = element.querySelectorAll(".gsp-loading__spinner");
    loader.forEach((overlay) => overlay.classList.remove("hidden"));
  }
  disableLoadingSpinner(element) {
    if (element.tagName === "BUTON") {
      element.removeAttribute("aria-disabled");
    }
    const loader = element.querySelectorAll(".gsp-loading__spinner");
    loader.forEach((overlay) => overlay.classList.add("hidden"));
  }
  getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }
  getStorage(key) {
    if (!GSP.config.state.hasLocalStorage) return null;
    const itemStr = window.localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    if (item.expiry && (/* @__PURE__ */ new Date()).getTime() > item.expiry) {
      window.localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
  setStorage(key, value, expiryInDays = null) {
    if (!GSP.config.state.hasLocalStorage) return;
    const item = {
      value
    };
    if (expiryInDays !== null) {
      const now = /* @__PURE__ */ new Date();
      item.expiry = now.getTime() + expiryInDays * 864e5;
    }
    window.localStorage.setItem(key, JSON.stringify(item));
  }
}
gspTheme$4.helper = new gspHelper();
class Notification {
  constructor() {
    this.default = {
      target: false,
      message: false,
      type: "success",
      method: "append",
      icon: "",
      timeOut: 3e3,
      sticky: false
    };
  }
  show(option) {
    option = gspTheme.helper.ExtendObject(this.default, option);
    var $classWrap = [
      "gsp-notification",
      "type-" + option.type
    ];
    if (option.sticky) {
      option.target = document.body;
      $classWrap.push("gsp-notification-sticky");
    }
    if (option.target === false || option.message === false) {
      return;
    }
    if (document.body.querySelector(".gsp-notification")) {
      Notification.prototype.remove(document.body.querySelector(".gsp-notification"), 0);
    }
    var id = "gsp-" + Math.random().toString(36).substr(2, 9);
    var html = '<div id ="' + id + '" class="' + $classWrap.join(" ") + '">';
    if (option.icon !== "") {
      html += '<span class="icon d-inline-block me-2">' + gspTheme.helper.getIconSvg(option.icon) + "</span>";
    }
    html += option.message;
    html += "</div>";
    switch (option.method) {
      case "append":
        option.target.append(html);
        break;
      case "appendChild":
        option.target.insertAdjacentHTML("afterbegin", html);
        break;
      case "afterEnd":
        option.target.insertAdjacentHTML("afterend", html);
        break;
      default:
        option.target.innerHTML = html;
    }
    var notification = document.getElementById(id);
    setTimeout(function() {
      if (!notification.classList.contains("show")) {
        notification.classList.add("show");
      }
    }, 250);
    notification.addEventListener("click", function(e) {
      Notification.prototype.remove(notification, 0);
    });
    Notification.prototype.remove(notification, option.timeOut);
  }
  remove(notification, timeOut) {
    setTimeout(function() {
      if (!notification.classList.contains("hide")) {
        notification.classList.add("hide");
      }
      if (notification.classList.contains("show")) {
        notification.classList.remove("show");
      }
    }, timeOut);
    setTimeout(function() {
      notification.remove();
    }, timeOut + 250);
  }
}
window.gspNotification = window.gspNotification || new Notification();
class LoadingBar {
  constructor() {
  }
  start(target, sticky = false) {
    if (!target.classList.contains("gspLoading__bar")) {
      target.classList.add("gspLoading__bar");
    }
    if (!target.classList.contains("gspLoading")) {
      target.classList.add("gspLoading");
    }
    if (!target.classList.contains("gspLoading__start")) {
      target.classList.add("gspLoading__start");
    }
    if (target.classList.contains("gspLoading_finished")) {
      target.classList.remove("gspLoading_finished");
    }
    if (sticky) {
      target.classList.add("gspLoading_stiky");
    }
  }
  remove(target) {
    if (!target.classList.contains("gspLoading_finished")) {
      target.classList.add("gspLoading_finished");
    }
    setTimeout(function() {
      if (target.classList.contains("gspLoading")) {
        target.classList.remove("gspLoading");
      }
    }, 300);
  }
}
window.gspLoadingBar = window.gspLoadingBar || new LoadingBar();
if (void 0 === window.Shopify) {
  window.Shopify = {};
}
Shopify.bind = function(func, context) {
  return function() {
    return func.apply(context, arguments);
  };
};
Shopify.setSelectorByValue = function(selectElement, value) {
  for (var index = 0, length = selectElement.options.length; index < length; index++) {
    var option = selectElement.options[index];
    if (value == option.value || value == option.innerHTML) return selectElement.selectedIndex = index, index;
  }
};
Shopify.addListener = function(element, eventType, handler) {
  element.addEventListener ? element.addEventListener(eventType, handler, false) : element.attachEvent("on" + eventType, handler);
};
Shopify.CountryProvinceSelector = function(countryId, provinceId, options) {
  this.countryEl = document.getElementById(countryId);
  this.provinceEl = document.getElementById(provinceId);
  this.provinceContainer = document.getElementById(options.hideElement || provinceId);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var defaultCountryValue = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, defaultCountryValue);
    this.countryHandler();
  },
  initProvince: function() {
    var defaultProvinceValue = this.provinceEl.getAttribute("data-default");
    if (defaultProvinceValue && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, defaultProvinceValue);
    }
  },
  countryHandler: function(event) {
    var selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
    var provinceData = JSON.parse(selectedOption.getAttribute("data-provinces"));
    this.clearOptions(this.provinceEl);
    if (provinceData && provinceData.length > 0) {
      for (var index = 0; index < provinceData.length; index++) {
        var option;
        (option = document.createElement("option")).value = provinceData[index][0];
        option.innerHTML = provinceData[index][1];
        this.provinceEl.appendChild(option);
      }
      this.provinceContainer.style.display = "";
    } else {
      this.provinceContainer.style.display = "none";
    }
  },
  clearOptions: function(selectElement) {
    while (selectElement.firstChild) {
      selectElement.removeChild(selectElement.firstChild);
    }
  },
  setOptions: function(selectElement, optionsArray) {
    var index = 0;
    for (optionsArray.length; index < optionsArray.length; index++) {
      var option = document.createElement("option");
      option.value = optionsArray[index];
      option.innerHTML = optionsArray[index];
      selectElement.appendChild(option);
    }
  }
};
const gspTheme$3 = window.gspTheme || {};
class gspRenderProductList {
  constructor(selectors, productHandles, limit = null) {
    this.productHandles = productHandles;
    this.productNodes = {};
    this.hasAnimate = false;
    this.selectors = selectors;
    this.selectors = {
      ...{ scope: document },
      ...selectors
    };
    if (limit !== null) {
      this.productHandles = this.productHandles.slice(0, limit);
    }
  }
  async renderList() {
    const render = this.selectors.scope.querySelector(this.selectors.render);
    if (render) {
      let hasProducts = false;
      let sliderEnable = render.hasAttribute("data-gsp-slider");
      let renderSlider = null;
      if (sliderEnable) {
        renderSlider = render.querySelector(".swiper-wrapper");
      }
      if (this.productHandles.length) {
        const fetchPromises = this.productHandles.map(async (productHandle) => {
          await gspTheme$3.helper.fetchSection(this.selectors.sectionId, { url: `${window.gspSetting.base_url}products/${productHandle}` }).then((response) => {
            const content = response.querySelector(".gsp-product-list-item");
            if (content) {
              if (render.dataset.classesItemInner) {
                const $class = this.addClassItem(render.dataset.classesItemInner);
                content.classList.add(...$class);
              }
              if (render.dataset.animateItemInner) {
                content.setAttribute("data-animate", render.dataset.animateItemInner);
                this.hasAnimate = true;
              }
              hasProducts = true;
              this.productNodes[productHandle] = content;
            }
          }).catch(console.error);
        });
        await Promise.all(fetchPromises);
        this.productHandles.forEach((productHandle) => {
          const node = this.productNodes[productHandle];
          if (node && node !== "") {
            if (sliderEnable) {
              let slide = document.createElement("div");
              slide.className = "swiper-slide";
              slide.appendChild(node);
              renderSlider.appendChild(slide);
            } else {
              render.appendChild(node);
            }
            GSP.bsScript.tooltips();
            if (this.hasAnimate) {
              GSP.animation.init();
            }
          }
        });
        if (sliderEnable) {
          GSP.carousel.initMultiSwiper(render, ".gsp-swiper");
        }
      }
      if (this.selectors.noProducts && !hasProducts) {
        this.showNoProductsMessage();
      }
    }
  }
  showNoProductsMessage() {
    const container = this.selectors.scope.querySelector(this.selectors.container);
    const noProductsMessage = this.selectors.scope.querySelector(this.selectors.noProducts);
    container.classList.add("d-none");
    noProductsMessage.classList.remove("d-none");
  }
  addClassItem($str_class) {
    if (typeof $str_class === "string" && $str_class !== "") {
      return $str_class.split(" ").filter(function(v) {
        return v !== "";
      });
    }
    return [];
  }
}
gspTheme$3.ProductList = gspRenderProductList;
class gspAddToCartSticky extends HTMLElement {
  constructor() {
    super();
    this.main = document.querySelector(".gsp-main-product__wrap");
    this.mainATC = this.main ? this.main.querySelector(".gsp-block__add_to_cart") : false;
    this.variantId = '[name="id"]';
    this.variant = this.querySelector(".select-variant");
    this.variantData = this.getVariantData();
  }
  connectedCallback() {
    this.processStickyAtc();
    this.variant.addEventListener("change", () => {
      const variantId = this.querySelector(this.variantId).value;
      this.currentVariant = this.variantData.find((variant) => variant.id === Number(variantId));
      this.updateButton(this.currentVariant);
    });
  }
  updateButton(currentVariant) {
    this.updateButtonStatus(true, "", false);
    if (currentVariant) {
      this.updateButtonStatus(!currentVariant.available, window.gspString.soldOut);
    } else {
      this.updateButtonStatus(true, "", true);
    }
  }
  updateButtonStatus(isEnabled = true, buttonText, isVisible = true) {
    const formContainer = this.querySelector(".atc-sticky-form");
    if (!formContainer) return;
    const addButton = formContainer.querySelector('[name="add"]');
    const buttonTextElements = formContainer.querySelectorAll('[name="add"] .btn-content span');
    if (addButton) {
      if (isEnabled) {
        addButton.setAttribute("disabled", "disabled");
        if (buttonText) {
          buttonTextElements.forEach((el) => {
            el.textContent = buttonText;
          });
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.classList.remove("disabled");
        buttonTextElements.forEach((el) => {
          el.textContent = window.gspString.addToCart;
        });
      }
    }
  }
  processStickyAtc() {
    const _self = this;
    if (this.mainATC) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            if (_self.classList.contains("active")) {
              _self.classList.remove("active");
              _self.recalculateSpacingForElements();
            }
          } else {
            if (!_self.classList.contains("active")) {
              _self.classList.add("active");
              _self.recalculateSpacingForElements(_self.offsetHeight);
            }
          }
        });
      }, { threshold: 0 });
      observer.observe(_self.mainATC);
    }
  }
  setVariant($variant) {
    if (this.variant && $variant !== "") {
      this.variant.value = $variant;
    }
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData;
  }
  recalculateSpacingForElements(height = 0) {
    const bodyTag = this.mainATC.closest("body");
    const htmlTag = this.mainATC.closest("html");
    const stt = bodyTag ? bodyTag.querySelector(".gsp-stt") : false;
    if (bodyTag) {
      bodyTag.style.paddingBottom = height + "px";
      if (height !== 0 && !bodyTag.classList.contains("atc-sticky-form-active")) {
        bodyTag.classList.add("atc-sticky-form-active");
      }
      if (height === 0 && bodyTag.classList.contains("atc-sticky-form-active")) {
        bodyTag.classList.remove("atc-sticky-form-active");
      }
    }
    if (bodyTag && htmlTag && !htmlTag.classList.contains("pb-0") && height !== 0) {
      htmlTag.classList.add("pb-0");
    }
    if (bodyTag && htmlTag && htmlTag.classList.contains("pb-0") && height === 0) {
      htmlTag.classList.remove("pb-0");
    }
    if (stt) {
      const transform = "translateY(-" + height + "px )";
      stt.style.setProperty("transform", transform);
    }
  }
}
customElements.define("gsp-atc-sticky", gspAddToCartSticky);
class ShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.formEl.addEventListener("submit", this.handleFormSubmit.bind(this));
    this.isCountrySetup = false;
    if (this.collapseEl) {
      this.collapseEl.addEventListener("show.bs.collapse", (event) => {
        this.setupCountryProvince();
      });
      this.collapseInstance = bootstrap.Collapse.getInstance(this.collapseEl) || new bootstrap.Collapse(this.collapseEl, {
        toggle: false
      });
    }
  }
  get countryProvince() {
    return this._countryProvince = this._countryProvince || this.querySelector("country-province");
  }
  get formEl() {
    return this._formEl = this._formEl || this.querySelector("form");
  }
  get submitEl() {
    return this._submitEl = this._submitEl || this.querySelector('[type="submit"]');
  }
  get messageEl() {
    return this._messageEl = this._messageEl || this.querySelector(".form__message");
  }
  get collapseEl() {
    return this._collapseEl = this._collapseEl || this.closest(".collapse");
  }
  setupCountryProvince() {
    if (!this.isCountrySetup && this.countryProvince) {
      const template = this.countryProvince.querySelector("template");
      const templateContent = document.importNode(template.content, true);
      this.countryProvince.countryElement.appendChild(templateContent);
      this.countryProvince.init();
      this.isCountrySetup = true;
    }
  }
  handleFormSubmit(event) {
    event.preventDefault();
    if (this.submitEl.getAttribute("aria-disabled") === "true") return;
    gspTheme.helper.enableLoadingSpiner(this.submitEl);
    const zip = this.querySelector('[name="address[zip]"]').value, country = this.querySelector('[name="address[country]"]').value, province = this.querySelector('[name="address[province]"]').value;
    const body = JSON.stringify({
      shipping_address: { zip, country, province }
    });
    let sectionUrl = `${gspSetting.routes.cart_url}/shipping_rates.json`;
    sectionUrl = sectionUrl.replace("//", "/");
    fetch(sectionUrl, { ...gspTheme.helper.fetchConfig("javascript"), ...{ body } }).then((response) => response.json()).then((parsedState) => {
      if (parsedState.shipping_rates) {
        this.formatShippingRates(parsedState.shipping_rates);
      } else {
        this.formatError(parsedState);
      }
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      gspTheme.helper.disableLoadingSpinner(this.submitEl);
    });
  }
  formatError = (errors) => {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.messageEl.hidden = false;
    this.messageEl.innerHTML = `
					<div class="alert alert-danger mb-0">
						 <p class="m-0 fw-bold">${window.gspString.shippingCalculatorStrings.error}</p>
						<ul class="d-grid ps-4 gap-1 text-sm mb-0" role="list">${shippingRatesList.join("")}</ul>
					</div>
			`;
  };
  formatShippingRates(shippingRates) {
    const showDeliveryDays = this.dataset.showDeliveryDays === "true";
    const { deliveryOne = "Day", deliveryOther = "Days" } = this.dataset;
    const shippingRatesList = shippingRates.map(({ presentment_name, currency, price, delivery_days }) => {
      let deliveryText = "";
      if (showDeliveryDays && delivery_days.length > 0) {
        let dayText = deliveryOne;
        const firstDay = delivery_days[0];
        const lastDay = delivery_days.at(-1);
        if (firstDay > 1) {
          dayText = deliveryOther;
        }
        deliveryText = firstDay === lastDay ? `(${firstDay} ${dayText})` : `(${firstDay} - ${lastDay} ${dayText})`;
      }
      return `<li>${presentment_name}: ${currency} ${price} ${deliveryText}</li>`;
    });
    this.messageEl.hidden = false;
    this.messageEl.innerHTML = `
					<div class="alert alert-${shippingRates.length === 0 ? "error" : "success"} mb-0">
						 <p class="m-0 fw-bold">
							${shippingRates.length === 0 ? window.gspString.shippingCalculatorStrings.notFound : shippingRates.length === 1 ? window.gspString.shippingCalculatorStrings.oneResult : window.gspString.shippingCalculatorStrings.multipleResults}
						</p>
						${shippingRatesList === "" ? "" : `<ul class="d-grid ps-4 gap-1 text-sm mb-0" role="list">${shippingRatesList.join("")}</ul>`}
					</div>
			`;
  }
}
customElements.define("shipping-calculator", ShippingCalculator);
class CountryProvinceElement extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener("change", this.handleCountryChange.bind(this));
    if (this.template && this.template === "cart") {
      this.init();
    }
  }
  init() {
    if (this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.dataset.country)
      );
      this.countryElement.dispatchEvent(new Event("change"));
    } else {
      this.handleCountryChange();
    }
  }
  handleCountryChange() {
    const option = this.countryElement.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.dataset.provinces);
    this.provinceElement.closest(".form-field").hidden = provinces.length === 0;
    if (provinces.length === 0) {
      return;
    }
    this.provinceElement.innerHTML = "";
    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
}
customElements.define("country-province", CountryProvinceElement);
class CartDiscountRemove extends HTMLElement {
  constructor() {
    super();
    this.clickHandler = this.handleClick.bind(this);
  }
  get discountsEl() {
    return this._discountsEl = this._discountsEl || this.closest(".gsp-cart__discounts");
  }
  get buttonEl() {
    return this._buttonEl = this._buttonEl || this.querySelector("button");
  }
  connectedCallback() {
    this.buttonEl.addEventListener("click", this.clickHandler);
  }
  disconnectedCallback() {
    this.buttonEl.removeEventListener("click", this.clickHandler);
  }
  getDiscounts() {
    const discounts = [];
    if (this.discountsEl) {
      const thisItem = this.closest("li");
      const items = this.discountsEl.querySelectorAll(".gsp-discount");
      items && items.forEach((item) => {
        if (item !== thisItem) {
          discounts.push(item.dataset.discountCode);
        }
      });
    }
    return discounts;
  }
  handleClick(event) {
    event.preventDefault();
    if (this.buttonEl.getAttribute("aria-disabled") === "true") return;
    gspTheme.helper.enableLoadingSpiner(this.buttonEl);
    const discounts = this.getDiscounts();
    const config = gspTheme.helper.fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    const formData = new FormData();
    formData.append("sections", sectionsToBundle);
    formData.append("sections_url", window.location.pathname);
    formData.append("discount", discounts.join(","));
    config.body = formData;
    fetch(`${gspSetting.routes.cart_update_url}`, config).then((response) => response.json()).then(async (parsedState) => {
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-remove-discount",
        cart: parsedState
      });
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      gspTheme.helper.disableLoadingSpinner(this.buttonEl);
    });
  }
}
customElements.define("cart-discount-remove", CartDiscountRemove);
class CartDrawerProductsRecommendation extends HTMLElement {
  constructor() {
    super();
    const isSafari = GSP.config.device.isSafari();
    if (isSafari) {
      this.init();
    } else {
      GSP.Motion.inView(this, this.init.bind(this), { margin: "600px 0px 600px 0px" });
    }
  }
  init() {
    if (this.isLoading || !this.dataset.url) return;
    this.isLoading = true;
    fetch(this.dataset.url).then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.text();
    }).then((responseText) => {
      const sectionInnerHTML = new DOMParser().parseFromString(responseText, "text/html").querySelector(".shopify-section");
      if (!sectionInnerHTML) return;
      const recommendations = sectionInnerHTML.querySelector(this.tagName);
      this.innerHTML = recommendations.innerHTML;
      GSP.carousel.initMultiSwiper(this);
      GSP.bsScript.tooltips(this);
    }).catch((error) => {
      console.error("Error loading recommendations:", error);
    }).finally(() => {
      this.isLoading = false;
    });
  }
}
customElements.define("cart-drawer-products-recommendation", CartDrawerProductsRecommendation);
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.formEl.addEventListener("submit", this.handleFormSubmit.bind(this));
    this.inputEl.addEventListener("focus", (event) => {
      this.displayFormErrors();
    });
    if (this.collapseEl) {
      this.collapseEl.addEventListener("show.bs.collapse", (event) => {
        this.displayFormErrors();
      });
      this.collapseInstance = bootstrap.Collapse.getInstance(this.collapseEl) || new bootstrap.Collapse(this.collapseEl, {
        toggle: false
      });
    }
  }
  get formEl() {
    return this._formEl = this._formEl || this.querySelector("form");
  }
  get submitEl() {
    return this._submitEl = this._submitEl || this.querySelector('[type="submit"]');
  }
  get inputEl() {
    return this._inputEl = this._inputEl || this.querySelector('[type="text"]');
  }
  get messageEl() {
    return this._messageEl = this._messageEl || this.querySelector(".form__message");
  }
  get couponEl() {
    return this._couponEl = this._couponEl || this.querySelector('input[name="discount"]');
  }
  get cartDiscountsEl() {
    return document.querySelector(".gsp-cart__discounts");
  }
  get collapseEl() {
    return this._collapseEl = this._collapseEl || this.closest(".collapse");
  }
  getDiscounts() {
    const discounts = [];
    if (this.cartDiscountsEl) {
      const items = this.cartDiscountsEl.querySelectorAll(".gsp-discount");
      items && items.forEach((item) => {
        discounts.push(item.dataset.discountCode);
      });
    }
    return discounts;
  }
  handleFormSubmit(event) {
    event.preventDefault();
    if (this.submitEl.getAttribute("aria-disabled") === "true") return;
    gspTheme.helper.enableLoadingSpiner(this.submitEl);
    this.displayFormErrors();
    const newDiscountCode = this.couponEl.value;
    const discounts = this.getDiscounts();
    if (discounts.includes(newDiscountCode)) {
      this.displayFormErrors(window.gspString.duplicateDiscountError);
      gspTheme.helper.disableLoadingSpinner(this.submitEl);
      return;
    }
    discounts.push(newDiscountCode);
    const config = gspTheme.helper.fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    const formData = new FormData();
    formData.append("sections", sectionsToBundle);
    formData.append("sections_url", window.location.pathname);
    formData.append("discount", discounts.join(","));
    config.body = formData;
    fetch(`${gspSetting.routes.cart_update_url}`, config).then((response) => response.json()).then(async (parsedState) => {
      if (parsedState.discount_codes.find((discount) => {
        return discount.code === newDiscountCode && discount.applicable === false;
      })) {
        this.couponEl.value = "";
        this.displayFormErrors(window.gspString.applyDiscountError);
        return;
      }
      gspNotification.show({
        message: window.gspString.cartPage.saveDiscountCode,
        type: "success",
        method: "appendChild",
        icon: "circle_check",
        sticky: true,
        timeOut: 3e3
      });
      if (this.collapseEl) {
        this.collapseInstance.hide();
      }
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-discount",
        cart: parsedState
      });
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      gspTheme.helper.disableLoadingSpinner(this.submitEl);
    });
  }
  displayFormErrors = (errorMessage = false) => {
    if (!this.messageEl) {
      if (errorMessage !== false) {
        alert(errorMessage);
      }
    } else {
      this.messageEl.toggleAttribute("hidden", !errorMessage);
      if (errorMessage !== false) {
        this.messageEl.innerText = errorMessage;
      }
    }
  };
}
customElements.define("cart-discount", CartDiscount);
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.formEl.addEventListener("submit", this.handleFormSubmit.bind(this));
  }
  get submitEl() {
    return this._submitEl = this._submitEl || this.querySelector('[type="submit"]');
  }
  get formEl() {
    return this._formEl = this._formEl || this.querySelector("form");
  }
  get noteEl() {
    return this._noteEl = this._noteEl || this.querySelector('[name="note"]');
  }
  get messageEl() {
    return this._messageEl = this._messageEl || this.querySelector(".form__message");
  }
  handleFormSubmit(event) {
    event.preventDefault();
    if (this.submitEl.getAttribute("aria-disabled") === "true") return;
    gspTheme.helper.enableLoadingSpiner(this.submitEl);
    this.displayFormErrors();
    const config = gspTheme.helper.fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData();
    formData.append("note", this.noteEl.value);
    config.body = formData;
    fetch(`${gspSetting.routes.cart_update_url}`, config).then((response) => response.json()).then(async (parsedState) => {
      if (parsedState.errors) {
        this.noteEl.value = "";
        this.displayFormErrors(parsedState.errors);
        return;
      }
      gspNotification.show({
        message: window.gspString.cartPage.saveNoteSuccess,
        type: "success",
        method: "appendChild",
        icon: "circle_check",
        sticky: true,
        timeOut: 3e3
      });
      let collapseElement = this.closest(".collapse");
      if (collapseElement) {
        const collapseInstance = bootstrap.Collapse.getInstance(collapseElement) || new bootstrap.Collapse(collapseElement, {
          toggle: false
        });
        collapseInstance.hide();
      }
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      gspTheme.helper.disableLoadingSpinner(this.submitEl);
    });
  }
  displayFormErrors = (errorMessage = false) => {
    this.messageEl.toggleAttribute("hidden", !errorMessage);
    if (errorMessage !== false) {
      this.messageEl.innerText = errorMessage;
    }
  };
}
customElements.define("cart-note", CartNote);
class CartCountElement extends HTMLElement {
  cartUpdateUnsubscriber = void 0;
  constructor() {
    super();
  }
  get itemCount() {
    return parseInt(this.innerText);
  }
  connectedCallback() {
    this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onCartUpdate(event) {
    if (event.cart.errors) return;
    const count = event.cart.item_count;
    if (this.closest(".gsp-header-addons-item") || this.closest("mobile-navigation-bar")) {
      this.countOnHeader(count);
    } else {
      this.innerText = count;
    }
  }
  countOnHeader(count) {
    if (count >= 20 && count <= 99) {
      this.innerText = count;
      this.classList.add("gsp-header-badge-lg");
      this.classList.remove("gsp-header-badge-more");
    } else if (count > 99) {
      this.innerText = "99+";
      this.classList.add("gsp-header-badge-more");
      this.classList.remove("gsp-header-badge-lg");
    } else {
      this.innerText = count;
      this.classList.remove("gsp-header-badge-lg");
      this.classList.remove("gsp-header-badge-more");
    }
  }
}
customElements.define("cart-count", CartCountElement);
class StickyAtcBarElement extends HTMLElement {
  constructor() {
    super();
    document.body.classList.add("gsp-sticky-atc-bar-enabled");
  }
  get variantIdSelect() {
    return this.querySelector('[name="id"]');
  }
  _getBaseUnit = () => 1 === this.currentVariant.unit_price_measurement.reference_value ? this.currentVariant.unit_price_measurement.reference_unit : this.currentVariant.unit_price_measurement.reference_value + this.currentVariant.unit_price_measurement.reference_unit;
  connectedCallback() {
    this.productFormActions = document.querySelector(".gsp-main-product-form");
    this.mainProductInfo = document.querySelector("product-info");
    this.container = this.closest(".gsp-sticky-atc-bar");
    this.variantData = this.getVariantData();
    this.select = this.querySelector("select");
    this.init();
    this.select.addEventListener("change", () => {
      if (this.isUpdating) return;
      this.isUpdating = true;
      this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector("variant-selects");
      const selectedVariantId = this.variantIdSelect.value;
      this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
      if (this.mainVariantSelects) {
        Array.from(this.mainVariantSelects.querySelectorAll("fieldset"), (element, index) => {
          const variantOptionVal = this.currentVariant.options[index];
          Array.from(element.querySelectorAll("input, select")).forEach((field) => {
            switch (field.tagName) {
              case "SELECT":
                field.value = variantOptionVal;
                const options = field.querySelectorAll("option");
                options.forEach((option) => option.removeAttribute("selected"));
                field.value = variantOptionVal;
                const selectedOption = field.querySelector(`option[value="${variantOptionVal}"]`);
                if (selectedOption) {
                  selectedOption.setAttribute("selected", "selected");
                }
                break;
              case "INPUT":
                if (field.value === variantOptionVal) {
                  field.checked = true;
                }
                break;
            }
          });
        });
        this.mainVariantSelects.dispatchEvent(new Event("change", { detail: { formStickty: true } }));
        this.isUpdating = false;
      } else {
        this.isUpdating = false;
      }
      this.updatePrice();
      this.updateButton(true, "", false);
      if (!this.currentVariant) {
        this.updateButton(true, "", true);
      } else {
        this.updateButton(!this.currentVariant.available, window.gspString.soldOut);
      }
    });
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  init() {
    if (!this.productFormActions) {
      document.body.classList.add("gsp-sticky-atc-bar-enabled");
      return;
    }
    this.productId = this.dataset.productId;
    const mql = GSP.config.device.queries.mobile;
    mql.onchange = this.checkDevice.bind(this);
    this.checkDevice();
    const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          document.body.classList.toggle("gsp-sticky-atc-bar-enabled", !entry.isIntersecting);
        });
      },
      { threshold: 1, rootMargin }
    );
    this.observer.observe(this.productFormActions);
    this.syncWithMainProductForm();
  }
  checkDevice() {
    document.documentElement.style.setProperty("--gsp-sticky-atc-bar-height", this.container.clientHeight + "px");
  }
  updatePrice() {
    const classes = {
      onSale: "gsp-price--on-sale",
      soldOut: "gsp-price--sold-out"
    };
    const selectors = {
      priceWrapper: ".gsp-product-price",
      salePrice: ".gsp-price-item--sale",
      compareAtPrice: [".gsp-price-item--regular"],
      unitPriceWrapper: ".gsp-price__unit-wrapper"
    };
    const moneyFormat2 = window.gspSetting.money_format;
    const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = gspTheme.helper.queryDomNodes(
      selectors,
      this
    );
    const unitPrice = unitPriceWrapper.querySelector(".gsp-price__unit");
    const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
    if (compare_at_price && compare_at_price > price) {
      priceWrapper.classList.add(classes.onSale);
    } else {
      priceWrapper.classList.remove(classes.onSale);
    }
    if (!this.currentVariant.available) {
      priceWrapper.classList.add(classes.soldOut);
    } else {
      priceWrapper.classList.remove(classes.soldOut);
    }
    if (salePrice) {
      salePrice.innerHTML = gspTheme.helper.formatMoney(price, moneyFormat2);
    }
    if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
      compareAtPrice.forEach(
        (item) => item.innerHTML = `<s>${gspTheme.helper.formatMoney(compare_at_price, moneyFormat2)}</s>`
      );
    } else {
      compareAtPrice.forEach((item) => item.innerHTML = gspTheme.helper.formatMoney(price, moneyFormat2));
    }
    if (unit_price_measurement && unitPrice) {
      unitPriceWrapper.classList.remove("hidden");
      const unitPriceContent = `<span>${gspTheme.helper.formatMoney(
        this.currentVariant.unit_price,
        moneyFormat2
      )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
      unitPrice.innerHTML = unitPriceContent;
    } else {
      unitPriceWrapper.classList.add("hidden");
    }
  }
  updateButton(disable = true, text, modifyClass = true) {
    const productForm = this.querySelector(".gsp-sticky-atc-bar__form");
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
    const buttonTextElements = addButton.querySelectorAll(".btn-content span");
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        buttonTextElements.forEach((el) => {
          el.textContent = text;
        });
      }
    } else {
      addButton.removeAttribute("disabled");
      buttonTextElements.forEach((el) => {
        el.textContent = window.gspString.addToCart;
      });
    }
  }
  syncWithMainProductForm() {
    GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.variantChange,
      (event) => {
        const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
        if (!isMainProduct) return;
        const variant = event.data.variant;
        this.currentVariant = variant;
        this.variantIdSelect.value = variant.id;
        this.updatePrice();
        this.updateButton(true, "", false);
        if (!variant) {
          this.updateButton(true, "", true);
        } else {
          this.updateButton(!variant.available, window.gspString.soldOut);
        }
      }
    );
  }
}
customElements.define("sticky-atc-bar", StickyAtcBarElement);
class StickyAtcBarMinimaListElement extends HTMLElement {
  cartErrorUnsubscriber = void 0;
  cartUpdateUnsubscriber = void 0;
  constructor() {
    super();
    this.submitEl.addEventListener("click", this.onClick.bind(this));
  }
  _getBaseUnit = () => 1 === this.currentVariant.unit_price_measurement.reference_value ? this.currentVariant.unit_price_measurement.reference_unit : this.currentVariant.unit_price_measurement.reference_value + this.currentVariant.unit_price_measurement.reference_unit;
  get submitEl() {
    return this._submitEl = this._submitEl || this.querySelector('[type="submit"]');
  }
  connectedCallback() {
    this.productFormActions = document.querySelector(".gsp-main-product-form");
    this.mainProductInfo = document.querySelector("product-info");
    this.container = this.closest(".gsp-sticky-atc-bar-minimalist");
    this.init();
    this.cartErrorUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.cartError, () => {
      this.resetButtonLoading();
      this.scrollToTop(this.productFormActions);
    });
    this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
      this.resetButtonLoading();
    });
  }
  disconnectedCallback() {
    if (this.cartErrorUnsubscriber) {
      this.cartErrorUnsubscriber();
    }
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  scrollToTop(target, offset = 200) {
    const scrollIntoView = (selector, offset2) => {
      window.scrollTo({
        behavior: "smooth",
        top: selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset2
      });
    };
    scrollIntoView(target, offset);
  }
  onClick(event) {
    gspTheme.helper.enableLoadingSpiner(this.submitEl);
  }
  resetButtonLoading() {
    gspTheme.helper.disableLoadingSpinner(this.submitEl);
  }
  init() {
    if (!this.productFormActions) {
      document.body.classList.add("gsp-sticky-atc-bar-minimalist-enabled");
      return;
    }
    const mql = GSP.config.device.queries.mobile;
    mql.onchange = this.checkDevice.bind(this);
    this.checkDevice();
    const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          document.body.classList.toggle("gsp-sticky-atc-bar-minimalist-enabled", !entry.isIntersecting);
        });
      },
      { threshold: 1, rootMargin }
    );
    this.observer.observe(this.productFormActions);
    this.syncWithMainProductForm();
  }
  checkDevice() {
    document.documentElement.style.setProperty("--gsp-sticky-atc-bar-minimalist-height", this.container.clientHeight + "px");
  }
  updatePrice() {
    const classes = {
      onSale: "gsp-price--on-sale",
      soldOut: "gsp-price--sold-out"
    };
    const selectors = {
      priceWrapper: ".gsp-product-price",
      salePrice: ".gsp-price-item--sale",
      compareAtPrice: [".gsp-price-item--regular"],
      unitPriceWrapper: ".gsp-price__unit-wrapper"
    };
    const moneyFormat2 = window.gspSetting.money_format;
    const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = gspTheme.helper.queryDomNodes(
      selectors,
      this
    );
    const unitPrice = unitPriceWrapper.querySelector(".gsp-price__unit");
    const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
    if (compare_at_price && compare_at_price > price) {
      priceWrapper.classList.add(classes.onSale);
    } else {
      priceWrapper.classList.remove(classes.onSale);
    }
    if (!this.currentVariant.available) {
      priceWrapper.classList.add(classes.soldOut);
    } else {
      priceWrapper.classList.remove(classes.soldOut);
    }
    if (salePrice) {
      salePrice.innerHTML = gspTheme.helper.formatMoney(price, moneyFormat2);
    }
    if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
      compareAtPrice.forEach(
        (item) => item.innerHTML = `<s>${gspTheme.helper.formatMoney(compare_at_price, moneyFormat2)}</s>`
      );
    } else {
      compareAtPrice.forEach((item) => item.innerHTML = gspTheme.helper.formatMoney(price, moneyFormat2));
    }
    if (unit_price_measurement && unitPrice) {
      unitPriceWrapper.classList.remove("hidden");
      const unitPriceContent = `<span>${gspTheme.helper.formatMoney(
        this.currentVariant.unit_price,
        moneyFormat2
      )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
      unitPrice.innerHTML = unitPriceContent;
    } else {
      unitPriceWrapper.classList.add("hidden");
    }
  }
  updateButton(disable = true, text, modifyClass = true) {
    const addButton = this.querySelector('[name="add"]');
    if (!addButton) return;
    const buttonTextElements = addButton.querySelectorAll(".btn-content span");
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        buttonTextElements.forEach((el) => {
          el.textContent = text;
        });
      }
    } else {
      addButton.removeAttribute("disabled");
      buttonTextElements.forEach((el) => {
        el.textContent = window.gspString.addToCartShort;
      });
    }
  }
  syncWithMainProductForm() {
    GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.variantChange,
      (event) => {
        const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
        if (!isMainProduct) return;
        const variant = event.data.variant;
        this.currentVariant = variant;
        this.updatePrice();
        this.updateButton(true, "", false);
        if (!variant) {
          this.updateButton(true, "", true);
        } else {
          this.updateButton(!variant.available, window.gspString.soldOut);
        }
      }
    );
  }
}
customElements.define("sticky-atc-bar-minimalist", StickyAtcBarMinimaListElement);
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.button.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.isCartPage = "cart" === window.gspSetting.templateName;
    const debouncedOnChange = gspTheme.helper.debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener("change", debouncedOnChange.bind(this));
    this.cartInner = this.closest(".gsp-cart__inner");
    this.cartWrapper = this.closest(".gsp-cart__wrapper");
    this.sectionId = gspTheme.helper.getSectionId(this);
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        return this.onCartUpdate(event);
      }
    );
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onCartUpdate(event) {
    if (event.cart.errors) {
      return;
    }
    this.cartUpdate(event.cart);
  }
  cartUpdate(parsedState) {
    const sectionId = gspTheme.helper.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(parsedState.sections[sectionId], "text/html");
    const selectors = [`#CartMainBody-${sectionId}`, `#CartMainEmpty-${sectionId}`];
    for (const selector of selectors) {
      const targetElement = document.querySelector(selector);
      const sourceElement = sectionToRender.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    }
    this.cartWrapper.classList.toggle("gsp-cart-empty", parsedState.item_count === 0);
    GSP.carousel.initMultiSwiper(this.cartWrapper);
    GSP.sticky.setSticky(".gsp-cart__footer.sticky > .gsp-cart__footer-inner", ".gsp-cart__footer.sticky");
    GSP.sticky.setSticky(".gsp-cart__body.sticky > .gsp-cart__body-inner", ".gsp-cart__body.sticky");
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.cartUpdated, {
      cart: parsedState,
      element: this.cartWrapper
    });
  }
  onChange(event) {
    const index = event.target.dataset.index;
    const inputValue = parseInt(event.target.value);
    this.updateQuantity(
      index,
      inputValue,
      event,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }
  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
      sections_url: window.location.pathname
    });
    fetch(`${window.gspSetting.routes.cart_change_url}`, { ...gspTheme.helper.fetchConfig(), ...{ body } }).then((response) => {
      return response.json();
    }).then((parsedState) => {
      const quantityElement = document.getElementById(`Quantity-${this.sectionId}-${line}`);
      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute("value");
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }
      const items = document.querySelectorAll(".gsp-cart-item");
      this.cartUpdate(parsedState);
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : void 0;
      let message = "";
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === "undefined") {
          message = window.gspString.cartError;
        } else {
          message = window.gspString.quantityError.replace("[quantity]", updatedValue);
        }
      }
      this.updateLiveRegions(line, message);
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cart: parsedState,
        variantId
      });
    }).catch(() => {
    }).finally(() => {
      this.disableLoading(line);
    });
  }
  updateLiveRegions(line, message) {
    let liveRegionElement = document.getElementById(`CartDrawer-Item-${line}`);
    let stickyNotification = false;
    let methodNotification = "afterEnd";
    if (this.isCartPage) {
      liveRegionElement = document.body;
      stickyNotification = true;
      methodNotification = "appendChild";
    }
    if (message !== "" && liveRegionElement) {
      gspNotification.show({
        target: liveRegionElement,
        message,
        type: "danger",
        method: methodNotification,
        icon: "circle_xmark",
        sticky: stickyNotification
      });
    }
  }
  enableLoading(line) {
    this.classList.add("gsp-cart__items--disabled");
    let cartItem = this.getCartItem(line);
    gspTheme.helper.enableLoadingSpiner(cartItem);
  }
  disableLoading(line) {
    this.classList.remove("gsp-cart__items--disabled");
    let cartItem = this.getCartItem(line);
    gspTheme.helper.disableLoadingSpinner(cartItem);
  }
  getCartItem(line) {
    return this.querySelector(`#CartItem-${line}`);
  }
}
customElements.define("cart-items", CartItems);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
  }
  getCartItem(line) {
    return this.querySelector(`#CartDrawer-Item-${line}`);
  }
  cartUpdate(parsedState) {
    const sectionId = gspTheme.helper.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(parsedState.sections[sectionId], "text/html");
    const selectors = [`#CartDrawerBody-${sectionId}`, `#CartDrawerEmpty-${sectionId}`, `#CartDrawerFooter-${sectionId}`, `#CartDrawerRecommendation-${sectionId}`];
    for (const selector of selectors) {
      const targetElement = document.querySelector(selector);
      const sourceElement = sectionToRender.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    }
    this.cartWrapper.classList.toggle("gsp-cart-empty", parsedState.item_count === 0);
    GSP.carousel.initMultiSwiper(this.cartWrapper);
    GSP.bsScript.tooltips(this.cartWrapper);
    if (parsedState.item_count) {
      const cartDrawer = this.cartWrapper.closest("cart-drawer");
      if (cartDrawer) {
        cartDrawer.toggleOverlayCartAddons();
      }
    }
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
class MainCartElement extends HTMLElement {
  getSectionToRenderListener = (event) => {
    event.detail.sections.push(gspTheme.helper.getSectionId(this));
  };
  handleTabletMatchListener = () => {
    this.loadTemplateContent(this.cartItemProducts, ".gsp-cart-product__info");
  };
  handleTabletUnMatchListener = () => {
    this.removeTemplateContent(this.cartItemProducts, ".gsp-cart-product__info");
  };
  cartUpdateUnsubscriber = void 0;
  cartItemProducts = null;
  constructor() {
    super();
    this.cartItemProducts = this.querySelectorAll(".gsp-cart-td__product");
  }
  connectedCallback() {
    document.addEventListener("cart:grouped-sections", this.getSectionToRenderListener);
    document.addEventListener("matchTablet", this.handleTabletMatchListener);
    document.addEventListener("unmatchTablet", this.handleTabletUnMatchListener);
    this.updateLayoutBasedOnConfig();
    this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.handleCartUpdate
    );
  }
  disconnectedCallback() {
    document.removeEventListener("cart:grouped-sections", this.getSectionToRenderListener);
    document.removeEventListener("matchTablet", this.handleTabletMatchListener);
    document.removeEventListener("unmatchTablet", this.handleTabletUnMatchListener);
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  handleCartUpdate = (event) => {
    if (event.source === "cart-items") {
      this.cartItemProducts = this.querySelectorAll(".gsp-cart-td__product");
      this.updateLayoutBasedOnConfig();
    }
  };
  updateLayoutBasedOnConfig() {
    if (!window.GSP || !GSP.config) return;
    if (GSP.config.device.tablet) {
      this.handleTabletMatchListener();
    } else {
      this.handleTabletUnMatchListener();
    }
  }
  loadTemplateContent(elements, parentSelector) {
    elements.forEach((element) => {
      const template = element.querySelector("template");
      const parent = element.querySelector(parentSelector);
      if (parent && template && !parent.querySelector(".template-content")) {
        const templateContent = document.importNode(template.content, true);
        const contentWrapper = document.createElement("div");
        contentWrapper.classList.add("template-content");
        contentWrapper.appendChild(templateContent);
        parent.appendChild(contentWrapper);
      }
    });
  }
  removeTemplateContent(elements, parentSelector) {
    elements.forEach((element) => {
      const parent = element.querySelector(parentSelector);
      const templateContent = parent?.querySelector(".template-content");
      if (templateContent) {
        parent.removeChild(templateContent);
      }
    });
  }
}
customElements.define("main-cart", MainCartElement);
class FreeShippingGoalElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      leftToSpend: "[data-left-to-spend]"
    };
    this.goal = Number(this.dataset.minimumAmount) * Number(window.Shopify.currency.rate || 1) || 0;
    this.progress = this.querySelector(".gsp-free-shipping-goal__bar");
    this.money_format = window.gspSetting.money_format;
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.updateShippingGloal(Number(this.dataset.cartTotal));
    this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        this.updateShippingGloal(event.cart.items_subtotal_price);
      }
    );
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  updateShippingGloal(amount) {
    if (amount > 0) {
      this.classList.remove("d-none");
    } else {
      this.classList.add("d-none");
    }
    this.cartTotal = amount / 100;
    this.goalLeft = this.goal - this.cartTotal;
    this.percent = this.cartTotal * 100 / this.goal;
    if (this.percent >= 100) this.percent = 100;
    if (this.cartTotal >= this.goal) {
      this.progress.style.setProperty("--percent", `${this.percent}%`);
      this.classList.add("gsp-free-shipping-goal--done");
      this.progress.dataset.value = this.cartTotal;
      this.progress.dataset.max = this.goal;
    } else {
      let spend = (this.goal - this.cartTotal) * 100;
      this.querySelector(this.selectors.leftToSpend).innerHTML = gspTheme.helper.formatMoney(
        spend,
        this.money_format
      );
      this.classList.remove("gsp-free-shipping-goal--done");
      this.progress.style.setProperty("--percent", `${this.percent}%`);
      this.progress.dataset.value = this.cartTotal;
      this.progress.dataset.max = this.goal;
    }
  }
}
customElements.define("free-shipping-goal", FreeShippingGoalElement);
class RecipientFormElement extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`);
    this.checkbox.disabled = false;
    this.controlField = this.querySelector(`#Recipient-Control-${this.dataset.sectionId}`);
    this.controlField.disabled = true;
    this.emailField = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
    this.nameField = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
    this.messageField = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
    this.sendOnField = this.querySelector(`#Recipient-send_on-${this.dataset.sectionId}`);
    this.errorWrapper = this.querySelector(".product-form__recipient-error-message-wrapper");
    this.errorList = this.errorWrapper && this.errorWrapper.querySelector("ul");
    this.errorMessage = this.errorWrapper && this.errorWrapper.querySelector(".error-message");
    this.defaultErrorMessage = this.errorMessage && this.errorMessage.innerText;
    this.currentVariantId = this.dataset.productVariantId;
    this.productId = this.dataset.productId;
    this.formFields = this.querySelector(".gsp-recipient-form__fields");
    this.addEventListener("change", this.onChange.bind(this));
  }
  unsubscribeCartUpdate = void 0;
  unsubscribeVariantChange = void 0;
  unsubscribeCartError = void 0;
  connectedCallback() {
    this.unsubscribeCartUpdate = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === "product-form" && event.productVariantId.toString() === this.currentVariantId) {
        this.resetRecipientForm();
      }
    });
    this.unsubscribeVariantChange = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.variantChange,
      (event) => {
        if (event.data.sectionId === this.dataset.sectionId) {
          this.currentVariantId = event.data.variant.id.toString();
        }
      }
    );
    this.unsubscribeCartError = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.cartError, (event) => {
      if (event.source === "product-form" && event.productVariantId.toString() === this.currentVariantId) {
        this.displayErrorMessage(event.message, event.errors);
      }
    });
  }
  disconnectedCallback() {
    this.unsubscribeCartUpdate && this.unsubscribeCartUpdate();
    this.unsubscribeVariantChange && this.unsubscribeVariantChange();
    this.unsubscribeCartError && this.unsubscribeCartError();
  }
  onChange() {
    if (!this.checkbox.checked) {
      this.clearInputFields();
      this.clearErrorMessage();
    }
  }
  displayErrorMessage(message, errors) {
    this.clearErrorMessage();
    if (Object.keys(errors).length > 1) {
      this.errorWrapper.hidden = false;
    }
    if (typeof errors === "object") {
      this.errorMessage.innerText = this.defaultErrorMessage;
      Object.entries(errors).forEach(([key, errorText]) => {
        const errorId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
        const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
        const inputField = this.querySelector(fieldSelector);
        if (inputField) {
          let errorMsg = `${inputField?.getAttribute("data-placeholder") || key} ${errorText}`;
          if (key === "send_on") {
            errorMsg = `${errorText}`;
          }
          const errorElement = this.querySelector(`#${errorId}`);
          if (errorElement) {
            errorElement.innerText = `${errorMsg}.`;
          }
          this.errorList && this.errorList.appendChild(this.createErrorListItem(fieldSelector, errorMsg));
          inputField.setAttribute("aria-invalid", true);
          inputField.setAttribute("aria-describedby", errorId);
          if (!inputField.classList.contains("is-invalid")) {
            inputField.classList.add("is-invalid");
          }
        }
      });
      return;
    }
    this.errorMessage.innerText = errors;
  }
  createErrorListItem(fieldSelector, message) {
    const listItem = document.createElement("li");
    const link = document.createElement("a");
    link.setAttribute("href", fieldSelector);
    link.classList.add("text-inherit");
    link.innerText = message;
    listItem.appendChild(link);
    listItem.className = "error-message";
    return listItem;
  }
  clearInputFields() {
    this.emailField.value = "";
    this.nameField.value = "";
    this.messageField.value = "";
    this.sendOnField.value = "";
  }
  clearErrorMessage() {
    this.errorWrapper.hidden = true;
    if (this.errorList) {
      this.errorList.innerHTML = "";
    }
    this.querySelectorAll(".gsp-recipient-form__fields .gsp-recipient-field").forEach((field) => {
      const input = field.querySelector(".form-field--input");
      const message = field.querySelector(".form-field--message");
      if (input && input.classList.contains("is-invalid")) {
        input.classList.remove("is-invalid");
      }
      message.innerText = "";
    });
    [this.emailField, this.messageField, this.nameField, this.sendOnField].forEach((input) => {
      input.setAttribute("aria-invalid", false);
      input.removeAttribute("aria-describedby");
    });
  }
  resetRecipientForm() {
    if (this.checkbox.checked) {
      this.checkbox.checked = false;
      this.clearInputFields();
      this.clearErrorMessage();
    }
  }
}
customElements.define("recipient-form", RecipientFormElement);
class ProductFormElement extends HTMLElement {
  constructor() {
    super();
    this.productIdInput = this.querySelector("[name=id]");
    this.productIdInput.disabled = false;
    this.onFormSubmitHandler = this.handleFormSubmit.bind(this);
    this.enableCartDrawer = window.gspSetting.shop.enable_add_to_cart_drawer;
    this.targetNotification = document.body;
    this.stickyNotification = true;
    if (this.enableCartDrawer) {
      this.targetNotification = this.cartItems;
      this.stickyNotification = false;
    }
    this.submitter = null;
  }
  connectedCallback() {
    this.formEl.addEventListener("submit", this.onFormSubmitHandler);
  }
  disconnectedCallback() {
    this.formEl.removeEventListener("submit", this.onFormSubmitHandler);
  }
  get submitEl() {
    return this._submitEl = this._submitEl || this.querySelector('[type="submit"]');
  }
  get formEl() {
    return this._formEl = this._formEl || this.querySelector("form");
  }
  handleFormSubmit = (event) => {
    event.preventDefault();
    this.submitter = event.submitter;
    if (this.submitEl.getAttribute("aria-disabled") === "true") return;
    gspTheme.helper.enableLoadingSpiner(this.submitEl);
    this.displayFormErrors();
    this.formData = new FormData(this.formEl);
    const formValidationResult = this.validateCustomFields(this.closest(".gsp-product-info"));
    if (formValidationResult && formValidationResult.length > 0) {
      this.handleCartError({
        message: window.gspString.requiredField,
        description: window.gspString.requiredField
      });
      return;
    }
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    const config = gspTheme.helper.fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    this.formData.append("sections", sectionsToBundle);
    config.body = this.formData;
    this.handleFormSubmission(config);
  };
  get isHideErrors() {
    return this.dataset.hideErrors === "true";
  }
  handleFormSubmission = (config) => {
    fetch(`${gspSetting.routes.cart_add_url}`, config).then((response) => response.json()).then(async (parsedState) => {
      if (parsedState.status) {
        this.handleCartError(parsedState);
        return;
      }
      try {
        const responseCart = await fetch("/cart.js");
        const cartJson = await responseCart.json();
        cartJson["sections"] = parsedState["sections"];
        this.updateCartState(cartJson);
        if (this.stickyNotification) {
          gspNotification.show({
            target: this.targetNotification,
            message: window.gspString.itemAdded,
            type: "success",
            method: "appendChild",
            icon: "circle_check",
            sticky: this.stickyNotification
          });
        }
      } catch (error) {
        this.displayFormErrors("Failed to fetch cart quantity");
      }
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      gspTheme.helper.disableLoadingSpinner(this.submitEl);
    });
  };
  handleCartError = (parsedState) => {
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.cartError, {
      source: "product-form",
      productVariantId: this.formData.get("id"),
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message
    });
    gspTheme.helper.disableLoadingSpinner(this.submitEl);
    this.displayFormErrors(parsedState.description);
    document.dispatchEvent(
      new CustomEvent("product-ajax:error", {
        detail: {
          errorMessage: parsedState.description
        }
      })
    );
    this.hasError = true;
  };
  resetFormState() {
    this.hasError = false;
    this.submitEl.removeAttribute("aria-disabled");
    this.displayFormErrors();
  }
  toggleSubmitButton(disable = true, text) {
    const buttonTextElements = this.submitEl.querySelectorAll(".btn-content span");
    if (disable) {
      this.submitEl.setAttribute("disabled", "disabled");
      if (text) {
        buttonTextElements.forEach((el) => {
          el.textContent = text;
        });
      }
    } else {
      this.submitEl.removeAttribute("disabled");
      buttonTextElements.forEach((el) => {
        el.textContent = window.gspString.addToCart;
      });
    }
  }
  displayFormErrors = (errorMessage = false) => {
    if (this.isHideErrors) return;
    if (typeof errorMessage === "object") {
      return;
    }
    this.formErrorMessage = this.formErrorMessage || this.querySelector(".gsp-product-form__error-message");
    if (!this.formErrorMessage) {
      if (errorMessage !== false) {
        alert(errorMessage);
      }
    } else {
      this.formErrorMessage.toggleAttribute("hidden", !errorMessage);
      if (errorMessage !== false) {
        this.formErrorMessage.innerText = errorMessage;
      }
    }
  };
  validateCustomFields(formElement) {
    const invalidFields = [];
    if (!formElement) return invalidFields;
    const customFields = formElement.querySelectorAll('[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])');
    customFields.forEach((field) => {
      const wrap = field.closest("[data-product-custom-field]");
      wrap.classList.remove("was-validated");
      if (field.type === "radio") {
        const radioGroup = formElement.querySelectorAll(`input[name="${field.name}"]`);
        const isRadioChecked = Array.from(radioGroup).some((radio) => radio.checked);
        if (!isRadioChecked) {
          invalidFields.push(field);
          wrap.classList.add("was-validated");
        }
      } else if (!field.value) {
        invalidFields.push(field);
        wrap.classList.add("was-validated");
      }
    });
    return invalidFields;
  }
  updateCartState = (cartJson) => {
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: "product-form",
      productVariantId: this.formData.get("id"),
      cart: cartJson,
      target: this
    });
  };
}
customElements.define("product-form", ProductFormElement);
class PricePerItemElement extends HTMLElement {
  updatePricePerItemUnsubscriber = void 0;
  variantIdChangedUnsubscriber = void 0;
  constructor() {
    super();
  }
  get sectionId() {
    return this.getAttribute("data-section-id");
  }
  get productId() {
    return this.getAttribute("data-product-id");
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    if (this.updatePricePerItemUnsubscriber) {
      this.updatePricePerItemUnsubscriber();
    }
    if (this.variantIdChangedUnsubscriber) {
      this.variantIdChangedUnsubscriber();
    }
  }
  init() {
    this.getVolumePricingArray();
    this.variantId = this.getAttribute("data-variant-id");
    this.input = document.getElementById(`Quantity-${this.sectionId || this.variantId}`);
    if (this.input) {
      this.input.addEventListener("change", this.onInputChange.bind(this));
    }
    this.variantIdChangedUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.variantChange,
      (event) => {
        this.variantId = event.data.variant.id.toString();
        this.getVolumePricingArray();
      }
    );
    this.updatePricePerItemUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
      (response) => {
        if (!response.cart) return;
        if (response.cart["variant_id"] !== void 0) {
          if (response.productVariantId === this.variantId) this.updatePricePerItem(response.cart.quantity);
        } else if (response.cart.item_count !== 0) {
          const isVariant = response.cart.items?.find((item) => item.variant_id.toString() === this.variantId);
          if (isVariant && isVariant.id.toString() === this.variantId) {
            this.updatePricePerItem(isVariant.quantity);
          } else {
            this.updatePricePerItem(0);
          }
        } else {
          this.updatePricePerItem(0);
        }
      }
    );
  }
  onInputChange() {
    this.updatePricePerItem();
  }
  updatePricePerItem(updatedCartQuantity) {
    if (this.input) {
      this.enteredQty = parseInt(this.input.value);
      this.step = parseInt(this.input.step);
    }
    this.currentQtyForVolumePricing = updatedCartQuantity === void 0 ? this.getCartQuantity(updatedCartQuantity) + this.enteredQty : this.getCartQuantity(updatedCartQuantity) + parseInt(this.step);
    if (this.classList.contains("variant-item__price-per-item")) {
      this.currentQtyForVolumePricing = this.getCartQuantity(updatedCartQuantity);
    }
    for (let pair of this.qtyPricePairs) {
      if (this.currentQtyForVolumePricing >= pair[0]) {
        const pricePerItemsCurrent = document.querySelectorAll(
          `price-per-item[id^="PricePerItem-${this.sectionId || this.variantId}"] .gsp-price-per-item--current`
        );
        pricePerItemsCurrent.forEach((pricePerItemCurrent) => {
          this.classList.contains("variant-item__price-per-item") ? pricePerItemCurrent.innerHTML = gspVolumePricingStrings.each.replace("[money]", pair[1]) : pricePerItemCurrent.innerHTML = pair[1];
        });
        break;
      }
    }
  }
  getCartQuantity(updatedCartQuantity) {
    return updatedCartQuantity || updatedCartQuantity === 0 ? updatedCartQuantity : parseInt(this.input.dataset.cartQuantity);
  }
  getVolumePricingArray() {
    const volumePricing = document.getElementById(`Volume-${this.sectionId || this.variantId}`);
    this.qtyPricePairs = [];
    if (volumePricing) {
      volumePricing.querySelectorAll("li").forEach((li) => {
        const qty = parseInt(li.querySelector("span:first-child").textContent);
        const price = li.querySelector("span:not(:first-child):last-child").dataset.text;
        this.qtyPricePairs.push([qty, price]);
      });
    }
    this.qtyPricePairs.reverse();
  }
}
customElements.define("price-per-item", PricePerItemElement);
class ProductQuantityInputElement extends HTMLElement {
  quantityUpdateUnsubscriber = void 0;
  quantityBoundriesUnsubscriber = void 0;
  quantityRulesUnsubscriber = void 0;
  constructor() {
    super();
  }
  get sectionId() {
    return this.getAttribute("data-section-id");
  }
  get productId() {
    return this.getAttribute("data-product-id");
  }
  get input() {
    return this.querySelector("input");
  }
  get value() {
    return this.input.value;
  }
  connectedCallback() {
    this.abortController = new AbortController();
    this.buttons = Array.from(this.querySelectorAll(".gsp-quantity__button"));
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.input.addEventListener("focus", () => setTimeout(() => this.input.select()));
    this.buttons.forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)), {
      signal: this.abortController.signal
    });
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
    this.quantityBoundriesUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.quantityBoundries,
      this.setQuantityBoundries.bind(this)
    );
    this.quantityRulesUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.quantityRules,
      this.updateQuantityRules.bind(this)
    );
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.quantityBoundriesUnsubscriber) {
      this.quantityBoundriesUnsubscriber();
    }
    if (this.quantityRulesUnsubscriber) {
      this.quantityRulesUnsubscriber();
    }
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const action = event.currentTarget.dataset.action;
    if (action === "plus") {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    if (this.input.dataset.min === previousValue && action === "minus") {
      this.input.value = parseInt(this.input.min);
    }
  }
  onInputChange() {
    if (this.input.value === "") {
      this.input.value = parseInt(this.input.min);
    }
    this.validateQtyRules();
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".gsp-quantity__button[data-action='minus']");
      if (buttonMinus) {
        buttonMinus.classList.toggle("disabled", parseInt(value) <= parseInt(this.input.min));
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[data-action='plus']");
      if (buttonPlus) {
        buttonPlus.classList.toggle("disabled", value >= max);
      }
    }
  }
  updateQuantityRules({ data: { sectionId, productId, parsedHTML } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const selectors = [".gsp-quantity__input", ".gsp-quantity__rules", ".gsp-quantity__label"];
    const quantityFormUpdated = parsedHTML.getElementById(`QuantityForm-${sectionId}`);
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated?.querySelector(selector);
      if (!current || !updated) continue;
      if (selector === ".gsp-quantity__input") {
        const attributes = ["data-cart-quantity", "data-min", "data-max", "step"];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }
  setQuantityBoundries({ data: { sectionId, productId } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const data = {
      cartQuantity: this.input.hasAttribute("data-cart-quantity") ? parseInt(this.input.getAttribute("data-cart-quantity")) : 0,
      min: this.input.hasAttribute("data-min") ? parseInt(this.input.getAttribute("data-min")) : 1,
      max: this.input.hasAttribute("data-max") ? parseInt(this.input.getAttribute("data-max")) : null,
      step: this.input.hasAttribute("step") ? parseInt(this.input.getAttribute("step")) : 1
    };
    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
    this.input.min = min;
    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute("max");
    }
    this.input.value = min;
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.quantityUpdate, void 0);
  }
}
customElements.define("quantity-input", ProductQuantityInputElement);
class ProductVariantSelectsElement extends HTMLElement {
  constructor() {
    super();
  }
  get selectedOptionValues() {
    return Array.from(this.querySelectorAll("select option[selected], .gsp-variant-picker input:checked")).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues
        }
      });
    });
  }
  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }
  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options).find((option) => option.getAttribute("selected")).removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target.closest(".gsp-variant-select").querySelector("[data-selected-value] > .gsp-swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchValue);
        selectedDropdownSwatchValue.classList.remove("gsp-swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset");
        selectedDropdownSwatchValue.classList.add("gsp-swatch--unavailable");
      }
      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target.closest(".gsp-variant-select").querySelector("[data-selected-value]");
      if (selectedSwatchValue) {
        selectedSwatchValue.innerHTML = value;
      }
    }
  }
}
customElements.define("variant-selects", ProductVariantSelectsElement);
class ProductMediaGalleryElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="GalleryViewer"]',
      thumbnails: '[id^="GalleryThumbnails"]',
      mediaList: '[id^="GalleryViewer"] .swiper-wrapper',
      mediaItems: [".product__media-item"]
    };
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
    this.handleUpdateSliderDraggableState = this.updateSliderDraggableState.bind(this);
    this.sliderInstance = null;
    this.thumbsInstance = null;
  }
  connectedCallback() {
    this.abortController = new AbortController();
    this.init();
  }
  disconnectedCallback() {
    this.abortController?.abort();
    this.destroySlider();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.mediaLayout = this.dataset.mediaLayout;
    this.onlyImage = this.dataset.onlyImage === "true";
    this.enableDesktopSlider = this.dataset.enableDesktopSlider === "true";
    this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === "true";
    this.enableImageZoom = this.dataset.enableImageZoom === "true";
    if (this.onlyImage) {
      return;
    }
    this.elements.viewer.addEventListener("gsp:swiper:afterInit", this.handleUpdateSliderDraggableState, {
      signal: this.abortController.signal
    });
    this.elements.viewer.addEventListener("gsp:swiper:realIndexChange", this.handleUpdateSliderDraggableState, {
      signal: this.abortController.signal
    });
    this.setSliderOptions();
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
  }
  updateMediaLayout() {
    const isMobile = this.mqlMobile.matches;
    let sliderMainNavWrapperEl = this.querySelector(".gsp-product-media-main-navigation");
    if (this.mediaLayout === "auto-width-carousel" || isMobile && this.enableMobileThumbnails === false) {
      sliderMainNavWrapperEl = this.querySelector(".gsp-product-media-main");
    }
    if (sliderMainNavWrapperEl) {
      this.sliderOptions.navigation = {
        nextEl: sliderMainNavWrapperEl.querySelector(".swiper-button-next"),
        prevEl: sliderMainNavWrapperEl.querySelector(".swiper-button-prev"),
        enabled: true
      };
    }
    this.destroySlider();
    if (isMobile || this.enableDesktopSlider) {
      this.initSlider();
    }
    let productInfo = this.closest("product-info");
    if (productInfo) {
      let currentVariant = this.getSelectedVariant(productInfo);
      if (currentVariant) {
        this.setActiveMedia(currentVariant);
      }
    }
  }
  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector("variant-selects [data-selected-variant]")?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true
    };
    this.thumbsOptions = {
      watchSlidesProgress: true,
      centerInsufficientSlides: true
    };
    if (this.mediaLayout === "vertical-carousel") {
      this.thumbsOptions = {
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        freeMode: true,
        mousewheel: {
          enabled: false
        }
      };
      this.thumbsOptions.breakpoints = {
        1024: {
          direction: "vertical",
          slidesPerView: "auto",
          spaceBetween: 10,
          centerInsufficientSlides: false
        },
        768: {
          direction: "horizontal",
          slidesPerView: "auto",
          spaceBetween: 10,
          centerInsufficientSlides: false
        }
      };
    }
  }
  initSlider() {
    if (this.sliderInstance) return;
    if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
      if (!this.thumbsInstance) {
        this.thumbsInstance = GSP.carousel.initSwiper(this.elements.thumbnails, this.thumbsOptions);
        this.sliderOptions.thumbs = {
          swiper: this.thumbsInstance,
          autoScrollOffset: 2
        };
      }
    }
    this.resetMediaItems();
    const isMobile = GSP.config.device.isMobile();
    const fadeLayouts = ["vertical-carousel", "carousel", "carousel-hide-thumbnails"];
    const useFade = isMobile ? this.enableMobileThumbnails : fadeLayouts.includes(this.mediaLayout);
    const options = useFade ? { ...this.sliderOptions, effect: "fade", fadeEffect: { crossFade: true } } : this.sliderOptions;
    this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, options);
  }
  destroySlider() {
    if (this.thumbsInstance && !this.thumbsInstance.destroyed) {
      this.thumbsInstance.destroy(true, true);
      this.thumbsInstance = null;
    }
    if (this.sliderInstance && !this.sliderInstance.destroyed) {
      this.sliderInstance.destroy(true, true);
      this.sliderInstance = null;
    }
  }
  setActiveMedia(variant) {
    if (this.onlyImage || !variant || !variant.hasOwnProperty("featured_media") || !variant.featured_media) return;
    if (this.sliderInstance) {
      const slideIndex = variant.featured_media.position || 0;
      this.sliderInstance.slideTo(slideIndex - 1);
    } else {
      this.sortMediaItems(variant);
    }
  }
  sortMediaItems(variant) {
    let newMedias = this.elements.mediaItems;
    newMedias.sort(function(a, b) {
      return a.dataset.mediaIndex - b.dataset.mediaIndex;
    });
    newMedias.some((media, index) => {
      if (media.dataset.mediaId == variant.featured_media.id) {
        const [element] = newMedias.splice(index, 1);
        newMedias.unshift(element);
        return true;
      }
    });
    this.elements.mediaList.innerHTML = "";
    newMedias.forEach((media) => {
      this.elements.mediaList.appendChild(media);
    });
    if (!GSP.config.device.isMobile() && this.context !== "quickview") {
      const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (selectedMedia) {
        window.scrollTo({ top: selectedMedia.offsetTop, behavior: "smooth" });
      }
    }
  }
  resetMediaItems() {
    let newMedias = this.elements.mediaItems;
    newMedias.sort(function(a, b) {
      return a.dataset.mediaIndex - b.dataset.mediaIndex;
    });
    this.elements.mediaList.innerHTML = "";
    newMedias.forEach((media) => {
      this.elements.mediaList.appendChild(media);
    });
  }
  toggleSliderDraggableState(swiper, isDraggable) {
    if (swiper.allowTouchMove !== isDraggable) {
      swiper.allowTouchMove = isDraggable;
    }
  }
  updateSliderDraggableState(event) {
    const { swiper } = event.detail;
    const { slides, activeIndex } = swiper;
    if (slides[activeIndex]) {
      const isModelMediaType = slides[activeIndex].dataset.mediaType === "model" || slides[activeIndex].dataset.mediaType === "external_video";
      this.toggleSliderDraggableState(swiper, !isModelMediaType);
    }
  }
  playActiveMedia(selected) {
    const deferredMedia = selected.querySelector("product-model");
    if (deferredMedia) deferredMedia.loadContent(false);
    const video = selected.querySelector("video-element");
    if (video) video.play();
  }
}
customElements.define("media-gallery", ProductMediaGalleryElement);
class ProductComplementaryElement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this._loaded || this._waiting) return;
    if (this.isVisible()) {
      this.start();
    } else {
      this.waitUntilVisible();
    }
  }
  disconnectedCallback() {
    this._visibilityObserver?.disconnect();
    this._waiting = false;
  }
  isVisible() {
    return this.checkVisibility ? this.checkVisibility() : this.getClientRects().length > 0;
  }
  waitUntilVisible() {
    this._waiting = true;
    this._visibilityObserver = new ResizeObserver(() => {
      if (!this.isVisible()) return;
      this._visibilityObserver.disconnect();
      this._waiting = false;
      this.start();
    });
    this._visibilityObserver.observe(this.parentElement || this);
  }
  start() {
    if (this._loaded) return;
    this._loaded = true;
    this.load();
  }
  async load() {
    const url = this.dataset.url;
    if (!url) return this.removeBlock();
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = gspTheme.helper.generateDomFromString(await response.text());
      const recommendations = html.querySelector(this.tagName);
      if (!recommendations || !recommendations.innerHTML.trim()) {
        return this.removeBlock();
      }
      this.innerHTML = recommendations.innerHTML;
      if (!this.querySelector(".gsp-product-card")) {
        return this.removeBlock();
      }
      this.initComponents();
    } catch (e) {
      console.error(e);
      this.removeBlock();
    }
  }
  initComponents() {
    GSP.bsScript.tooltips();
    if (this.hasAttribute("data-gsp-animation")) {
      GSP.animation.initManual(this);
    }
    if (window.gspSetting?.image_motion) {
      GSP.imageMotion.initManual(this);
    }
    if (this.hasAttribute("data-gsp-slider")) {
      this.navigation_id = this.dataset.navigationId;
      GSP.carousel.initSwiper(this.querySelector(".gsp-swiper"), {
        navigation: {
          nextEl: `#${this.navigation_id} .swiper-button-next`,
          prevEl: `#${this.navigation_id} .swiper-button-prev`
        }
      });
    }
  }
  removeBlock() {
    this.closest(".gsp-block")?.remove();
  }
}
if (!customElements.get("product-complementary")) {
  customElements.define("product-complementary", ProductComplementaryElement);
}
class ProductRecommendationsElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.abortController = null;
  }
  get section() {
    return this.closest(".shopify-section");
  }
  get isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }
  connectedCallback() {
    this.load();
  }
  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }
  load() {
    const url = this.dataset.url;
    if (!url || !this.isConnected) return;
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    fetch(url, {
      signal: this.abortController.signal,
      // Trong editor URL không đổi khi đổi setting => tránh dính cache cũ
      cache: this.isDesignMode ? "no-store" : "default"
    }).then((response) => {
      if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);
      return response.text();
    }).then((text) => {
      const html = gspTheme.helper.generateDomFromString(text);
      const recommendations = html.querySelector(this.tagName);
      if (!recommendations || !recommendations.innerHTML.trim().length) {
        this.showEmpty();
        return;
      }
      const totalProducts = recommendations.querySelectorAll(".gsp-product-card").length;
      if (totalProducts === 0) {
        this.showEmpty();
        return;
      }
      this.innerHTML = recommendations.innerHTML;
      this.totalProducts = totalProducts;
      this.showContent();
      GSP.bsScript.tooltips();
      if (this.hasAttribute("data-gsp-animation")) {
        GSP.animation.init();
      }
      if (window.gspSetting.image_motion) {
        GSP.imageMotion.init();
      }
      if (this.hasAttribute("data-gsp-slider")) {
        GSP.carousel.initMultiSwiper(this, ".gsp-swiper");
      }
    }).catch((e) => {
      if (e.name === "AbortError") return;
      console.error(e);
      this.showEmpty();
    });
  }
  showContent() {
    if (this.section) {
      this.section.classList.remove("no-product-recommendations");
    }
  }
  showEmpty() {
    this.innerHTML = "";
    if (this.section) {
      this.section.classList.add("no-product-recommendations");
    }
  }
}
customElements.define("product-recommendations", ProductRecommendationsElement);
class ProductInfoElement extends HTMLElement {
  quantityForm = void 0;
  pendingRequestUrl = null;
  preProcessHtmlCallbacks = [];
  postProcessHtmlCallbacks = [];
  constructor() {
    super();
  }
  onVariantChangeUnsubscriber = void 0;
  connectedCallback() {
    this.onVariantChangeUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
      this.handleOptionValueChange.bind(this)
    );
    this.initQuantityHandlers();
    this.currentVariant = this.getSelectedVariant(this);
    if (this.currentVariant) {
      this.updateMedia(this.currentVariant);
    }
  }
  disconnectedCallback() {
    if (this.onVariantChangeUnsubscriber) {
      this.onVariantChangeUnsubscriber();
    }
  }
  handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
    if (!this.contains(event.target)) return;
    this.resetProductFormState();
    const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
    const viewMode = this.dataset.viewMode || "main-product";
    const shouldSwapProduct = this.dataset.url !== productUrl;
    const shouldFetchFullPage = this.dataset.updateUrl === "true" && shouldSwapProduct;
    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
      targetId: target.id,
      callback: shouldSwapProduct ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode) : this.handleUpdateProductInfo(productUrl, viewMode)
    });
  }
  handleSwapProduct(productUrl, updateFullPage, viewMode) {
    return (html) => {
      const quickView = html.querySelector("#MainProduct-quick-view__content");
      if (quickView && viewMode === "quick-view") {
        html = quickView.content.cloneNode(true);
      }
      const selector = updateFullPage ? "product-info[id^='MainProduct']" : "product-info";
      const variant = this.getSelectedVariant(html.querySelector(selector));
      this.updateURL(productUrl, variant?.id);
      if (updateFullPage) {
        document.querySelector("head title").innerHTML = html.querySelector("head title").innerHTML;
        GSP.HTMLUpdateUtility.viewTransition(
          document.querySelector("main"),
          html.querySelector("main"),
          this.preProcessHtmlCallbacks,
          this.postProcessHtmlCallbacks
        );
        GSP.HTMLUpdateUtility.viewTransition(
          document.querySelector(".gsp-sticky-atc-bar-minimalist"),
          html.querySelector(".gsp-sticky-atc-bar-minimalist"),
          this.preProcessHtmlCallbacks,
          this.postProcessHtmlCallbacks
        );
      } else {
        GSP.HTMLUpdateUtility.viewTransition(
          this,
          html.querySelector("product-info"),
          this.preProcessHtmlCallbacks,
          this.postProcessHtmlCallbacks
        );
      }
      GSP.animation.init();
      this.currentVariant = variant;
    };
  }
  renderProductInfo({ requestUrl, targetId, callback }) {
    this.abortController?.abort();
    this.abortController = new AbortController();
    fetch(requestUrl, { signal: this.abortController.signal }).then((response) => response.text()).then((responseText) => {
      this.pendingRequestUrl = null;
      const html = new DOMParser().parseFromString(responseText, "text/html");
      callback(html);
    }).then(() => {
      document.querySelector(`#${targetId}`)?.focus();
    }).catch((error) => {
      if (error.name === "AbortError") {
        console.log("Fetch aborted by user");
      } else {
        console.error(error);
      }
    });
  }
  buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
    const params = [];
    !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(",")}`);
    }
    return `${url}?${params.join("&")}`;
  }
  handleUpdateProductInfo(productUrl, viewMode) {
    return (html) => {
      const quickView = html.querySelector("#MainProduct-quick-view__content");
      if (quickView && viewMode === "quick-view") {
        html = quickView.content.cloneNode(true);
      }
      const variant = this.getSelectedVariant(html);
      this.pickupAvailability?.update(variant);
      this.updateOptionValues(html);
      this.updateURL(productUrl, variant?.id);
      this.updateVariantInputs(variant?.id);
      if (!variant) {
        this.setUnavailable();
        return;
      }
      this.updateMedia(variant);
      const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
        const source = html.getElementById(`${id}-${this.sectionId}`);
        const destination = this.querySelector(`#${id}-${this.dataset.section}`);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.classList.toggle("hidden", shouldHide(source));
        }
      };
      updateSourceFromDestination("Price");
      updateSourceFromDestination("Availability");
      updateSourceFromDestination("Sku", ({ classList }) => classList.contains("hidden"));
      updateSourceFromDestination("Barcode", ({ classList }) => classList.contains("hidden"));
      updateSourceFromDestination("inventory", ({ innerText }) => innerText === "");
      updateSourceFromDestination("badges", ({ classList }) => classList.contains("hidden"));
      updateSourceFromDestination("PricePerItem", ({ classList }) => classList.contains("hidden"));
      updateSourceFromDestination("Volume");
      this.updateQuantityRules(this.sectionId, this.productId, html);
      this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove("hidden");
      this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove("hidden");
      GSP.HTMLUpdateUtility.viewTransition(
        document.querySelector(`#SizeChart-${this.sectionId}`),
        html.querySelector(`#SizeChart-${this.sectionId}`),
        this.preProcessHtmlCallbacks,
        this.postProcessHtmlCallbacks
      );
      const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.productForm?.toggleSubmitButton(addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true, window.gspString.soldOut);
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: this.sectionId,
          html,
          variant
        }
      });
    };
  }
  resetProductFormState() {
    const productForm = this.productForm;
    productForm?.resetFormState();
  }
  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector("variant-selects [data-selected-variant]")?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }
  get productForm() {
    return this.querySelector("product-form");
  }
  get variantSelectors() {
    return this.querySelector("variant-selects");
  }
  get sectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }
  get pickupAvailability() {
    return this.querySelector("pickup-availability");
  }
  get quantityInput() {
    return this.querySelector("quantity-input input");
  }
  get productId() {
    return this.getAttribute("data-product-id");
  }
  updateOptionValues(html) {
    const variantSelects = html.querySelector("variant-selects");
    if (variantSelects) {
      GSP.bsScript.tooltipsDispose(this.variantSelectors);
      GSP.HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
      GSP.bsScript.tooltips(this.variantSelectors);
    }
  }
  updateURL(url, variantId) {
    if (this.dataset.updateUrl !== "false" && typeof window.history.pushState === "function" && variantId) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("variant", variantId);
      window.history.pushState(null, null, currentUrl);
    }
  }
  updateVariantInputs(variantId) {
    this.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    ).forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = variantId ?? "";
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  setUnavailable() {
    this.productForm?.toggleSubmitButton(true, window.gspString.unavailable);
    const selectors = ["Price", "inventory", "Availability", "Sku", "Barcode", "Price-Per-Item", "Volume-Note", "Volume", "Quantity-Rules"].map((id) => `#${id}-${this.dataset.section}`).join(", ");
    document.querySelectorAll(selectors).forEach(({ classList }) => classList.add("hidden"));
  }
  updateMedia(variant) {
    const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
    if (!productMedia) return;
    const setActiveMedia = () => {
      if (typeof productMedia.setActiveMedia === "function") {
        productMedia.init();
        productMedia.setActiveMedia(variant);
        return true;
      }
      return false;
    };
    if (!setActiveMedia()) {
      this.timer = setInterval(() => {
        if (setActiveMedia()) {
          clearInterval(this.timer);
        }
      }, 100);
    }
  }
  initQuantityHandlers() {
    if (!this.quantityInput) return;
    this.setQuantityBoundries();
    if (!this.hasAttribute("data-original-section")) {
      this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
        GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
        this.fetchQuantityRules.bind(this)
      );
    }
  }
  fetchQuantityRules() {
    const currentVariantId = this.productForm?.productIdInput?.value;
    if (!currentVariantId) return;
    const quantityRulesCart = this.querySelector(".gsp-quantity__rules-cart");
    if (quantityRulesCart) {
      gspTheme.helper.enableLoadingSpiner(quantityRulesCart);
    }
    fetch(`${this.getAttribute("data-url")}?variant=${currentVariantId}&section_id=${this.sectionId}`).then((response) => response.text()).then((responseText) => {
      const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
      this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
    }).catch((error) => {
      console.error(error);
    }).finally(() => {
      if (quantityRulesCart) {
        gspTheme.helper.disableLoadingSpinner(quantityRulesCart);
      }
    });
  }
  updateQuantityRules(sectionId, productId, parsedHTML) {
    if (!this.quantityInput) return;
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.quantityRules, {
      data: {
        sectionId,
        productId,
        parsedHTML
      }
    });
    this.setQuantityBoundries();
  }
  setQuantityBoundries() {
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
      data: {
        sectionId: this.sectionId,
        productId: this.productId
      }
    });
  }
}
customElements.define("product-info", ProductInfoElement);
class PriceRangeElement extends HTMLElement {
  constructor() {
    super();
    this.minRangeInput = this.querySelector('input[type="range"]:first-child');
    this.maxRangeInput = this.querySelector('input[type="range"]:last-child');
    this.minPriceInput = this.querySelector('input[name="filter.v.price.gte"]');
    this.maxPriceInput = this.querySelector('input[name="filter.v.price.lte"]');
    this.minPriceLabel = this.querySelector(".gsp-facet-range__value--min");
    this.maxPriceLabel = this.querySelector(".gsp-facet-range__value--max");
    this.currencySymbol = this.dataset.currencySymbol || "";
    this.minPriceInput.addEventListener("focus", this.minPriceInput.select);
    this.maxPriceInput.addEventListener("focus", this.maxPriceInput.select);
    this.minPriceInput.addEventListener("change", this.handleInputMinChange.bind(this));
    this.maxPriceInput.addEventListener("change", this.handleInputMaxChange.bind(this));
    this.minRangeInput.addEventListener("change", this.handleRangeMinChange.bind(this));
    this.maxRangeInput.addEventListener("change", this.handleRangeMaxChange.bind(this));
    this.minRangeInput.addEventListener("input", this.handleRangeMinInput.bind(this));
    this.maxRangeInput.addEventListener("input", this.handleRangeMaxInput.bind(this));
  }
  handleRangeMinChange(event) {
    event.stopPropagation();
    this.minPriceLabel.textContent = `${this.currencySymbol}${event.target.value}`;
    this.minPriceInput.value = event.target.value;
    this.minPriceInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
  handleRangeMaxChange(event) {
    event.stopPropagation();
    this.maxPriceLabel.textContent = `${this.currencySymbol}${event.target.value}`;
    this.maxPriceInput.value = event.target.value;
    this.maxPriceInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
  handleInputMinChange(event) {
    event.preventDefault();
    event.target.value = Math.max(
      Math.min(parseInt(event.target.value), parseInt(this.maxPriceInput.value || event.target.max) - 1),
      event.target.min
    );
    this.minRangeInput.value = event.target.value;
    this.minRangeInput.parentElement.style.setProperty(
      "--gsp-facet-range-min",
      `${parseInt(this.minRangeInput.value) / parseInt(this.minRangeInput.max) * 100}%`
    );
  }
  handleInputMaxChange(event) {
    event.preventDefault();
    event.target.value = Math.min(
      Math.max(parseInt(event.target.value), parseInt(this.minPriceInput.value || event.target.min) + 1),
      event.target.max
    );
    this.maxRangeInput.value = event.target.value;
    this.maxRangeInput.parentElement.style.setProperty(
      "--gsp-facet-range-max",
      `${parseInt(this.maxRangeInput.value) / parseInt(this.maxRangeInput.max) * 100}%`
    );
  }
  handleRangeMinInput(event) {
    event.target.value = Math.min(
      parseInt(event.target.value),
      parseInt(this.maxPriceInput.value || event.target.max) - 1
    );
    event.target.parentElement.style.setProperty(
      "--gsp-facet-range-min",
      `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`
    );
    this.minPriceLabel.textContent = `${this.currencySymbol}${event.target.value}`;
    this.minPriceInput.value = event.target.value;
  }
  handleRangeMaxInput(event) {
    event.target.value = Math.max(
      parseInt(event.target.value),
      parseInt(this.minPriceInput.value || event.target.min) + 1
    );
    event.target.parentElement.style.setProperty(
      "--gsp-facet-range-max",
      `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`
    );
    this.maxPriceLabel.textContent = `${this.currencySymbol}${event.target.value}`;
    this.maxPriceInput.value = event.target.value;
  }
}
customElements.define("price-range", PriceRangeElement);
class LayoutSwitcherElement extends HTMLElement {
  constructor() {
    super();
    this.initLayoutMode();
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
  }
  get buttons() {
    return this.querySelectorAll("button");
  }
  get wrapper() {
    return this._wrapperEl = this._wrapperEl || this.closest(".gsp-listing");
  }
  onButtonClick(event) {
    const target = event.currentTarget ? event.currentTarget : event;
    const layoutMode = target.dataset.layoutMode;
    this.changeLayout(target, layoutMode);
    if (typeof window.history.pushState === "function") {
      var title = document.title;
      let currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("view-layout", layoutMode);
      window.history.pushState(null, title, currentUrl);
    }
    GSP.animation.initManual($(this.wrapper));
  }
  initLayoutMode() {
    let layoutMode = gspTheme.helper.getParam("view-layout");
    if (layoutMode == null) {
      layoutMode = this.dataset.currentLayout;
    }
    const target = this.querySelector(`button[data-layout-mode="${layoutMode}"]`);
    if (target) {
      this.changeLayout(target, layoutMode);
    }
  }
  changeLayout(target, layoutMode) {
    this.buttons.forEach((button) => {
      button.classList.remove("active");
    });
    target.classList.add("active");
    this.wrapper.setAttribute("data-gsl", layoutMode);
  }
}
customElements.define("layout-switcher", LayoutSwitcherElement);
class ColorSwatchElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      card: ".gsp-product-card",
      mainImg: ".gsp-product-thumb-primary img",
      swatches: ".swatch-item",
      variantImg: ".color-swatch--variant-image"
    };
    this.hoverTracker = null;
  }
  connectedCallback() {
    this.optionNodes = this.querySelectorAll(this.selectors.swatches);
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  init() {
    this.abortController = new AbortController();
    this.pcard = this.closest(this.selectors.card);
    this.mainImage = this.pcard.querySelector(this.selectors.mainImg);
    this.optionNodes.forEach((button) => {
      button.addEventListener("mouseenter", this.onMouseEnter.bind(this), {
        signal: this.abortController.signal
      });
    });
    this.pcard.addEventListener("pointerleave", this.onMouseLeave.bind(this), {
      signal: this.abortController.signal
    });
  }
  onMouseEnter(e) {
    const { target } = e;
    const variantImage = target.querySelector(this.selectors.variantImg);
    clearTimeout(this.hoverTracker);
    this.hoverTracker = setTimeout(() => {
      this.selected && this.selected.removeAttribute("aria-selected");
      target.setAttribute("aria-selected", true);
      this.selected = target;
      if (this.mainImage && variantImage) {
        this.mainImage.src = variantImage.src;
        this.mainImage.srcset = variantImage.srcset;
        this.pcard.classList.add("preview-swatch");
      }
    }, 50);
  }
  onMouseLeave(e) {
    if (!this.pcard.contains(e.relatedTarget) && e.relatedTarget && !e.relatedTarget.classList.contains("tooltip-arrow")) {
      this.pcard.classList.remove("preview-swatch");
    }
  }
}
customElements.define("color-swatch", ColorSwatchElement);
class GiftWrappingElement extends HTMLElement {
  constructor() {
    super();
    this.giftWrapProductId = this.dataset.giftWrapId;
    this.isGiftWrappingEnabled = this.dataset.giftWrapping;
    this.cartItemCount = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapItemCount = parseInt(this.getAttribute("gift-wraps-in-cart"));
  }
  connectedCallback() {
    this.initializeGiftWrapCheckbox();
    this.handleInitialGiftWrapState();
  }
  disconnectedCallback() {
  }
  initializeGiftWrapCheckbox() {
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
      event.target.checked ? this.addGiftWrap() : this.removeGiftWrap();
    });
  }
  handleInitialGiftWrapState() {
    if (this.cartItemCount == 1 && this.giftWrapItemCount > 0) {
      return this.removeGiftWrap();
    }
    if (this.giftWrapItemCount > 0 && this.isGiftWrappingEnabled.length == 0) {
      return this.addGiftWrap();
    }
    if (this.giftWrapItemCount == 0 && this.isGiftWrappingEnabled.length > 0) {
      return this.addGiftWrap();
    }
  }
  addGiftWrap() {
    gspTheme.helper.enableLoadingSpiner(this);
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 1
      },
      { "gift-wrapping": true },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }
  removeGiftWrap() {
    gspTheme.helper.enableLoadingSpiner(this);
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 0
      },
      { "gift-wrapping": "", "gift-note": "" },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }
  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
    );
    return sections;
  }
  createRequestBody(updates, attributes, sections) {
    return JSON.stringify({ updates, attributes, sections });
  }
  updateCart(body) {
    fetch(`${gspSetting.routes.cart_update_url}`, { ...gspTheme.helper.fetchConfig(), ...{ body } }).then((response) => response.json()).then((parsedState) => {
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
    }).finally(() => {
      gspTheme.helper.disableLoadingSpinner(this);
    }).catch((error) => {
      console.error("Error updating cart:", error);
    });
  }
}
customElements.define("gift-wrapping", GiftWrappingElement);
class GiftWrapCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.button.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (cartItems) {
        cartItems.enableLoading(this.dataset.index);
      }
      const giftWrappingElement = document.querySelector("gift-wrapping");
      if (giftWrappingElement) {
        giftWrappingElement.removeGiftWrap();
      }
    });
  }
}
customElements.define("gift-wrap-cart-remove-button", GiftWrapCartRemoveButton);
class GiftNoteElement extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", gspTheme.helper.debounce(this.updateGiftNote.bind(this), 300));
  }
  updateGiftNote(event) {
    const requestBody = JSON.stringify({ attributes: { "gift-note": event.target.value } });
    fetch(`${gspSetting.routes.cart_update_url}`, { ...gspTheme.helper.fetchConfig(), ...{ body: requestBody } });
  }
}
customElements.define("gift-note", GiftNoteElement);
class ProductModel extends HTMLElement {
  constructor() {
    super();
    this.isPlaying = false;
    this.abortController = new AbortController();
    const deferredPoster = this.querySelector('[id^="Deferred-Poster-"]');
    if (deferredPoster) {
      deferredPoster.addEventListener("click", this.loadContent.bind(this));
    }
  }
  connectedCallback() {
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      const modelViewer = content.querySelector("model-viewer");
      const deferredElement = this.querySelector(".gsp-media-model").appendChild(modelViewer);
      if (focus) deferredElement.focus();
    }
    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this)
      }
    ]);
  }
  playMedia() {
    this.isPlaying = true;
    this.modelViewerUI?.play();
  }
  pauseMedia() {
    this.isPlaying = false;
    this.modelViewerUI?.pause();
  }
  async setupModelViewerUI(errors) {
    if (errors) return;
    if (!Shopify.ModelViewerUI) {
      await this.waitForModelViewerUI();
    }
    if (!Shopify.ModelViewerUI) return;
    const element = this.querySelector("model-viewer");
    if (!element) return;
    const signal = this.abortController.signal;
    this.modelViewerUI = new Shopify.ModelViewerUI(element);
    if (!this.modelViewerUI) return;
    this.playMedia();
    let pointerStartX = 0;
    let pointerStartY = 0;
    element.addEventListener(
      "pointerdown",
      (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      },
      { signal }
    );
    element.addEventListener(
      "click",
      (event) => {
        const distanceX = Math.abs(event.clientX - pointerStartX);
        const distanceY = Math.abs(event.clientY - pointerStartY);
        const totalDistance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
        if (totalDistance < 10) {
          this.pauseMedia();
        }
      },
      { signal }
    );
  }
  async waitForModelViewerUI() {
    const maxAttempts = 10;
    const interval = 50;
    for (let i = 0; i < maxAttempts; i++) {
      if (Shopify.ModelViewerUI) {
        return;
      }
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  }
}
customElements.define("product-model", ProductModel);
window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this)
      }
    ]);
  },
  setupShopifyXR(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR());
      return;
    }
    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  }
};
window.addEventListener("DOMContentLoaded", () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    if (!GSP.config.state.hasLocalStorage) return;
    const productId = parseInt(this.dataset.productId);
    const cookieName = "pureveatheme:recently-viewed";
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (items.includes(productId)) {
      items.splice(items.indexOf(productId), 1);
    }
    items.unshift(productId);
    window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);
class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest(".shopify-section");
    this.isDesignMode = Shopify.designMode;
    this.initialized = false;
  }
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    if (!this.isDesignMode && this.isCartEmpty()) {
      this.removeSection();
      return;
    }
    this.init();
    this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        return this.onCartUpdate(event);
      }
    );
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  init() {
    const queryUrl = this.getQueryUrl();
    if (!queryUrl) {
      this.removeSection();
      return;
    }
    fetch(queryUrl).then((response) => response.text()).then((text) => {
      const html = gspTheme.helper.generateDomFromString(text);
      const recommendations = html.querySelector(this.tagName);
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        this.totalProducts = recommendations.querySelectorAll(".gsp-product-card").length;
        if (this.totalProducts > 0) {
          this.show();
          GSP.bsScript.tooltips();
          if (this.hasAttribute("data-gsp-animation")) {
            GSP.animation.init();
          }
          if (window.gspSetting.image_motion) {
            GSP.imageMotion.init();
          }
          if (this.hasAttribute("data-gsp-slider")) {
            GSP.carousel.initMultiSwiper(this, ".gsp-swiper");
          }
        } else {
          this.removeSection();
        }
      } else {
        this.removeSection();
      }
    }).catch((e) => {
      console.error(e);
      this.removeSection();
    });
  }
  getQueryUrl() {
    const items = JSON.parse(window.localStorage.getItem("pureveatheme:recently-viewed") || "[]");
    const productId = parseInt(this.dataset.productId);
    const productsToShow = parseInt(this.dataset.productsToShow);
    if (items.includes(productId)) {
      items.splice(items.indexOf(productId), 1);
    }
    if (items.length > 0) {
      const queryParams = items.map((item) => "id:" + item).slice(0, productsToShow).join(" OR ");
      return this.dataset.url + queryParams;
    }
    return false;
  }
  removeSection() {
    this.section.remove();
  }
  show() {
    this.section.classList.add("show");
  }
  isCartEmpty() {
    if (!this.isCartPage()) {
      return false;
    }
    return document.querySelector(".gsp-cart__empty-content") !== null;
  }
  isCartPage() {
    return document.body.classList.contains("template-cart");
  }
  onCartUpdate(event) {
    if (!this.isCartPage() || this.isDesignMode) {
      return;
    }
    if (event.cart.errors) {
      return;
    }
    if (event.cart.item_count === 0) {
      this.removeSection();
    }
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);
class VideoTestimonials extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.abortController = new AbortController();
    this.videos = [...document.querySelectorAll("video-element")];
    this.modal = document.querySelector("popup-video-testinonials");
    this.videos.forEach((video) => {
      video.addEventListener("click", this.onVideoClickHandler.bind(this), {
        signal: this.abortController.signal
      });
    });
    document.addEventListener(
      "shopify:block:select",
      () => {
        this.ignoreNextClick = true;
        requestAnimationFrame(() => {
          this.ignoreNextClick = false;
        });
      },
      {
        signal: this.abortController.signal
      }
    );
  }
  disconnectedCallback() {
    this.abortController?.abort();
  }
  onVideoClickHandler(event) {
    if (this.ignoreNextClick) {
      return;
    }
    const currentVideo = event.currentTarget;
    const index = this.videos.indexOf(currentVideo);
    this.modal.currentIndex = index;
    this.modal.show();
  }
}
customElements.define("video-testimonials", VideoTestimonials);
class PopupVideoTestinonials extends ModalComponent {
  connectedCallback() {
    super.connectedCallback();
    this.sliderInstance = false;
    this.thumbsInstance = false;
    this.currentIndex = 0;
    this.selectors = {
      viewer: '[id^="GalleryViewer"]',
      thumbnails: '[id^="GalleryThumbnails"]'
    };
    this.init();
  }
  onShowHandler() {
    this.initSlider();
  }
  onShownHandler() {
    this.setActiveMedia();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.setSliderOptions();
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true
      }
    };
    this.thumbsOptions = {
      watchSlidesProgress: true
    };
  }
  initSlider() {
    if (typeof this.sliderInstance !== "object") {
      if (typeof this.thumbsInstance !== "object") {
        this.thumbsInstance = GSP.carousel.initSwiper(this.elements.thumbnails, this.thumbsOptions);
        this.sliderOptions.thumbs = {
          swiper: this.thumbsInstance,
          autoScrollOffset: 2
        };
      }
      this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
      this.handleSlideChange();
    }
  }
  setActiveMedia() {
    if (this.sliderInstance) {
      this.sliderInstance.slideTo(this.currentIndex);
      requestAnimationFrame(() => {
        const activeSlide = this.sliderInstance.slides[this.sliderInstance.activeIndex];
        if (activeSlide) {
          this.playActiveMedia(activeSlide);
        }
      });
    }
  }
  playActiveMedia(selected) {
    const video = selected.querySelector("video-element");
    if (video) video.play();
  }
  handleSlideChange() {
    this.sliderInstance.on("realIndexChange", (swiper) => {
      const { slides, activeIndex, thumbs } = swiper;
      if (slides[activeIndex]) {
        this.playActiveMedia(slides[activeIndex]);
      }
    });
  }
  designMode() {
  }
}
customElements.define("popup-video-testinonials", PopupVideoTestinonials);
class ShoppableVideos extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="ShoppableVideosSlider"]'
    };
    this.sliderInstance = null;
    this.abortController = new AbortController();
    this._mediaLayoutRaf = null;
    this._playingSlide = null;
    this._playMediaTimer = null;
    this.handleUpdateMediaLayout = this.scheduleUpdateMediaLayout.bind(this);
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this._mediaLayoutRaf) {
      cancelAnimationFrame(this._mediaLayoutRaf);
      this._mediaLayoutRaf = null;
    }
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.setSliderOptions();
    this._inView = false;
    GSP.Motion.inView(this.elements.viewer, () => {
      this._inView = true;
      this.playActiveMedia();
      return () => {
        this._inView = false;
      };
    });
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.mqlLaptop = GSP.config.device.queries.laptop;
    this.mqlLaptop.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.mqlSmallDesktop = GSP.config.device.queries.smallDesktop;
    this.mqlSmallDesktop.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.elements.viewer.addEventListener("gsp:swiper:afterInit", (event) => {
      const { swiper } = event.detail;
      this.sliderInstance = swiper;
      this.sliderAfterInit();
    }, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true
    };
  }
  canLoop() {
    let canLoop = false;
    if (GSP.core.isDeviceUp("md")) {
      const containerWidth = this.elements.viewer.offsetWidth;
      const firstSlideWidth = this.elements.viewer.querySelector(".swiper-slide").offsetWidth;
      const visibleSlides = Math.ceil(containerWidth / firstSlideWidth);
      const slideCount = this.querySelectorAll(".swiper-slide").length;
      canLoop = slideCount >= visibleSlides;
    }
    return canLoop;
  }
  isCreative() {
    return GSP.core.isDeviceUp("md");
  }
  updateMediaLayout() {
    if (GSP.core.isDeviceDown("md")) {
      this.sliderOptions.scrollbar = {
        el: this.querySelector(".shoppable-videos-swiper-pagination-mobile"),
        enabled: true,
        draggable: true
      };
    } else {
      this.sliderOptions.pagination = {
        el: this.querySelector(".shoppable-videos-swiper-pagination"),
        clickable: true,
        enabled: true,
        type: "timeline"
      };
    }
    this.destroySlider();
    this.sliderOptions.loop = this.canLoop();
    this.elements.viewer.classList.remove("shoppable-videos-swiper-creative--active");
    this.elements.viewer.classList.toggle("shoppable-videos-swiper-creative", this.isCreative());
    this.initSlider();
  }
  initSlider() {
    if (this.sliderInstance) {
      return;
    }
    this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
  }
  destroySlider() {
    this.elements.viewer.classList.remove("shoppable-videos-swiper-creative--active");
    if (this._playMediaTimer) {
      clearTimeout(this._playMediaTimer);
      this._playMediaTimer = null;
    }
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
      this.sliderInstance = null;
    }
    if (this._playingSlide) {
      this.pauseMediaOn(this._playingSlide);
      this._playingSlide = null;
    }
  }
  updateSlidesHeight() {
    const swiper = this.sliderInstance;
    const { slides, activeIndex } = swiper;
    const activeHeight = slides[activeIndex].offsetHeight;
    this.elements.viewer.style.setProperty(
      "--shoppable-videos-height",
      `${activeHeight}px`
    );
    this.elements.viewer.classList.add("shoppable-videos-swiper-creative--active");
  }
  playActiveMedia() {
    if (!this.sliderInstance) {
      return;
    }
    const activeSlide = this.sliderInstance.slides[this.sliderInstance.activeIndex];
    if (!activeSlide) {
      return;
    }
    if (activeSlide === this._playingSlide) {
      return;
    }
    if (this._playingSlide) {
      this.pauseMediaOn(this._playingSlide);
    }
    const video = activeSlide.querySelector("video-element");
    if (video) {
      video.play();
      this._playingSlide = activeSlide;
    }
  }
  pauseMediaOn(slideEl) {
    if (!slideEl) {
      return;
    }
    const video = slideEl.querySelector("video-element");
    if (!video) {
      return;
    }
    const nativeVideo = video.querySelector("video");
    if (nativeVideo) {
      nativeVideo.pause();
      nativeVideo.currentTime = 0;
      video.removeAttribute("playing");
    } else {
      video.pause();
    }
  }
  scheduleUpdateMediaLayout() {
    if (this._mediaLayoutRaf) {
      cancelAnimationFrame(this._mediaLayoutRaf);
    }
    this._mediaLayoutRaf = requestAnimationFrame(() => {
      this._mediaLayoutRaf = null;
      this.updateMediaLayout();
    });
  }
  sliderAfterInit() {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    if (this.elements.viewer.classList.contains("shoppable-videos-swiper-creative")) {
      this.updateSlidesHeight();
    }
    if (this._inView) {
      this.playActiveMedia();
    }
    swiper.on("slideChange", () => {
      this.handleSlideChange();
    });
    swiper.on("slideChangeTransitionEnd", () => {
      this.handleSlideChangeTransitionEnd();
    });
  }
  handleSlideChange() {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    const speed = Number(swiper.params.speed) || 0;
    if (speed > 0 && !swiper.animating) {
      return;
    }
    if (this._playMediaTimer) {
      clearTimeout(this._playMediaTimer);
      this._playMediaTimer = null;
    }
    this._playMediaTimer = setTimeout(() => {
      this._playMediaTimer = null;
      if (!swiper.destroyed) {
        this.playActiveMedia();
      }
    }, speed + 50);
  }
  handleSlideChangeTransitionEnd() {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    if (this._playMediaTimer) {
      clearTimeout(this._playMediaTimer);
      this._playMediaTimer = null;
    }
    this.playActiveMedia();
  }
}
customElements.define("shoppable-videos", ShoppableVideos);
class ShoppableVideosGallery extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="ShoppableVideosSlider"]'
    };
    this.sliderInstance = null;
    this.abortController = new AbortController();
    this.autoplay = false;
    this.autoplayDelay = 3e3;
    this.autoplayTimer = null;
    this.loopedSlides = 0;
    this._mediaLayoutRaf = null;
    this._playingSlide = null;
    this._playActiveMediaTimer = null;
    this._slidesHeightTimer = null;
    this._lastSlideChangeAt = 0;
    this._resizeObserver = null;
    this.handleUpdateMediaLayout = this.scheduleUpdateMediaLayout.bind(this);
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this._mediaLayoutRaf) {
      cancelAnimationFrame(this._mediaLayoutRaf);
      this._mediaLayoutRaf = null;
    }
    if (this._playActiveMediaTimer) {
      clearTimeout(this._playActiveMediaTimer);
      this._playActiveMediaTimer = null;
    }
    if (this._slidesHeightTimer) {
      clearTimeout(this._slidesHeightTimer);
      this._slidesHeightTimer = null;
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
  }
  scheduleUpdateMediaLayout() {
    if (this._mediaLayoutRaf) {
      cancelAnimationFrame(this._mediaLayoutRaf);
    }
    this._mediaLayoutRaf = requestAnimationFrame(() => {
      this._mediaLayoutRaf = null;
      this.updateMediaLayout();
    });
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.setSliderOptions();
    this._inView = false;
    this._hovering = false;
    this._dragging = false;
    GSP.Motion.inView(this.elements.viewer, () => {
      this._inView = true;
      this.syncAutoplay();
      this.playActiveMedia();
      return () => {
        this._inView = false;
        this.stopAutoplay();
      };
    });
    this.elements.viewer.addEventListener("mouseenter", () => {
      this._hovering = true;
      this.syncAutoplay();
    }, {
      signal: this.abortController.signal
    });
    this.elements.viewer.addEventListener("mouseleave", () => {
      this._hovering = false;
      this.syncAutoplay();
    }, {
      signal: this.abortController.signal
    });
    this.elements.viewer.addEventListener("touchend", (event) => {
      this.resumeSuspendedOnGesture(event);
    }, {
      passive: true,
      signal: this.abortController.signal
    });
    this.elements.viewer.addEventListener("gsp:swiper:afterInit", (event) => {
      const { swiper } = event.detail;
      this.sliderInstance = swiper;
      this.initLoop();
      swiper.on("slideChange", () => {
        this._lastSlideChangeAt = Date.now();
      });
      if (this.elements.viewer.classList.contains("shoppable-videos-swiper-creative")) {
        this.updateSlidesHeight();
        this.scheduleSlidesHeightUpdate(700);
      }
    }, {
      signal: this.abortController.signal
    });
    const handleTransitionSettled = () => {
      if (this.loopedSlides) {
        this.releaseNavLockAndFix();
      }
      this.playActiveMedia();
      this.scheduleSlidesHeightUpdate(700);
      this._dragging = false;
      this.syncAutoplay();
    };
    this.elements.viewer.addEventListener("gsp:swiper:slideChangeTransitionEnd", handleTransitionSettled, {
      signal: this.abortController.signal
    });
    this.elements.viewer.addEventListener("gsp:swiper:transitionEnd", handleTransitionSettled, {
      signal: this.abortController.signal
    });
    this.elements.viewer.addEventListener("gsp:swiper:sliderMove", (event) => {
      this._dragging = true;
      this.stopAutoplay();
      if (this.loopedSlides) {
        this.loopFixDuringDrag();
      }
    }, {
      signal: this.abortController.signal
    });
    if ("ResizeObserver" in window) {
      this._resizeObserver = new ResizeObserver(() => this.scheduleSlidesHeightUpdate());
      this._resizeObserver.observe(this.elements.viewer);
    }
    if (document.readyState !== "complete") {
      window.addEventListener("load", () => this.scheduleSlidesHeightUpdate(), {
        once: true,
        signal: this.abortController.signal
      });
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.scheduleSlidesHeightUpdate());
    }
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.mqlLaptop = GSP.config.device.queries.laptop;
    this.mqlLaptop.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.mqlSmallDesktop = GSP.config.device.queries.smallDesktop;
    this.mqlSmallDesktop.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
  }
  scheduleSlidesHeightUpdate(delay = 150) {
    clearTimeout(this._slidesHeightTimer);
    this._slidesHeightTimer = setTimeout(() => {
      this._slidesHeightTimer = null;
      this.updateSlidesHeight();
    }, delay);
  }
  updateSlidesHeight() {
    const swiper = this.sliderInstance;
    const viewer = this.elements.viewer;
    if (!swiper || swiper.destroyed || !viewer.classList.contains("shoppable-videos-swiper-creative")) {
      return;
    }
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) {
      return;
    }
    const activeClass = "shoppable-videos-swiper-creative--active";
    if (viewer.classList.contains(activeClass)) {
      const elapsed = Date.now() - this._lastSlideChangeAt;
      if (elapsed < 650) {
        this.scheduleSlidesHeightUpdate(650 - elapsed + 50);
        return;
      }
    }
    const activeHeight = activeSlide.offsetHeight;
    if (activeHeight > 0) {
      const current = parseFloat(viewer.style.getPropertyValue("--shoppable-videos-height"));
      if (!(Math.abs(current - activeHeight) < 1)) {
        viewer.style.setProperty("--shoppable-videos-height", `${activeHeight}px`);
      }
    }
    viewer.classList.add(activeClass);
  }
  updateMediaLayout() {
    this.stopAutoplay();
    this.destroySlider();
    this.elements.viewer.classList.remove("shoppable-videos-swiper-creative--active");
    this.elements.viewer.classList.toggle("shoppable-videos-swiper-creative", !GSP.config.device.isMobile());
    this.initSlider();
  }
  initSlider() {
    if (!this.sliderInstance) {
      if (GSP.config.device.isMobile()) {
        this.sliderOptions.centeredSlides = false;
        this.sliderOptions.scrollbar = {
          el: this.querySelector(".shoppable-videos-swiper-pagination-mobile"),
          enabled: true,
          draggable: true
        };
        if (this.options.autoplay && this.options.autoplay.enabled) {
          this.sliderOptions.autoplay = {
            enabled: true
          };
          this.autoplay = false;
        }
        this.sliderOptions.loop = true;
      } else {
        this.sliderOptions.loop = false;
        this.sliderOptions.centeredSlides = true;
        this.sliderOptions.centeredSlidesStart = true;
        this.sliderOptions.centeredSlidesBounds = false;
        this.sliderOptions.scrollbar = {
          enabled: false
        };
        if (this.options.autoplay && this.options.autoplay.enabled) {
          this.sliderOptions.autoplay = {
            enabled: false
          };
          this.autoplay = true;
          this.autoplayDelay = this.options.autoplay.delay;
        }
      }
      this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
    }
  }
  setSliderOptions() {
    try {
      this.options = JSON.parse(this.elements.viewer.dataset.swiperOptions || "{}");
    } catch (error) {
      console.warn("Invalid swiper options:", error);
      this.options = {};
    }
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true,
      loop: false
    };
  }
  destroySlider() {
    if (this._playActiveMediaTimer) {
      clearTimeout(this._playActiveMediaTimer);
      this._playActiveMediaTimer = null;
    }
    if (this.sliderInstance) {
      this.destroyLoop();
      this.sliderInstance.destroy(true, true);
      this.sliderInstance = null;
    }
    if (this._playingSlide) {
      this.pauseMediaOn(this._playingSlide);
      this._playingSlide = null;
    }
  }
  playActiveMedia() {
    if (this._playActiveMediaTimer) {
      clearTimeout(this._playActiveMediaTimer);
    }
    this._playActiveMediaTimer = setTimeout(() => {
      this._playActiveMediaTimer = null;
      this.commitActiveMedia();
    }, 100);
  }
  commitActiveMedia() {
    if (!this.sliderInstance) {
      return;
    }
    const activeSlide = this.sliderInstance.slides[this.sliderInstance.activeIndex];
    if (!activeSlide) {
      return;
    }
    if (activeSlide.classList.contains("swiper-slide-duplicate")) {
      return;
    }
    const video = activeSlide.querySelector("video-element");
    if (activeSlide === this._playingSlide) {
      const nativeVideo = video && video.querySelector("video");
      if (!nativeVideo || !nativeVideo.paused) {
        return;
      }
    }
    if (this._playingSlide && this._playingSlide !== activeSlide) {
      this.pauseMediaOn(this._playingSlide);
    }
    if (video) {
      if (typeof video.play !== "function") {
        customElements.upgrade(video);
      }
      if (typeof video.play === "function" || video.querySelector("video")) {
        this._playingSlide = activeSlide;
        this.playVideoElement(video, activeSlide);
      } else {
        queueMicrotask(() => this.commitActiveMedia());
      }
    }
  }
  // iOS Safari only allows play() without a user gesture when the video
  // is muted AND inline. On top of that, <video-element> has two traps:
  //  - its `playing` attribute is set on the native "play" event, which
  //    fires as soon as play() is called, even if iOS then stalls the
  //    video (not loaded / deferred). Its play() is guarded by
  //    `if (!this.playing)`, so a stalled video can never be restarted.
  //  - it swallows play() rejections internally.
  // So we verify real playback ourselves and, if needed, recover by
  // talking to the native <video> directly.
  playVideoElement(video, slide, attempt = 0) {
    const nativeVideo = video.querySelector("video");
    if (nativeVideo) {
      nativeVideo.setAttribute("playsinline", "");
      nativeVideo.setAttribute("webkit-playsinline", "");
      nativeVideo.playsInline = true;
      nativeVideo.disableRemotePlayback = true;
    }
    if (attempt > 0 && typeof video.mute === "function" && !video.muted) {
      video.mute();
    }
    try {
      if (attempt === 0) {
        video.play();
      }
    } catch (error) {
    }
    this.verifyPlayback(video, slide, attempt);
  }
  verifyPlayback(video, slide, attempt) {
    setTimeout(() => {
      if (!this.sliderInstance || this.sliderInstance.destroyed) {
        return;
      }
      if (this.sliderInstance.slides[this.sliderInstance.activeIndex] !== slide) {
        return;
      }
      const nv = video.querySelector("video");
      const reallyPlaying = nv && !nv.paused && nv.readyState >= 3 && nv.currentTime > 0;
      if (reallyPlaying) {
        video.setAttribute("playing", "");
        return;
      }
      if (attempt >= 3) {
        return;
      }
      if (!nv) {
        this.playVideoElement(video, slide, attempt + 1);
        return;
      }
      nv.muted = true;
      nv.defaultMuted = true;
      if (!video.muted) {
        video.setAttribute("muted", "");
      }
      if (attempt >= 1 && nv.readyState === 0) {
        try {
          nv.load();
        } catch (e) {
        }
      }
      const promise = nv.play();
      if (promise && typeof promise.catch === "function") {
        promise.catch((error) => {
        });
      }
      this.verifyPlayback(video, slide, attempt + 1);
    }, attempt === 0 ? 500 : 700);
  }
  resumeSuspendedOnGesture(event) {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    if (event.target && event.target.closest && event.target.closest("button, a")) {
      return;
    }
    const slide = swiper.slides[swiper.activeIndex];
    const video = slide && slide.querySelector("video-element");
    if (!video || !video.hasAttribute("suspended") || video.paused === true) {
      return;
    }
    const nativeVideo = video.querySelector("video");
    if (nativeVideo && nativeVideo.paused) {
      const promise = nativeVideo.play();
      if (promise && typeof promise.catch === "function") {
        promise.catch(() => {
        });
      }
    }
    this._playingSlide = slide;
  }
  pauseMediaOn(slideEl) {
    if (!slideEl) {
      return;
    }
    const video = slideEl.querySelector("video-element");
    if (!video) {
      return;
    }
    const nativeVideo = video.querySelector("video");
    if (nativeVideo) {
      nativeVideo.pause();
      nativeVideo.currentTime = 0;
      video.removeAttribute("playing");
    } else {
      video.pause();
    }
  }
  initLoop() {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    if (this.autoplay) {
      this.stopAutoplay();
      swiper.on("navigationNext navigationPrev", () => {
        if (this._inView) {
          this.syncAutoplay();
        }
      });
    }
    this.destroyLoop();
    this.createLoop();
    this.loopFix();
    if (this._inView) {
      this.syncAutoplay();
      this.playActiveMedia();
    }
    if (this.loopedSlides === 0) {
      return;
    }
    this._navLocked = false;
    this._navLockTimeout = null;
    const originalSlideNext = swiper.slideNext.bind(swiper);
    const originalSlidePrev = swiper.slidePrev.bind(swiper);
    swiper.slideNext = (...args) => {
      if (this._navLocked) {
        return false;
      }
      this.lockNav();
      return originalSlideNext(...args);
    };
    swiper.slidePrev = (...args) => {
      if (this._navLocked) {
        return false;
      }
      this.lockNav();
      return originalSlidePrev(...args);
    };
    const originalUpdateSlidesClasses = swiper.updateSlidesClasses.bind(swiper);
    swiper.updateSlidesClasses = () => {
      originalUpdateSlidesClasses();
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
    };
  }
  lockNav() {
    const swiper = this.sliderInstance;
    this._navLocked = true;
    clearTimeout(this._navLockTimeout);
    const speed = swiper && swiper.params && swiper.params.speed || 300;
    this._navLockTimeout = setTimeout(() => {
      this.releaseNavLockAndFix();
    }, speed + 200);
  }
  releaseNavLockAndFix() {
    clearTimeout(this._navLockTimeout);
    this.loopFix();
    this._navLocked = false;
  }
  startAutoplay() {
    if (!this.autoplay) {
      return;
    }
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed || !this.loopedSlides) {
      return;
    }
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      if (!this.sliderInstance || this.sliderInstance.destroyed) {
        this.stopAutoplay();
        return;
      }
      this.sliderInstance.slideNext();
    }, this.autoplayDelay);
  }
  // Single source of truth for whether autoplay should be running.
  // Hover and drag are tracked separately because a drag can outlast
  // a stray mouseleave fired mid-gesture (cursor crossing the edge
  // while the mouse button is still held) — either one being "active"
  // must keep autoplay paused.
  syncAutoplay() {
    if (this._inView && !this._hovering && !this._dragging) {
      this.startAutoplay();
    } else {
      this.stopAutoplay();
    }
  }
  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
  destroyLoop() {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    const { slidesEl } = swiper;
    const duplicates = Array.from(slidesEl.querySelectorAll(".swiper-slide-duplicate"));
    duplicates.forEach((el) => {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });
    swiper.recalcSlides();
    swiper.updateSlides();
    this.loopedSlides = 0;
  }
  createLoop() {
    if (GSP.config.device.isMobile()) {
      return;
    }
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    const { slidesEl, params } = swiper;
    const originalSlides = Array.from(
      slidesEl.querySelectorAll(`.${params.slideClass}`)
    ).filter((slide) => !slide.classList.contains("swiper-slide-duplicate"));
    if (originalSlides.length === 0) return;
    originalSlides.forEach((slide, index) => {
      slide.setAttribute("data-swiper-slide-index", index);
    });
    const containerWidth = this.elements.viewer.offsetWidth;
    const cols = originalSlides.length;
    if (cols < 2) {
      swiper.recalcSlides();
      swiper.updateSlides();
      this.loopedSlides = 0;
      return;
    }
    const slideWidths = originalSlides.map((slide) => slide.offsetWidth || 0);
    let visibleSlides = 0;
    let width = 0;
    const maxIterations = cols * 20;
    while (width < containerWidth && visibleSlides < maxIterations) {
      const w = slideWidths[visibleSlides % cols];
      if (w <= 0) {
        break;
      }
      width += w;
      visibleSlides += 1;
    }
    if (visibleSlides === 0) {
      visibleSlides = cols;
    }
    this.loopedSlides = Math.max(visibleSlides, 4);
    const prependSlides = [];
    const appendSlides = [];
    for (let i = 0; i < this.loopedSlides; i += 1) {
      const appendIndex = i % cols;
      appendSlides.push(originalSlides[appendIndex]);
      const prependIndex = (cols - 1 - i % cols + cols) % cols;
      prependSlides.unshift(originalSlides[prependIndex]);
    }
    for (let i = 0; i < appendSlides.length; i += 1) {
      const clone = appendSlides[i].cloneNode(true);
      if (clone) {
        clone.classList.add("swiper-slide-duplicate");
        clone.setAttribute("data-swiper-slide-index", appendSlides[i].getAttribute("data-swiper-slide-index"));
        slidesEl.appendChild(clone);
        customElements.upgrade(clone);
      }
    }
    for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
      const clone = prependSlides[i].cloneNode(true);
      if (clone) {
        clone.classList.add("swiper-slide-duplicate");
        clone.setAttribute("data-swiper-slide-index", prependSlides[i].getAttribute("data-swiper-slide-index"));
        slidesEl.prepend(clone);
        customElements.upgrade(clone);
      }
    }
    swiper.recalcSlides();
    swiper.updateSlides();
  }
  loopFix() {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed || !this.loopedSlides) {
      return;
    }
    const slides = Array.from(swiper.slides);
    const activeIndex = swiper.activeIndex;
    const currentSlide = slides[activeIndex];
    if (!currentSlide) {
      return;
    }
    if (!currentSlide.classList.contains("swiper-slide-duplicate")) {
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      return;
    }
    const targetIndex = this.findRealTargetIndex(slides, activeIndex);
    if (targetIndex === null) {
      return;
    }
    this.jumpToIndex(targetIndex);
  }
  loopFixDuringDrag() {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed || !this.loopedSlides) {
      return;
    }
    const max = swiper.maxTranslate();
    const min = swiper.minTranslate();
    if (swiper.translate > min) {
      this.clampDragTranslate(min);
    } else if (swiper.translate < max) {
      this.clampDragTranslate(max);
    }
    swiper.updateActiveIndex();
    const slides = Array.from(swiper.slides);
    const activeIndex = swiper.activeIndex;
    const targetIndex = this.findRealTargetIndex(slides, activeIndex);
    if (targetIndex === null) {
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      return;
    }
    this.jumpToIndex(targetIndex, { isDrag: true });
  }
  clampDragTranslate(clampValue) {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    const diff = swiper.translate - clampValue;
    if (swiper.touchEventsData) {
      swiper.touchEventsData.startTranslate -= diff;
      swiper.touchEventsData.currentTranslate -= diff;
    }
    swiper.setTranslate(clampValue);
  }
  findRealTargetIndex(slides, activeIndex) {
    const currentSlide = slides[activeIndex];
    if (!currentSlide || !currentSlide.classList.contains("swiper-slide-duplicate")) {
      return null;
    }
    const realIndex = parseInt(currentSlide.getAttribute("data-swiper-slide-index"), 10);
    if (Number.isNaN(realIndex)) {
      return null;
    }
    const targetSlide = slides.find(
      (slide) => !slide.classList.contains("swiper-slide-duplicate") && parseInt(slide.getAttribute("data-swiper-slide-index"), 10) === realIndex
    );
    if (!targetSlide) {
      return null;
    }
    const targetIndex = slides.indexOf(targetSlide);
    return targetIndex >= 0 && targetIndex !== activeIndex ? targetIndex : null;
  }
  jumpToIndex(targetIndex, { isDrag = false } = {}) {
    const swiper = this.sliderInstance;
    if (!swiper || swiper.destroyed) {
      return;
    }
    const { slidesGrid, snapGrid, params, activeIndex } = swiper;
    const grid = params.centeredSlides && snapGrid ? snapGrid : slidesGrid;
    const diff = (grid[targetIndex] ?? 0) - (grid[activeIndex] ?? 0);
    swiper.setTransition(0);
    this.suppressGrowTransition();
    if (isDrag && swiper.touchEventsData) {
      swiper.touchEventsData.startTranslate -= diff;
      swiper.touchEventsData.currentTranslate -= diff;
    }
    swiper.setTranslate(swiper.translate - diff);
    swiper.updateActiveIndex(targetIndex);
    swiper.updateSlidesClasses();
    swiper.animating = false;
    if (swiper.pagination && swiper.pagination.el) {
      swiper.pagination.render();
      swiper.pagination.update();
    }
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    this.restoreGrowTransitionNextFrame();
  }
  suppressGrowTransition() {
    this.elements.viewer.classList.add("gsp-loop-jumping");
  }
  restoreGrowTransitionNextFrame() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.elements.viewer.classList.remove("gsp-loop-jumping");
      });
    });
  }
}
customElements.define("shoppable-videos-gallery", ShoppableVideosGallery);
class BrandStory extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="GalleryViewer"]',
      thumbnails: '[id^="GalleryThumbnails"]'
    };
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
    this.abortController = new AbortController();
    this.sliderInstance = false;
    this.thumbsInstance = false;
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this.resizeHandler) {
      GSP.resize.unregister(this.resizeHandler);
    }
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.elements.thumbnails.addEventListener("gsp:swiper:afterInit", (event) => {
      this.updateContentPadding();
    }, {
      signal: this.abortController.signal
    });
    this.setSliderOptions();
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
    this.resizeHandler = () => {
      this.updateContentPadding();
    };
    GSP.resize.register(this.resizeHandler);
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true,
      simulateTouch: false
    };
    this.thumbsOptions = {
      watchSlidesProgress: true
    };
  }
  initSlider() {
    if (typeof this.sliderInstance !== "object") {
      if (this.elements.thumbnails) {
        if (typeof this.thumbsInstance !== "object") {
          this.thumbsInstance = GSP.carousel.initSwiper(this.elements.thumbnails, this.thumbsOptions);
          this.sliderOptions.thumbs = {
            swiper: this.thumbsInstance
          };
        }
      }
      this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
      this.thumbsInstance.slides.forEach((slide, index) => {
        slide.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.sliderInstance.slideTo(index);
          }
        });
      });
    }
  }
  updateContentPadding() {
    const thumbnail = this.querySelector(".brand-story__thumbnail");
    if (!thumbnail) {
      return;
    }
    const thumbnailHeight = thumbnail.offsetHeight;
    this.style.setProperty("--story-thumbnail-space", `${thumbnailHeight + 50}px`);
  }
  updateMediaLayout() {
    this.destroySlider();
    this.sliderOptions.autoplay = {
      enabled: GSP.core.isDeviceDown("md"),
      delay: 5e3
    };
    this.initSlider();
  }
  destroySlider() {
    if (typeof this.thumbsInstance === "object") {
      this.thumbsInstance.destroy();
      this.thumbsInstance = false;
    }
    if (typeof this.sliderInstance === "object") {
      this.sliderInstance.destroy();
      this.sliderInstance = false;
    }
  }
}
customElements.define("brand-story", BrandStory);
class reviewsSpotlightThumb extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="reviewsSpotlightMain"]',
      thumbnails: '[id^="reviewsSpotlightThumb"]'
    };
    this.abortController = new AbortController();
    this.sliderInstance = false;
    this.thumbsInstance = false;
    this.sliderOptions = {};
    this.thumbsOptions = {};
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this.closest(".shopify-section"));
    this.initSlider();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  initSlider() {
    if (typeof this.sliderInstance !== "object") {
      if (this.elements.thumbnails) {
        if (typeof this.thumbsInstance !== "object") {
          this.thumbsInstance = GSP.carousel.initSwiper(this.elements.thumbnails, this.thumbsOptions);
          this.sliderOptions.thumbs = {
            swiper: this.thumbsInstance
          };
        }
      }
      this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
      this.thumbsInstance.slides.forEach((slide, index) => {
        slide.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.sliderInstance.slideTo(index);
          }
        });
      });
    }
  }
  destroySlider() {
    if (typeof this.thumbsInstance === "object") {
      this.thumbsInstance.destroy();
      this.thumbsInstance = false;
    }
    if (typeof this.sliderInstance === "object") {
      this.sliderInstance.destroy();
      this.sliderInstance = false;
    }
  }
}
customElements.define("reviews-spotlight", reviewsSpotlightThumb);
if (!customElements.get("gsp-search-form")) {
  class gspSearchForm extends HTMLElement {
    constructor() {
      super();
      this.enablePredictive = this.dataset.predictiveSearch === "true";
      this.sectionId = this.dataset.sectionId || "fetch__predictive-search";
      this.searchOffcanvas = this.closest(".gsp-search-offcanvas");
      this.recommend = this.querySelector(".gsp-search-recommend");
      this.input = this.querySelector(".search-input");
      this.btnSubmit = this.querySelector(".btn-submit");
      this.btnClear = this.querySelector(".btn-clear");
      this.render = this.querySelector("[data-predictive-search-result]");
      this.cachedResults = {};
    }
    connectedCallback() {
      if (this.searchOffcanvas) {
        this.offcanvasSearch();
      }
      if (this.enablePredictive) {
        this.input.addEventListener("input", gspTheme.helper.debounce((event) => {
          this.onChange();
        }, 300).bind(this));
        this.reset();
      }
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      const q = this.getQuery();
      if (q.length) {
        this.activeButtonSpin();
        this.activeLoadingSection();
        this.showRecommend(false);
        if (this.btnClear) {
          this.showBtnClear();
        }
        this.getSearchResults(q);
      } else {
        this.showRecommend();
        this.render.innerHTML = "";
        if (this.btnClear) {
          this.showBtnClear(false);
        }
      }
    }
    getSearchResults(searchQuery) {
      const formattedQuery = searchQuery.replace(" ", "-").toLowerCase();
      const unavailableProductsOption = this.dataset.unavailableProductsOption;
      let searchFields = "title,product_type,vendor,variants.sku,variants.title,tag,body";
      let type = this.dataset.searchType;
      if (this.cachedResults[formattedQuery]) {
        this.renderSearchResults(this.cachedResults[formattedQuery]);
        return;
      }
      let fetchUrl = `${window.gspSetting.routes.predictive_search_url}?q=${encodeURIComponent(searchQuery)}&resources[type]=${type}&resources[options][unavailable_products]=${unavailableProductsOption}&resources[options][fields]=${searchFields}&section_id=${this.sectionId}`;
      fetch(fetchUrl).then((response) => {
        if (!response.ok) {
          this.activeButtonSpin(false);
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      }).then((responseText) => {
        const parser = new DOMParser();
        const sectionResultHtml = "#shopify-section-" + this.sectionId;
        const searchResultHtml = parser.parseFromString(responseText, "text/html").querySelector(sectionResultHtml).innerHTML;
        this.cachedResults[formattedQuery] = searchResultHtml;
        this.renderSearchResults(searchResultHtml);
      }).catch((error) => {
        this.activeButtonSpin(false);
        throw error;
      });
    }
    renderSearchResults(searchResultsHtml) {
      this.render.innerHTML = searchResultsHtml;
      this.activeButtonSpin(false);
      this.activeLoadingSection(false);
      GSP.carousel.initMultiSwiper(this.render, ".gsp-swiper");
    }
    activeButtonSpin(active = true) {
      active ? gspTheme.helper.enableLoadingSpiner(this.btnSubmit) : gspTheme.helper.disableLoadingSpinner(this.btnSubmit);
    }
    activeLoadingSection(active = true) {
      const loading = this.render.querySelector(".gsp-loading-sections");
      if (loading) {
        if (!active) {
          loading.classList.add("d-none");
        } else {
          loading.classList.remove("d-none");
        }
      }
    }
    reset(show = true) {
      const _self = this;
      if (_self.btnClear) {
        _self.btnClear.addEventListener("click", (event) => {
          _self.showBtnClear(false);
          _self.render.innerHTML = "";
          _self.input.focus();
          this.showRecommend();
        });
      }
    }
    showBtnClear(show = true) {
      if (show) {
        this.btnClear.classList.remove("d-none");
      } else {
        this.btnClear.classList.add("d-none");
      }
    }
    showRecommend(show = true) {
      if (this.recommend && show && this.recommend.classList.contains("d-none")) {
        this.recommend.classList.remove("d-none");
      }
      if (this.recommend && !show && !this.recommend.classList.contains("d-none")) {
        this.recommend.classList.add("d-none");
      }
    }
    offcanvasSearch() {
      GSP.pubsub.subscribe(
        GSP.pubsub.PUB_SUB_EVENTS.appendElement,
        (event) => {
          if (this.searchOffcanvas.classList.contains("d-none")) {
            this.searchOffcanvas.classList.remove("d-none");
          }
        }
      );
      this.searchOffcanvas.addEventListener("shown.bs.offcanvas", (event) => {
        this.input.focus();
        GSP.carousel.initMultiSwiper(this.searchOffcanvas, ".gsp-swiper");
      });
    }
  }
  customElements.define("gsp-search-form", gspSearchForm);
}
const gspTheme$2 = window.gspTheme || {};
class GspCustomer {
  constructor() {
    this.containerAddress = document.querySelector("[data-gsp-customer-addresses]");
    this.init();
  }
  init() {
    this.agree_term();
    if (this.containerAddress) {
      this.setupCountries();
    }
  }
  agree_term() {
    document.querySelectorAll('form[data-show-terms="true"]').forEach(((e) => {
      const agreeTerm = e.querySelector("[name='agree_terms']");
      if (agreeTerm) {
        const termsAction = e.querySelector("[data-terms-action]");
        agreeTerm.addEventListener("change", function() {
          if (this.checked) {
            termsAction.removeAttribute("disabled");
          } else {
            termsAction.setAttribute("disabled", "true");
          }
        });
      }
    }));
  }
  setupCountries() {
    const countrySelectElements = this.containerAddress.querySelectorAll("[data-address-country-select]");
    if (Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector("AddressCountry_new", "AddressProvince_new", {
        hideElement: "AddressProvinceContainerNew"
      });
      countrySelectElements.forEach((element) => {
        const formId = element.dataset.formId;
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }
}
gspTheme$2.Customer = new GspCustomer();
const gspTheme$1 = window.gspTheme || {};
class gspFetchPostByParams {
  constructor(selector = {}, target = "") {
    this.listingWrap = selector.listingWrap ? selector.listingWrap : false;
    this.spin = selector.spin ? selector.spin : false;
    this.sectionWrap = this.listingWrap ? this.listingWrap.closest(".gsp-section__wrap") : false;
    this.mainRenderInner = this.listingWrap ? this.listingWrap.querySelector(".gsp-listing-inner") : false;
    this.sectionId = this.listingWrap ? this.listingWrap.dataset.sectionId : false;
    this.isIsotope = this.listingWrap && this.listingWrap.classList.contains("gsp-isotope");
    this.hasAnimation = this.listingWrap && this.listingWrap.classList.contains("has-animation");
    this.sectionHasSlider = this.sectionWrap && this.sectionWrap.classList.contains("gsp-section-slider");
    this.hasSidebar = this.sectionWrap && this.sectionWrap.classList.contains("gsp-section__has-sidebar");
    this.sidebar = this.hasSidebar ? this.sectionWrap.querySelector("#gsp-sidebar") : false;
    this.target = target;
    this.abortController = null;
  }
  loadPost(options = {}, targetRender = [], append = true) {
    const _self = this;
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();
    gspLoadingBar.start(document.querySelector("body"), true);
    if (!append) {
      this.scrollTop();
    }
    if (this.spin) {
      gspTheme$1.helper.enableLoadingSpiner(this.spin);
    }
    const optionsDefault = { fromCache: true, signal: this.abortController.signal };
    options = { ...optionsDefault, ...options };
    gspTheme$1.helper.fetchSection(_self.sectionId, options).then(((response) => {
      targetRender.forEach((target) => {
        GSP.bsScript.hide(this.sectionWrap);
        if (append) {
          response.querySelectorAll(target.selector).forEach(((item) => {
            _self.sectionWrap.querySelector(target.target).appendChild(item);
            if (_self.isIsotope) {
              var iso = new Isotope(_self.sectionWrap.querySelector(target.target), {});
              iso.appended(item);
            }
          }));
        } else {
          const element = response.querySelector(target.selector);
          if (element) {
            _self.sectionWrap.querySelector(target.target).innerHTML = element.innerHTML;
          }
        }
      });
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.loadPost, {
        data: response,
        target: _self.target
      });
    })).catch(((error) => {
      if (this.spin) {
        gspTheme$1.helper.disableLoadingSpinner(this.spin);
      }
      gspLoadingBar.remove(document.querySelector("body"));
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.loadPostError);
    })).finally((() => {
      gspLoadingBar.remove(document.querySelector("body"));
      // Restore product visibility after any AJAX filter/sort update or error.
      if (!append && this.sectionWrap) {
        const visibleGrid = this.sectionWrap.querySelector(".gsp-listing-inner");
        if (visibleGrid) {
          visibleGrid.style.opacity = "";
          visibleGrid.style.pointerEvents = "";
          visibleGrid.style.transition = "";
        }
      }
      if (gspSetting.templateName === "search") {
        this.updateSectionPageTitle(".gsp-page-title-section", options);
      }
      if (this.spin) {
        gspTheme$1.helper.disableLoadingSpinner(this.spin);
      }
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.loadPostFinally, append);
      this.initPost(append);
    }));
  }
  scrollTop() {
    if (this.mainRenderInner) {
      this.mainRenderInner.style.transition = `opacity 1000ms`;
      this.mainRenderInner.style.opacity = 0;
      this.mainRenderInner.style.pointerEvents = "none";
      const wrapperOffset = this.listingWrap.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo(0, wrapperOffset);
    }
  }
  updateSectionPageTitle(target, options) {
    document.querySelectorAll(target).forEach(((e) => {
      const section_id = e.dataset.sectionId;
      if (section_id !== void 0) {
        gspTheme$1.helper.fetchSection(section_id, options).then(((response) => {
          const breadcrumb = response.querySelector(".gsp-breadcrumb");
          const pageTitle = response.querySelector(".gsp-page-title");
          if (breadcrumb) {
            e.querySelector(".gsp-breadcrumb").innerHTML = breadcrumb.innerHTML;
          }
          if (pageTitle) {
            e.querySelector(".gsp-page-title").innerHTML = pageTitle.innerHTML;
          }
        }));
      }
    }));
  }
  initPost(append = true) {
    GSP.bsScript.tooltips(this.sectionWrap);
    if (this.isIsotope && !append) {
      const $isotope = this.listingWrap.querySelectorAll("[data-options-isotope]");
      GSP.isotopeFilter.setupIsotope($isotope);
    }
    if (window.gspSetting.image_motion) {
      GSP.imageMotion.initManual($(this.listingWrap));
    }
    if (this.hasAnimation) {
      GSP.animation.initManual($(this.listingWrap));
    }
    if (this.sectionHasSlider) {
      const sliderInSection = this.sectionWrap.querySelector(".gsp-swiper");
      GSP.carousel.initSwiper(sliderInSection);
    }
  }
  getPageByUrl($url = null) {
    const paramsCurrentUrl = this.getParamsCurrentUrl($url);
    if (paramsCurrentUrl !== null) {
      const paramsPage = paramsCurrentUrl.get("page");
      if (paramsPage !== null && Number.isInteger(Number(paramsPage))) {
        return parseInt(paramsPage);
      }
    }
    return null;
  }
  getParamsCurrentUrl($url = null) {
    if ($url === null) {
      $url = window.location.href;
    }
    const urlObj = new URL($url);
    if (urlObj) {
      return new URLSearchParams(urlObj.search);
    }
    return null;
  }
}
class gspPagination extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.paginationType ? this.dataset.paginationType : "paginate_shopify";
    this.fetchPost = new gspFetchPostByParams(this.getSelectors());
    this.mainListing = this.closest("[data-gsp-main-listing]");
    this.currentPage = this.getCurrentPage();
    this.totalPages = parseInt(this.dataset.totalPages);
    this.infiniteLoadingObserver;
    this.pushState = false;
  }
  connectedCallback() {
    this.init();
  }
  getCurrentPage() {
    if (this.mainListing) {
      return this.fetchPost.getPageByUrl() !== null ? this.fetchPost.getPageByUrl() : 1;
    } else {
      return parseInt(this.dataset.currentPage);
    }
  }
  getSelectors() {
    return {
      listingWrap: this.closest(".gsp-listing"),
      spin: this.querySelector("button")
    };
  }
  getSelectorsToRender(append = true) {
    var listingId = this.dataset.listingTarget;
    if (append) {
      return [
        { selector: "[data-listing-id='" + listingId + "'] .gsp-listing-item", target: ".gsp-listing-inner" }
      ];
    } else {
      return [
        { selector: "[data-listing-id='" + listingId + "'] [data-gsp-listing-render]", target: "[data-listing-id='" + listingId + "'] [data-gsp-listing-render]" }
      ];
    }
  }
  init() {
    const _self = this;
    const $targetRender = _self.getSelectorsToRender(false);
    const $targetRenderAppend = _self.getSelectorsToRender();
    if (this.mainListing) {
      this.pushState = true;
    }
    switch (_self.type) {
      case "nextpre":
        const $buttonPre = _self.querySelector(".gsp-pagination-pre");
        const $buttonNext = _self.querySelector(".gsp-pagination-next");
        const $pagePre = $buttonPre?.dataset.page ? parseInt($buttonPre.dataset.page) : null;
        const $pageNext = $buttonNext?.dataset.page ? parseInt($buttonNext.dataset.page) : null;
        if (_self.mainListing) {
          // Full-page Shopify navigation for main collection/search listings.
          // Keep existing <a href> links native, including Ctrl+click/new tabs.
          const navigateNative = (element, page) => {
            if (!element || !Number.isInteger(page) || page < 1 || page > _self.totalPages) return;
            if (element.matches("a[href]")) return;
            element.addEventListener("click", (event) => {
              event.preventDefault();
              const url = new URL(window.location.href);
              if (page === 1) {
                url.searchParams.delete("page");
              } else {
                url.searchParams.set("page", String(page));
              }
              window.location.assign(url.toString());
            });
          };
          navigateNative($buttonPre, $pagePre);
          navigateNative($buttonNext, $pageNext);
          break;
        }
        // Preserve section-specific AJAX pagination for non-main listings.
        if ($buttonPre && $pagePre >= 1 && $pagePre <= _self.totalPages) {
          const $options = {
            params: { page: $pagePre },
            pushState: _self.pushState
          };
          $buttonPre.addEventListener("click", _self.fetchPost.loadPost.bind(_self.fetchPost, $options, $targetRender, false));
        }
        if ($buttonNext && $pageNext >= 1 && $pageNext <= _self.totalPages) {
          const $options = {
            params: { page: $pageNext },
            pushState: _self.pushState
          };
          $buttonNext.addEventListener("click", _self.fetchPost.loadPost.bind(_self.fetchPost, $options, $targetRender, false));
        }
        break;
      case "pagination":
        // Allow native Shopify <a href> page links to load the full page.
        // The old AJAX handler could leave the product grid blank.
        break;
      case "loadmore":
        const button = _self.querySelector("button");
        button.addEventListener("click", function(e) {
          e.preventDefault();
          let $pageTarget = _self.currentPage + 1;
          if ($pageTarget <= _self.totalPages) {
            const $options = {
              params: { page: $pageTarget }
            };
            _self.fetchPost.loadPost($options, $targetRenderAppend);
          }
          _self.updateCurrentPage($pageTarget);
        });
        break;
      case "infinite":
        _self.infiniteLoadingObserver = new IntersectionObserver(((entries) => {
          entries.forEach(((entry) => {
            if (1 === entry.intersectionRatio) {
              let $pageTarget = _self.currentPage + 1;
              if ($pageTarget <= _self.totalPages) {
                const $options = {
                  params: { page: $pageTarget }
                };
                _self.fetchPost.loadPost($options, $targetRenderAppend);
                _self.updateCurrentPage($pageTarget);
              }
            }
          }));
        }), { threshold: 1 });
        _self.infiniteLoadingObserver.observe(_self);
    }
  }
  updateCurrentPage(pageTarget) {
    GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.loadPostFinally, (append) => {
      this.currentPage = pageTarget;
      if (pageTarget >= this.totalPages && append) {
        this.remove();
      }
    });
  }
}
customElements.define("gsp-pagination", gspPagination);
class gspWidgetFilterList extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.getSelector().wrapper;
    this.param = this.wrapper.dataset.param;
    this.fetchPost = new gspFetchPostByParams(this.getSelectorsMainSection());
  }
  getSelector() {
    return {
      wrapper: this.querySelector(".gsp-product-option-content")
    };
  }
  connectedCallback() {
    this.wrapper.addEventListener("change", () => {
      this.processFilter();
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.filterProductChange);
    });
  }
  getSelectorsMainSection() {
    const mainWrap = this.closest(".gsp-section-content__wrap");
    return {
      listingWrap: mainWrap ? mainWrap.querySelector(".gsp-listing") : false
    };
  }
  getSelectorsToRender() {
    return [
      {
        selector: ".gsp-listing",
        target: ".gsp-listing"
      },
      {
        selector: ".gsp-sidebar-section > .gsp-sidebar-inner",
        target: ".gsp-sidebar-section > .gsp-sidebar-inner"
      },
      {
        selector: "#FacetDrawer .offcanvas-body",
        target: "#FacetDrawer .offcanvas-body"
      },
      {
        selector: ".gsp-breadcrumb",
        target: ".gsp-breadcrumb"
      }
    ];
  }
  getAllItemCheck() {
    let listCheck = [];
    this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      const value = checkbox.value;
      if (checkbox.checked && value !== "") {
        listCheck.push(value);
      }
    });
    return listCheck;
  }
  processFilter() {
    const _self = this;
    _self.getAllItemCheck();
    const $options = {
      paramVars: { param: _self.param, values: _self.getAllItemCheck() },
      pushState: true,
      deleteParams: ["page"]
    };
    _self.fetchPost.loadPost($options, _self.getSelectorsToRender(), false);
  }
}
if (!customElements.get("gsp-widget-filter-list")) {
  customElements.define("gsp-widget-filter-list", gspWidgetFilterList);
}
if (!customElements.get("gsp-filter-list")) {
  class gspFilterListProduct extends gspWidgetFilterList {
    constructor() {
      super();
      this.offcanvas = this.closest("#FacetDrawer");
      this.close();
    }
    close() {
      const bsOffcanvas = new bootstrap.Offcanvas(this.offcanvas);
      GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.filterProductChange, () => {
        setTimeout(() => {
          bsOffcanvas.hide();
        }, 150);
      });
    }
  }
  customElements.define("gsp-filter-list", gspFilterListProduct);
}
class gspFilterWidgetPriceProduct extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector(".gsp-filter-price-inner");
    this.inputMin = this.wrapper.querySelector("input[name=range-min]");
    this.inputMax = this.wrapper.querySelector("input[name=range-max]");
    this.rangeMax = this.inputMax.max;
    this.paramMin = this.inputMin.dataset.param;
    this.paramMax = this.inputMax.dataset.param;
    this.btnSubmit = this.wrapper.querySelector(".btn-filter");
    this.design = this.dataset.design ? this.dataset.design : "slider";
    this.fetchPost = new gspFetchPostByParams(this.getSelectorsMain());
  }
  connectedCallback() {
    if (this.design === "slider") {
      this.rangerFilter();
    }
    if (this.design === "input") {
      this.submitFilter();
    }
  }
  rangerFilter() {
    this.wrapper.addEventListener("input", () => {
      this.liveValueRanger();
    });
    this.inputMin.addEventListener("input", () => {
      this.rangerMinChange();
    });
    this.inputMax.addEventListener("input", () => {
      this.rangerMaxChange();
    });
    this.wrapper.addEventListener("change", () => {
      this.processFilter();
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.filterProductChange);
    });
  }
  submitFilter() {
    if (this.btnSubmit) {
      this.btnSubmit.addEventListener("click", (event) => {
        event.preventDefault();
        this.processFilter();
        GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.filterProductChange);
      });
    }
  }
  getSelectorsMain() {
    const mainWrap = this.closest(".gsp-section-content__wrap");
    return {
      listingWrap: mainWrap ? mainWrap.querySelector(".gsp-listing") : false,
      spin: this.querySelector(".gsp-spin-wrapper")
    };
  }
  getSelectorsToRender() {
    return [
      {
        selector: ".gsp-listing",
        target: ".gsp-listing"
      },
      {
        selector: ".gsp-sidebar-section > .gsp-sidebar-inner",
        target: ".gsp-sidebar-section > .gsp-sidebar-inner"
      }
    ];
  }
  rangerMinChange() {
    const $valueMin = Number(this.inputMin.value);
    const $valueMax = Number(this.inputMax.value);
    if ($valueMax - $valueMin <= 0) {
      this.inputMin.value = $valueMax;
    }
  }
  rangerMaxChange() {
    const $valueMin = Number(this.inputMin.value);
    const $valueMax = Number(this.inputMax.value);
    if ($valueMax - $valueMin <= 0) {
      this.inputMax.value = $valueMin;
    }
  }
  liveValueRanger() {
    const $livePriceMin = this.querySelector(".gsp-filter-price-live .min");
    const $livePriceMax = this.querySelector(".gsp-filter-price-live .max");
    const $rangeMax = Number(this.rangeMax);
    const $valueMin = Number(this.inputMin.value);
    const $valueMax = Number(this.inputMax.value);
    const $totalRange = $rangeMax - $valueMin - ($rangeMax - $valueMax);
    const $progressLeft = $valueMin / $rangeMax * 100 + "%";
    const $progressRight = ($rangeMax - $valueMax) / $rangeMax * 100 + "%";
    if ($totalRange >= 0) {
      const $progressWidth = $totalRange / $rangeMax * 100 + "%";
      this.wrapper.style.setProperty("--gsp-ranger-progress-width", $progressWidth);
    }
    if ($valueMin === $rangeMax && $valueMin === $rangeMax && !this.inputMin.classList.contains("z-index-10")) {
      this.inputMin.classList.add("z-index-10");
    }
    if ($valueMin !== $rangeMax && $valueMin !== $rangeMax && this.inputMin.classList.contains("z-index-10")) {
      this.inputMin.classList.remove("z-index-10");
    }
    this.wrapper.style.setProperty("--gsp-ranger-progress-left", $progressLeft);
    this.wrapper.style.setProperty("--gsp-ranger-progress-right", $progressRight);
    $livePriceMin.textContent = $valueMin;
    $livePriceMax.textContent = $valueMax;
  }
  processFilter() {
    const $valueMin = Number(this.inputMin.value);
    const $valueMax = Number(this.inputMax.value);
    const $options = {
      params: { [this.paramMin]: $valueMin, [this.paramMax]: $valueMax },
      pushState: true,
      deleteParams: ["page"]
    };
    this.fetchPost.loadPost($options, this.getSelectorsToRender(), false);
  }
}
if (!customElements.get("gsp-widget-filter-price")) {
  customElements.define("gsp-widget-filter-price", gspFilterWidgetPriceProduct);
}
if (!customElements.get("gsp-filter-price")) {
  class gspFilterPriceProduct extends gspFilterWidgetPriceProduct {
    constructor() {
      super();
      this.offcanvas = this.closest("#FacetDrawer");
      this.close();
    }
    close() {
      const bsOffcanvas = new bootstrap.Offcanvas(this.offcanvas);
      GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.filterProductChange, () => {
        setTimeout(() => {
          bsOffcanvas.hide();
        }, 150);
      });
    }
  }
  customElements.define("gsp-filter-price", gspFilterPriceProduct);
}
if (!customElements.get("facet-form")) {
  class FacetForm extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.formEl.addEventListener("change", this.onFormChange.bind(this), {
        signal: this.abortController.signal
      });
      this.formEl.addEventListener("submit", this.onFormSubmit.bind(this), {
        signal: this.abortController.signal
      });
      this.fetchPost = new gspFetchPostByParams(this.getSelectorsMainSection(), "facet-form");
    }
    get formEl() {
      return this._formEl = this._formEl || this.querySelector("form");
    }
    loadPostUnsubscriber = void 0;
    connectedCallback() {
      this.rageInputKeyUp();
      this.loadPostUnsubscriber = GSP.pubsub.subscribe(
        GSP.pubsub.PUB_SUB_EVENTS.loadPost,
        this.handleUpdate.bind(this)
      );
    }
    disconnectedCallback() {
      if (this.loadPostUnsubscriber) {
        this.loadPostUnsubscriber();
      }
      this.abortController.abort();
      this.fetchPost = null;
    }
    handleUpdate = (event) => {
      if (event.target !== "facet-form") {
        return;
      }
      const response = event.data;
      const facetElements = response.querySelectorAll(
        "#DrawerFacetFiltersContainer [data-filter], #gsp-sidebar [data-filter], #HorizontalFacetFiltersContainer [data-filter]"
      );
      const facetElementsFormDom = document.querySelectorAll(
        "#DrawerFacetFiltersContainer [data-filter], #gsp-sidebar [data-filter], #HorizontalFacetFiltersContainer [data-filter]"
      );
      Array.from(facetElementsFormDom).forEach((currentElement) => {
        if (!Array.from(facetElements).some(({ id }) => currentElement.id === id)) {
          currentElement.classList.add("hidden");
        }
      });
      facetElements.forEach((element) => {
        const filter = document.querySelector(`[data-filter][data-index="${element.dataset.index}"]`);
        if (filter !== null) {
          filter.classList.remove("hidden");
          if (filter.classList.contains("gsp-facet")) {
            filter.querySelector(".gsp-facet__body").innerHTML = element.querySelector(".gsp-facet__body").innerHTML;
          } else {
            filter.innerHTML = element.innerHTML;
          }
        }
      });
      this.rageInputKeyUp();
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.facetUpdate, { response });
    };
    rageInputKeyUp() {
      this.formEl.querySelectorAll(".gsp-facet-range__input").forEach((el) => {
        el.addEventListener("keydown", (event) => {
          clearTimeout(this._debounceTimer);
        });
      });
    }
    onFormChange() {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => {
        this.formEl.dispatchEvent(
          new Event("submit", { cancelable: true })
        );
      }, 300);
    }
    onFormSubmit(event) {
      event.preventDefault();
      const url = this.buildUrl().toString();
      this.renderSection(url);
    }
    renderSection(url) {
      let $options = {
        pushState: true,
        url,
        fromCache: true
      };
      const currentLayout = gspTheme$1.helper.getParam("view-layout");
      if (currentLayout) {
        $options.params = { "view-layout": currentLayout };
      }
      this.fetchPost.loadPost($options, this.getSelectorsToRender(), false);
    }
    buildUrl() {
      const searchParams = new URLSearchParams(new FormData(this.formEl));
      const url = new URL(this.formEl.action);
      url.search = "";
      searchParams.forEach((value, key) => url.searchParams.append(key, value));
      ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((item) => {
        if (url.searchParams.get(item) === "") {
          url.searchParams.delete(item);
        }
      });
      return url;
    }
    getSelectorsMainSection() {
      const section_id = gspTheme$1.helper.getSectionId(this.formEl);
      const listingWrap = document.querySelector(`[data-listing-id="${section_id}"]`);
      return {
        listingWrap,
        spin: document.querySelector(".gsp-toolbar")
      };
    }
    getSelectorsToRender() {
      return [
        {
          selector: '[data-ajax-render="active-facets"]',
          target: '[data-ajax-render="active-facets"]'
        },
        {
          selector: '[data-ajax-render="count"]',
          target: '[data-ajax-render="count"]'
        },
        {
          selector: '[data-ajax-render="count-mobile"]',
          target: '[data-ajax-render="count-mobile"]'
        },
        {
          selector: "[data-gsp-listing-render]",
          target: "[data-gsp-listing-render]"
        }
      ];
    }
  }
  customElements.define("facet-form", FacetForm);
}
if (!customElements.get("facet-short")) {
  class FacetShort extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.fetchPost = new gspFetchPostByParams(this.getSelectors());
      this.onSortChange = this.onSortChange.bind(this);
    }
    connectedCallback() {
      this.init();
    }
    disconnectedCallback() {
      this.abortController.abort();
    }
    init() {
      this.sortByElements.forEach((element) => {
        element.addEventListener("change", this.onSortChange, {
          signal: this.abortController.signal
        });
      });
      this.updateCurrentLabel();
    }
    get sortByElements() {
      return this.querySelectorAll("[data-sort-by]");
    }
    get sortByLabel() {
      return this.querySelector("[data-sort-by-label]");
    }
    get currentSortBy() {
      return this.querySelector("[data-sort-by]:checked");
    }
    onSortChange(event) {
      const currentElement = event.currentTarget;
      const value = currentElement.value;
      if (!value) {
        return;
      }
      this.syncSortBy(value);
      const options = {
        params: {
          sort_by: value
        },
        pushState: true,
        deleteParams: ["page"]
      };
      this.fetchPost.loadPost(
        options,
        this.getSelectorsToRender(),
        false
      );
    }
    syncSortBy(value) {
      const facetShortElements = document.querySelectorAll("facet-short");
      facetShortElements.forEach((facetShort) => {
        const radio = facetShort.querySelector(
          `[data-sort-by][value="${CSS.escape(value)}"]`
        );
        if (radio) {
          radio.checked = true;
        }
        facetShort.updateCurrentLabel(value);
      });
    }
    getSelectors() {
      const section_id = gspTheme$1.helper.getSectionId(this);
      const listingWrap = document.querySelector(`[data-listing-id="${section_id}"]`);
      return {
        listingWrap
      };
    }
    getSelectorsToRender() {
      return [
        { selector: "[data-gsp-listing-render]", target: "[data-gsp-listing-render]" }
      ];
    }
    updateCurrentLabel(value = null) {
      const currentElement = value !== null ? this.querySelector(`[data-sort-by][value="${CSS.escape(value)}"]`) : this.currentSortBy;
      if (!currentElement || !this.sortByLabel) {
        return;
      }
      this.sortByLabel.textContent = currentElement.dataset.sortLabel || currentElement.value;
    }
  }
  customElements.define("facet-short", FacetShort);
}
if (!customElements.get("facet-remove")) {
  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.linkEl.addEventListener("click", this.onClick.bind(this), {
        signal: this.abortController.signal
      });
    }
    get linkEl() {
      return this._linkEl = this._linkEl || this.querySelector("a");
    }
    disconnectedCallback() {
      this.abortController.abort();
    }
    onClick(event) {
      const form = document.querySelector("facet-form");
      if (form) {
        event.preventDefault();
        const url = new URL(this.linkEl.href);
        form.renderSection(url.toString());
      }
    }
  }
  customElements.define("facet-remove", FacetRemove);
}
if (!customElements.get("facet-count")) {
  class FacetCount extends HTMLElement {
    constructor() {
      super();
    }
    facetUpdateUnsubscriber = void 0;
    connectedCallback() {
      this.update();
      this.facetUpdateUnsubscriber = GSP.pubsub.subscribe(
        GSP.pubsub.PUB_SUB_EVENTS.facetUpdate,
        this.update.bind(this)
      );
    }
    disconnectedCallback() {
      if (this.facetUpdateUnsubscriber) {
        this.facetUpdateUnsubscriber();
      }
    }
    update() {
      this.hidden = this.itemCount === 0;
      if (this.itemCount > 0) {
        this.innerText = `(${this.itemCount})`;
      } else {
        this.innerText = "";
      }
    }
    get itemCount() {
      let count = 0;
      const facetsActive = document.querySelector('[data-ajax-render="active-facets"]');
      if (facetsActive) {
        count = facetsActive.querySelectorAll(".gsp-facet-remove").length;
      }
      return count;
    }
  }
  customElements.define("facet-count", FacetCount);
}
(function($2) {
  GSP.registerAssets = {
    init: function() {
      this.loadAssets();
      this.preview();
    },
    register: function() {
      return {
        ".gsp-simple-countdown": "countdownHandle",
        ".gsp-image-box-image": "imageBoxHandle",
        ".gsp-collection-tabs-inner": "collectionTabsHandle",
        "pickup-availability": "pickupAvailabilityHandle",
        ".gsp-adv-accordion-inner": "advancedAccordionHandle",
        ".gsp-collection-listing": "collectionListingHandle",
        ".gsp-hotspots": "hotspotsHandle",
        "products-bundle": "productsBundleHandle",
        "image-comparison": "imageComparison",
        "spotlight-pick": "spotlightPick",
        "show-more-button": "showMoreButton",
        "copy-to-clipboard": "copyToClipboard",
        "popup-promotion": "popupPromotion",
        "gsp-quick-order-list": "quickOrderListHandle",
        ".gsp-product-slideshow": "productSlideshowHandle",
        ".gsp-expandable-gallery": "expandableGalleryHandle",
        "scrolling-card-layered": "scrollingCardsHandle",
        ".gsp-section-collection-with-image": "collectionWithImageHandle",
        "gsp-collection-marquee": "collectionMarqueeHandle",
        "shoppable-image": "shoppableImageHandle",
        "gsp-icon": "iconHandle"
      };
    },
    preview: function() {
      const assetsNeedPreview = {
        ".gsp-expandable-gallery": "expandableGalleryHandle",
        "image-comparison": "imageComparison",
        ".gsp-hotspots": "hotspotsHandle",
        ".gsp-collection-tabs-inner": "collectionTabsHandle",
        "scrolling-card-layered": "scrollingCardsHandle"
      };
      document.addEventListener("shopify:section:load", function(event) {
        const sectionEl = event.target;
        if (!sectionEl || typeof sectionEl.querySelector !== "function") return;
        for (const selector in assetsNeedPreview) {
          const handle = assetsNeedPreview[selector];
          const el = sectionEl.querySelector(selector);
          if (el) {
            gspTheme.helper.loadAssetsNew(handle);
          }
        }
      });
    },
    loadAssets: function() {
      const assets = this.register();
      for (const selector in assets) {
        const handle = assets[selector];
        if ($2(selector).length) {
          gspTheme.helper.loadAssetsNew(handle);
        }
      }
    }
  };
  $2(document).ready(function() {
    GSP.registerAssets.init();
  });
})(jQuery);
(function($2) {
  GSP.offCanvas = {
    init: function() {
      document.querySelectorAll(".offcanvas:not(.show)").forEach((el) => {
        el.setAttribute("inert", "inert");
      });
      document.addEventListener("show.bs.offcanvas", function(event) {
        event.target.removeAttribute("inert");
      });
      document.addEventListener("hidden.bs.offcanvas", function(event) {
        event.target.setAttribute("inert", "inert");
      });
    }
  };
  GSP.offCanvas.init();
})(jQuery);
class PressElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      slider: '[id^="PressText"]',
      thumbnails: '[id^="PressImage"]'
    };
    this.sliderInstance = false;
    this.thumbsInstance = false;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.setSliderOptions();
    this.initSlider();
  }
  setSliderOptions() {
    this.sliderOptions = {
      loop: false
    };
    this.thumbsOptions = {
      watchSlidesProgress: true,
      loop: false
    };
  }
  initSlider() {
    if (typeof this.sliderInstance !== "object") {
      if (typeof this.thumbsInstance !== "object") {
        this.thumbsInstance = GSP.carousel.initSwiper(this.elements.thumbnails, this.thumbsOptions);
        this.sliderOptions.thumbs = {
          swiper: this.thumbsInstance
        };
      }
      this.sliderInstance = GSP.carousel.initSwiper(this.elements.slider, this.sliderOptions);
      this.thumbsInstance.slides.forEach((slide, index) => {
        slide.setAttribute("tabindex", "0");
        slide.setAttribute("role", "button");
        slide.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.sliderInstance.slideTo(index);
          }
        });
      });
    }
  }
}
customElements.define("press-element", PressElement);
class TabCollapseElement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    const wrapper = this.querySelector(".tab-collapse");
    if (!wrapper) return;
    this.wrapper = wrapper;
    this.navLinks = wrapper.querySelectorAll(".nav-link");
    this.collapses = wrapper.querySelectorAll(".accordion-collapse");
    this.bindTabEvents();
    this.bindCollapseEvents();
  }
  bindTabEvents() {
    this.navLinks.forEach((tabBtn) => {
      tabBtn.addEventListener("show.bs.tab", (e) => {
        const targetSelector = tabBtn.getAttribute("data-bs-target");
        const pane = this.wrapper.querySelector(targetSelector);
        if (!pane) return;
        const collapse = pane.querySelector(".accordion-collapse");
        if (!collapse) return;
        const instance = bootstrap.Collapse.getOrCreateInstance(collapse);
        instance.show();
      });
    });
  }
  bindCollapseEvents() {
    this.collapses.forEach((collapseEl) => {
      collapseEl.addEventListener("shown.bs.collapse", (e) => {
        const pane = collapseEl.closest(".tab-pane");
        if (!pane) return;
        const paneId = pane.getAttribute("id");
        const tabBtn = this.wrapper.querySelector(
          `.nav-link[data-bs-target="#${paneId}"]`
        );
        if (tabBtn) {
          const tab = new bootstrap.Tab(tabBtn);
          tab.show();
        }
      });
    });
  }
}
customElements.define("tab-collapse", TabCollapseElement);
const onYouTubeApiLoaded = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
class VideoElement extends HTMLElement {
  constructor() {
    super();
    if (this.posterElement) {
      this.posterElement.addEventListener("click", this.handlePosterClick.bind(this));
    }
    if (this.volumeElement) {
      this.volumeElement.addEventListener("click", this.handleVolumeClick.bind(this));
    }
    if (this.autoplay) {
      GSP.Motion.inView(this, () => {
        if (!this.paused) {
          this.play();
        }
        return () => {
          this.pause();
        };
      });
    }
    if (this.autoplayOnHover) {
      this.addEventListener("mouseleave", this.handleMouseInteraction.bind(this, "leave"));
      this.addEventListener("mouseenter", this.handleMouseInteraction.bind(this, "enter"));
    }
    this.addEventListener("video:play", this.updatePosterIcon.bind(this));
    this.addEventListener("video:pause", this.updatePosterIcon.bind(this));
    this.addEventListener("video:mute", this.updateVolumeIcon.bind(this));
    this.addEventListener("video:unmute", this.updateVolumeIcon.bind(this));
    if (this.autoStopOtherVideo) {
      this.addEventListener("video:play", this.pauseOtherVideoOnPage.bind(this));
    }
  }
  get posterElement() {
    return this.querySelector('[id^="DeferredPoster-"]');
  }
  get volumeElement() {
    return this.querySelector('[id^="ToggleVolumeButton-"]');
  }
  get controlledElement() {
    return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
  }
  get autoplay() {
    return this.hasAttribute("autoplay");
  }
  get autoplayOnHover() {
    return this.hasAttribute("autoplay-on-hover");
  }
  get autoStopOtherVideo() {
    return this.hasAttribute("auto-stop-other-video");
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get muted() {
    return this.hasAttribute("muted");
  }
  get player() {
    return this.playerProxy = this.playerProxy || new Proxy(this.initializePlayer(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.handlePlayerAction(target, prop);
        };
      }
    });
  }
  static get observedAttributes() {
    return ["playing", "muted"];
  }
  handlePosterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    gspTheme.helper.enableLoadingSpiner(this.posterElement);
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
    setTimeout(() => {
      gspTheme.helper.disableLoadingSpinner(this.posterElement);
    }, 500);
  }
  handleVolumeClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.muted) {
      this.unmute();
    } else {
      this.mute();
    }
  }
  updateVolumeIcon() {
    if (!this.volumeElement) return;
    const iconMute = this.volumeElement.querySelector(".icon-mute");
    const iconUnmute = this.volumeElement.querySelector(".icon-unmute");
    if (this.muted) {
      iconMute?.classList.remove("hidden");
      iconUnmute?.classList.add("hidden");
    } else {
      iconMute?.classList.add("hidden");
      iconUnmute?.classList.remove("hidden");
    }
  }
  pauseOtherVideoOnPage() {
    if (!this.autoplay) {
      document.querySelectorAll("video-element").forEach((el) => {
        if (el === this) return;
        if (el.playing && !el.autoplay) {
          el.paused = true;
          el.pause();
        }
      });
    }
  }
  handleMouseInteraction(type, event) {
    if (type === "enter") {
      if (!this.playing) {
        this.paused = false;
        this.play();
      }
    } else {
      if (this.playing) {
        this.paused = true;
        this.pause();
      }
    }
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  mute() {
    this.setAttribute("muted", "");
    this.player.mute();
  }
  unmute() {
    this.removeAttribute("muted");
    this.player.unmute();
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        return this.dispatchEvent(new CustomEvent("video:play", { bubbles: true }));
      }
      if (newValue === null) {
        return this.dispatchEvent(new CustomEvent("video:pause", { bubbles: true }));
      }
    }
    if (name === "muted") {
      if (oldValue === null && newValue === "") {
        return this.dispatchEvent(new CustomEvent("video:mute", { bubbles: true }));
      }
      if (newValue === null) {
        return this.dispatchEvent(new CustomEvent("video:unmute", { bubbles: true }));
      }
    }
  }
  initializePlayer() {
    if (this.hasAttribute("source")) {
      this.setAttribute("loaded", "");
      this.closest(".media")?.classList.remove("loading");
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector("template");
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = window.matchMedia("screen and (max-width: 1023px)").matches;
        if (muteVideo) {
          this.setAttribute("muted", "");
        }
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("source") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubeApiLoaded;
          const player = new YT.Player(this.querySelector("iframe"), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                }
                this.updateVolumeIcon();
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("source") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector("iframe"));
          if (muteVideo) {
            player.setMuted(true);
          }
          this.updateVolumeIcon();
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.closest(".media")?.classList.remove("loading");
      const player = this.querySelector("video");
      if (player) {
        this.syncNativeVideoState(player);
        this.updateVolumeIcon();
        player.addEventListener("play", () => {
          this.setAttribute("playing", "");
          this.removeAttribute("suspended");
        });
        player.addEventListener("pause", () => {
          if (!player.seeking && player.paused) {
            this.removeAttribute("playing");
          }
        });
        player.addEventListener("loadeddata", () => {
          this.setAttribute("loaded", "");
        });
      }
      return player;
    }
  }
  // A <video muted> that is cloned from a <template> (cloneNode) does NOT
  // get muted from the `muted` content attribute (the attribute is only
  // read when the element is created by the parser). Safari/iOS then
  // treats the video as unmuted and blocks autoplay that has no user
  // gesture. So we copy the state from <video-element muted> explicitly.
  syncNativeVideoState(nativeVideo) {
    if (!nativeVideo) return;
    nativeVideo.setAttribute("playsinline", "");
    nativeVideo.setAttribute("webkit-playsinline", "");
    nativeVideo.playsInline = true;
    nativeVideo.defaultMuted = this.muted;
    nativeVideo.muted = this.muted;
  }
  handlePlayerAction(target, prop) {
    if (this.getAttribute("source") === "youtube") {
      if (prop === "play") {
        target.playVideo();
      } else if (prop === "pause") {
        target.pauseVideo();
      } else if (prop === "mute") {
        target.mute();
      } else if (prop === "unmute") {
        target.unMute();
      }
    } else if (this.getAttribute("source") === "vimeo") {
      if (prop === "play") {
        target.play();
      } else if (prop === "pause") {
        target.pause();
      } else if (prop === "mute") {
        target.setMuted(true);
      } else if (prop === "unmute") {
        target.setMuted(false);
      }
    } else {
      if (prop === "play" && !this.hasAttribute("source")) {
        this.syncNativeVideoState(target);
        const onBlocked = (error) => {
          if (error.name !== "NotAllowedError") return;
          this.setAttribute("suspended", "");
          if (!this.closest(".gsp-element-shoppable-video")) {
            target.controls = true;
          }
          const replacementImageSrc = target.previousElementSibling?.currentSrc;
          if (replacementImageSrc) {
            target.poster = replacementImageSrc;
          }
        };
        target.play().catch((error) => {
          if (error.name === "NotAllowedError" && !target.muted) {
            this.setAttribute("muted", "");
            target.defaultMuted = true;
            target.muted = true;
            target.play().catch(onBlocked);
            return;
          }
          onBlocked(error);
        });
      } else if (prop === "mute") {
        target.muted = true;
      } else if (prop === "unmute") {
        target.muted = false;
      } else {
        target[prop]();
      }
    }
  }
  updatePosterIcon() {
    if (!this.posterElement) return;
    const iconPlay = this.posterElement.querySelector(".icon-play");
    const iconPause = this.posterElement.querySelector(".icon-pause");
    if (!this.playing) {
      iconPlay?.classList.remove("hidden");
      iconPause?.classList.add("hidden");
    } else {
      iconPlay?.classList.add("hidden");
      iconPause?.classList.remove("hidden");
    }
  }
}
customElements.define("video-element", VideoElement);
class PromoBannersElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="PromoBannersSlider"]'
    };
    this.sliderInstance = null;
    this.abortController = new AbortController();
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
    this.layout = this.dataset.layout;
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.setSliderOptions();
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true
    };
  }
  updateMediaLayout() {
    const isMobile = this.mqlMobile.matches;
    this.destroySlider();
    if (isMobile || this.layout === "slider") {
      this.initSlider();
    }
  }
  destroySlider() {
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
      this.sliderInstance = null;
    }
  }
  initSlider() {
    if (this.sliderInstance) {
      return;
    }
    this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
  }
}
customElements.define("promo-banners", PromoBannersElement);
class VisualShowcaseElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="VisualShowcaseSlider"]'
    };
    this.sliderInstance = null;
    this.abortController = new AbortController();
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.setSliderOptions();
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true
    };
  }
  updateMediaLayout() {
    this.destroySlider();
    if (GSP.config.device.isMobile()) {
      this.sliderOptions.autoplay = {
        enabled: true
      };
    } else {
      this.sliderOptions.autoplay = {
        enabled: false
      };
    }
    this.initSlider();
  }
  destroySlider() {
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
      this.sliderInstance = null;
    }
  }
  initSlider() {
    if (this.sliderInstance) {
      return;
    }
    this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
  }
}
customElements.define("visual-showcase", VisualShowcaseElement);
if (!customElements.get("logo-badge")) {
  class LogoBadge extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.layout = this.dataset.layout;
      this.init();
    }
    init() {
      if (this.layout === "image") {
        return;
      }
      const refit = () => this.fit();
      this.fit();
      if (document.fonts) {
        const textEl = this.querySelector(".logo-badge__text");
        if (textEl && document.fonts.load) {
          const cs = getComputedStyle(textEl);
          const sample = textEl.textContent.trim();
          document.fonts.load(`${cs.fontWeight} 20px ${cs.fontFamily}`, sample).then(refit).catch(() => {
          });
        }
        if (document.fonts.ready) {
          document.fonts.ready.then(refit);
        }
      }
      if (document.readyState !== "complete") {
        window.addEventListener("load", refit, { once: true });
      }
    }
    fit() {
      const svg = this.querySelector(".logo-badge__ring");
      if (!svg) return;
      const gapInfo = this.fitTextSize(svg);
      if (!gapInfo) return;
      this.drawSeparatorArc(svg, gapInfo);
    }
    // Lấy số liệu font bằng Canvas 2D thay cho SVG getComputedTextLength():
    // WebKit/iOS đo sai khi SVG bị scale (viewBox 200 -> ~75px).
    // Trả về { g, cap }: g = độ dài chữ trên mỗi 1px font-size (đã gồm letter-spacing),
    // cap = chiều cao chữ hoa trên mỗi 1px font-size.
    measureMetrics(textEl, text) {
      try {
        const cs = getComputedStyle(textEl);
        const ctx = this._ctx = this._ctx || document.createElement("canvas").getContext("2d");
        if (!ctx) return null;
        const refSize = 100;
        ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${refSize}px ${cs.fontFamily}`;
        const glyphsPerPx = ctx.measureText(text).width / refSize;
        if (!glyphsPerPx) return null;
        const fs = parseFloat(cs.fontSize) || 20;
        const ls = parseFloat(cs.letterSpacing);
        const lsRatio = Number.isFinite(ls) ? ls / fs : 0;
        const chars = Array.from(text).length;
        const capPx = ctx.measureText("H").actualBoundingBoxAscent / refSize;
        return {
          g: glyphsPerPx + lsRatio * chars,
          cap: capPx > 0 ? capPx : 0.7
        };
      } catch (err) {
        return null;
      }
    }
    fitTextSize(svg) {
      const textEl = svg.querySelector(".logo-badge__text");
      const textPath = svg.querySelector("textPath");
      const pathEl = svg.querySelector("defs path");
      if (!textEl || !textPath) return null;
      const baseFontSize = parseFloat(this.dataset.fontSize) || 20;
      const fillPercent = parseFloat(this.dataset.textFill) || 94;
      const R = parseFloat(this.dataset.circleRadius) || 75;
      const f = fillPercent / 100;
      const TAU = 2 * Math.PI;
      const minSize = 4;
      const maxSize = baseFontSize * 2;
      textEl.style.fontSize = `${baseFontSize}px`;
      const text = (textPath.textContent || "").replace(/\s+/g, " ").trim();
      if (!text) return null;
      let metrics = this.measureMetrics(textEl, text);
      if (!metrics) {
        let natural = 0;
        try {
          natural = textPath.getComputedTextLength() || textEl.getComputedTextLength();
        } catch (err) {
          return null;
        }
        if (!natural) return null;
        metrics = { g: natural / baseFontSize, cap: 0.7 };
      }
      const { g, cap } = metrics;
      const c = cap / 2;
      let size = f * TAU * R / (g + f * TAU * c);
      size = Math.max(minSize, Math.min(size, maxSize));
      const pathRadius = R - c * size;
      const actualLength = g * size;
      textEl.style.fontSize = `${size.toFixed(2)}px`;
      if (pathEl) {
        const r = pathRadius.toFixed(3);
        const d2 = (pathRadius * 2).toFixed(3);
        pathEl.setAttribute("d", `M 100,100 m -${r},0 a ${r},${r} 0 1,1 ${d2},0 a ${r},${r} 0 1,1 -${d2},0`);
      }
      const actualFillFraction = Math.min(actualLength / (TAU * pathRadius), 1);
      const halfGapPercent = (1 - actualFillFraction) * 100 / 2;
      textPath.setAttribute("startOffset", `${halfGapPercent}%`);
      return {
        halfGapPercent,
        actualFillPercent: actualFillFraction * 100
      };
    }
    drawSeparatorArc(svg, gapInfo) {
      const arcPath = svg.querySelector(".logo-badge__separator-arc");
      if (!arcPath) return;
      const requestedLength = parseFloat(this.dataset.separatorLength) || 0;
      if (requestedLength <= 0) {
        arcPath.removeAttribute("d");
        return;
      }
      const radius = parseFloat(this.dataset.circleRadius) || 80;
      const cx = 100;
      const cy = 100;
      const { halfGapPercent, actualFillPercent } = gapInfo;
      const startTextDeg = 180 + halfGapPercent * 3.6;
      const endTextDeg = startTextDeg + actualFillPercent * 3.6;
      const gapCenterDeg = (endTextDeg + (startTextDeg + 360)) / 2;
      const totalGapDeg = (100 - actualFillPercent) * 3.6;
      const requestedDeg = requestedLength / 100 * 360;
      const maxSafeArcDeg = Math.max(0, totalGapDeg - 12);
      const actualArcDeg = Math.min(requestedDeg, maxSafeArcDeg);
      const halfArcDeg = actualArcDeg / 2;
      const toRad = (deg) => deg * Math.PI / 180;
      const point = (deg) => ({
        x: cx + radius * Math.cos(toRad(deg)),
        y: cy + radius * Math.sin(toRad(deg))
      });
      const start = point(gapCenterDeg - halfArcDeg);
      const end = point(gapCenterDeg + halfArcDeg);
      const largeArcFlag = halfArcDeg * 2 > 180 ? 1 : 0;
      const d = `M ${start.x.toFixed(2)},${start.y.toFixed(2)} A ${radius},${radius} 0 ${largeArcFlag},1 ${end.x.toFixed(2)},${end.y.toFixed(2)}`;
      arcPath.setAttribute("d", d);
    }
  }
  customElements.define("logo-badge", LogoBadge);
}
class MarqueeElement extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = null;
    this.animationId = null;
    this.inertiaAnimationId = null;
    this.abortController = null;
    this.resizeDebounceId = null;
    this.direction = "left";
    this.speedSec = 40;
    this.scrollDragMaxWidth = null;
    this.autoPlay = true;
    this.autoPlayMobile = true;
    this.showScrollbar = false;
    this.showScrollbarMobile = false;
    this.isDOMBuilt = false;
    this.hasDragged = false;
    this.velocity = 0;
    this.friction = 0.94;
    this.lastDragX = 0;
    this.lastDragTime = 0;
    this.isInertiaActive = false;
  }
  connectedCallback() {
    this.container = this.querySelector(".gsp-marquee__container");
    if (!this.container) return;
    this.track = this.container.querySelector(".gsp-marquee__track");
    if (!this.track) return;
    this.abortController = new AbortController();
    this.setupScrollbar();
    this.group = this.track.querySelector(".gsp-marquee__group");
    if (this.group == null) {
      this.group = document.createElement("div");
      this.group.className = "gsp-marquee__group";
      Array.from(this.track.childNodes).forEach((node) => {
        this.group.appendChild(node);
      });
      this.track.appendChild(this.group);
    }
    if (!this.originalHTML) {
      this.originalHTML = this.track.innerHTML;
    }
    if (this.hasAttribute("data-direction")) {
      this.direction = this.getAttribute("data-direction");
    }
    if (this.hasAttribute("data-speed")) {
      const parsedSpeed = parseFloat(this.getAttribute("data-speed"));
      this.speedSec = !isNaN(parsedSpeed) && parsedSpeed > 0 ? parsedSpeed : this.speedSec;
    }
    if (this.hasAttribute("data-scroll-max-width")) {
      this.scrollbar.style.maxWidth = this.getAttribute("data-scroll-max-width");
    }
    if (this.hasAttribute("data-scroll-drag-max-width")) {
      this.scrollDragMaxWidth = parseFloat(this.getAttribute("data-scroll-drag-max-width"));
    }
    if (this.hasAttribute("data-autoplay")) {
      this.autoPlay = this.getAttribute("data-autoplay") === "true";
    }
    this.autoPlayMobile = this.autoPlay;
    if (this.hasAttribute("data-autoplay-mobile")) {
      this.autoPlayMobile = this.getAttribute("data-autoplay-mobile") === "true";
    }
    if (this.hasAttribute("data-show-scrollbar")) {
      this.showScrollbar = this.getAttribute("data-show-scrollbar") === "true";
    }
    this.showScrollbarMobile = this.showScrollbar;
    if (this.hasAttribute("data-show-scrollbar-mobile")) {
      this.showScrollbarMobile = this.getAttribute("data-show-scrollbar-mobile") === "true";
    }
    this.thumbRatio = 0.2;
    this.offset = 0;
    this.isHovered = false;
    this.isDragging = false;
    this.isDraggingBar = false;
    this.startX = 0;
    this.dragOffset = 0;
    this.lastTime = performance.now();
    this.updateScrollbarVisibility();
    this.updateDimensions();
    this.setupResizeObserver();
    this.addEventListeners();
  }
  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    this.stopLoop();
    this.stopInertia();
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
    if (this.resizeDebounceId) {
      clearTimeout(this.resizeDebounceId);
      this.resizeDebounceId = null;
    }
  }
  setupScrollbar() {
    this.scrollbar = this.container.querySelector(".gsp-marquee__scrollbar");
    if (!this.scrollbar) {
      this.scrollbar = document.createElement("div");
      this.scrollbar.className = "gsp-marquee__scrollbar";
      this.scrollbarInner = document.createElement("div");
      this.scrollbarInner.className = "gsp-marquee__scrollbar-inner";
      this.scrollbarDrag = document.createElement("div");
      this.scrollbarDrag.className = "gsp-marquee__scrollbar-drag";
      this.scrollbarInner.appendChild(this.scrollbarDrag);
      this.scrollbar.appendChild(this.scrollbarInner);
      this.container.appendChild(this.scrollbar);
    } else {
      this.scrollbarDrag = this.scrollbar.querySelector(".gsp-marquee__scrollbar-drag");
    }
  }
  updateScrollbarVisibility() {
    if (!this.scrollbar) return;
    const shouldShowScrollbar = GSP.config.device.isMobile() ? this.showScrollbarMobile : this.showScrollbar;
    this.scrollbar.style.display = shouldShowScrollbar ? "" : "none";
  }
  setupResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.resizeDebounceId) clearTimeout(this.resizeDebounceId);
      this.resizeDebounceId = setTimeout(() => {
        requestAnimationFrame(() => {
          this.updateScrollbarVisibility();
          this.updateDimensions();
          this.handleAutoPlayState();
        });
      }, 50);
    });
    this.resizeObserver.observe(this.container);
  }
  handleAutoPlayState() {
    const canAutoPlay = GSP.config.device.isMobile() ? this.autoPlayMobile : this.autoPlay;
    if (canAutoPlay) {
      this.startLoop();
    } else {
      this.stopLoop();
      this.normalizeOffset();
      this.render();
    }
  }
  updateDimensions() {
    if (!this.isDOMBuilt) {
      const MAX_DEVICE_WIDTH = 3840;
      const originalTrackWidth = this.track.scrollWidth;
      if (originalTrackWidth > 0) {
        const neededCopiesForHalf = Math.ceil(MAX_DEVICE_WIDTH / originalTrackWidth);
        const totalCopies = neededCopiesForHalf * 2;
        const safeCopies = Math.min(totalCopies, 200);
        if (safeCopies > 1) {
          const fragment = document.createDocumentFragment();
          const templateFragment = document.createRange().createContextualFragment(this.originalHTML);
          for (let i = 1; i < safeCopies; i++) {
            fragment.appendChild(templateFragment.cloneNode(true));
          }
          this.track.appendChild(fragment);
        }
        this.contentWidth = this.track.scrollWidth / 2;
        this.pxPerMs = this.speedSec > 0 ? this.contentWidth / (this.speedSec * 1e3) : 0;
        this.isDOMBuilt = true;
      }
    }
    if (this.scrollbar && this.scrollbarDrag) {
      const scrollbarWidth = this.scrollbarInner.clientWidth;
      let dragWidth = scrollbarWidth * this.thumbRatio;
      if (this.scrollDragMaxWidth !== null && dragWidth > this.scrollDragMaxWidth) dragWidth = this.scrollDragMaxWidth;
      this.scrollbarDrag.style.width = `${dragWidth}px`;
      this.maxDragOffset = scrollbarWidth - dragWidth;
    }
    this.normalizeOffset();
  }
  // --- CÁC HÀM XỬ LÝ ĐÀ TRƯỢT (INERTIA/FREE MODE) ---
  stopInertia() {
    if (this.inertiaAnimationId) {
      cancelAnimationFrame(this.inertiaAnimationId);
      this.inertiaAnimationId = null;
    }
    this.isInertiaActive = false;
  }
  startInertia() {
    this.stopInertia();
    if (Math.abs(this.velocity) < 0.05) {
      this.velocity = 0;
      return;
    }
    this.isInertiaActive = true;
    let lastFrameTime = performance.now();
    const step = (currentTime) => {
      const deltaTime = currentTime - lastFrameTime;
      lastFrameTime = currentTime;
      this.offset -= this.velocity * deltaTime;
      this.velocity *= Math.pow(this.friction, deltaTime / 16.6);
      this.normalizeOffset();
      this.render();
      if (Math.abs(this.velocity) > 0.01) {
        this.inertiaAnimationId = requestAnimationFrame(step);
      } else {
        this.stopInertia();
        this.velocity = 0;
      }
    };
    this.inertiaAnimationId = requestAnimationFrame(step);
  }
  addEventListeners() {
    const { signal } = this.abortController;
    this.container.addEventListener("mouseenter", () => this.isHovered = true, { signal });
    this.container.addEventListener("mouseleave", () => this.isHovered = false, { signal });
    this.track.addEventListener("dragstart", (e) => e.preventDefault(), { signal });
    this.track.addEventListener("click", (e) => {
      if (this.hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { capture: true, signal });
    this.track.addEventListener("mousedown", (e) => {
      if (e.target.closest(".gsp-marquee__scrollbar")) return;
      this.stopInertia();
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.clientX;
      this.dragOffset = this.offset;
      this.lastDragX = e.clientX;
      this.lastDragTime = performance.now();
      this.velocity = 0;
    }, { signal });
    if (this.scrollbarDrag) {
      this.scrollbarDrag.addEventListener("mousedown", (e) => {
        e.stopPropagation();
        this.stopInertia();
        this.isDraggingBar = true;
        this.startX = e.clientX;
        this.dragOffset = this.offset;
      }, { signal });
      this.scrollbar.addEventListener("click", (e) => {
        if (e.target === this.scrollbarDrag) return;
        this.stopInertia();
        const rect = this.scrollbar.getBoundingClientRect();
        const clickX = e.clientX - rect.left - this.scrollbarDrag.clientWidth / 2;
        if (this.maxDragOffset > 0) {
          const ratio = Math.max(0, Math.min(1, clickX / this.maxDragOffset));
          this.offset = (1 - ratio) * this.contentWidth;
          this.normalizeOffset();
          this.render();
        }
      }, { signal });
    }
    window.addEventListener("mousemove", (e) => {
      if (this.isDraggingBar && this.maxDragOffset > 0) {
        const deltaX = e.clientX - this.startX;
        const ratio = this.contentWidth / this.maxDragOffset;
        this.offset = this.dragOffset - deltaX * ratio;
        this.normalizeOffset();
        this.render();
        return;
      }
      if (this.isDragging) {
        const deltaX = e.clientX - this.startX;
        if (Math.abs(deltaX) > 5) {
          this.hasDragged = true;
        }
        this.offset = this.dragOffset - deltaX;
        this.normalizeOffset();
        this.render();
        const now = performance.now();
        const dt = now - this.lastDragTime;
        if (dt > 0) {
          const dx = e.clientX - this.lastDragX;
          this.velocity = dx / dt;
          this.lastDragX = e.clientX;
          this.lastDragTime = now;
        }
      }
    }, { signal });
    window.addEventListener("mouseup", () => {
      if (this.isDragging) {
        this.isDragging = false;
        if (performance.now() - this.lastDragTime < 100) {
          this.startInertia();
        }
      }
      this.isDraggingBar = false;
    }, { signal });
    this.track.addEventListener("touchstart", (e) => {
      if (e.target.closest(".gsp-marquee__scrollbar")) return;
      this.stopInertia();
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.touches[0].clientX;
      this.dragOffset = this.offset;
      this.lastDragX = e.touches[0].clientX;
      this.lastDragTime = performance.now();
      this.velocity = 0;
    }, { passive: true, signal });
    if (this.scrollbarDrag) {
      this.scrollbarDrag.addEventListener("touchstart", (e) => {
        e.stopPropagation();
        this.stopInertia();
        this.isDraggingBar = true;
        this.startX = e.touches[0].clientX;
        this.dragOffset = this.offset;
      }, { passive: true, signal });
    }
    window.addEventListener("touchmove", (e) => {
      if (this.isDraggingBar || this.isDragging) {
        if (e.cancelable) e.preventDefault();
      }
      if (this.isDraggingBar && this.maxDragOffset > 0) {
        const deltaX = e.touches[0].clientX - this.startX;
        const ratio = this.contentWidth / this.maxDragOffset;
        this.offset = this.dragOffset - deltaX * ratio;
        this.normalizeOffset();
        this.render();
        return;
      }
      if (this.isDragging) {
        const deltaX = e.touches[0].clientX - this.startX;
        if (Math.abs(deltaX) > 5) {
          this.hasDragged = true;
        }
        this.offset = this.dragOffset - deltaX;
        this.normalizeOffset();
        this.render();
        const now = performance.now();
        const dt = now - this.lastDragTime;
        if (dt > 0) {
          const dx = e.touches[0].clientX - this.lastDragX;
          this.velocity = dx / dt;
          this.lastDragX = e.touches[0].clientX;
          this.lastDragTime = now;
        }
      }
    }, { passive: false, signal });
    window.addEventListener("touchend", () => {
      if (this.isDragging) {
        this.isDragging = false;
        if (performance.now() - this.lastDragTime < 100) {
          this.startInertia();
        }
      }
      this.isDraggingBar = false;
    }, { signal });
  }
  normalizeOffset() {
    if (!this.contentWidth) return;
    this.offset = (this.offset % this.contentWidth + this.contentWidth) % this.contentWidth;
  }
  stopLoop() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  }
  startLoop() {
    this.stopLoop();
    this.lastTime = performance.now();
    const animate = (currentTime) => {
      const deltaTime = currentTime - this.lastTime;
      this.lastTime = currentTime;
      if (!this.isHovered && !this.isDragging && !this.isDraggingBar && !this.isInertiaActive) {
        const moveBy = this.pxPerMs * deltaTime;
        if (this.direction === "left") {
          this.offset += moveBy;
        } else {
          this.offset -= moveBy;
        }
        this.normalizeOffset();
        this.render();
      }
      this.animationId = requestAnimationFrame(animate);
    };
    this.animationId = requestAnimationFrame(animate);
  }
  render() {
    this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
    if (this.scrollbarDrag && this.contentWidth > 0 && this.maxDragOffset > 0) {
      const progress = this.offset / this.contentWidth;
      const dragTranslateX = this.maxDragOffset - progress * this.maxDragOffset;
      this.scrollbarDrag.style.transform = `translate3d(${dragTranslateX}px, 0, 0)`;
    }
  }
}
customElements.define("marquee-element", MarqueeElement);
class ReadMoreElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      content: ".read-more__content",
      button: ".read-more__toggle",
      buttonText: ".btn-content"
    };
    this.classes = {
      isDisabled: "is-disabled",
      isCollapsed: "is-collapsed"
    };
    this.abortController = new AbortController();
    this.modeHeight = this.dataset.modeHeight ? this.dataset.modeHeight : "line-height";
    this.height = this.dataset.maxHeight;
    this.toggleClass = this.dataset.toggleClass;
    this.showText = this.dataset.showText;
    this.hideText = this.dataset.hideText;
    this.lineClamp = parseInt(this.dataset.lineClamp);
    this.buttonEl = this.querySelector(this.selectors.button);
    this.contentEl = this.querySelector(this.selectors.content);
    this.buttonEl.addEventListener("click", this.onClick.bind(this), {
      signal: this.abortController.signal
    });
    if (!this.dataset.responsive) {
      this.init();
    }
    if (this.dataset.responsive) {
      this.device();
      this.resize();
    }
  }
  resize() {
    this.resizeHandler = (event) => {
      const { widthChanged } = event;
      if (widthChanged) {
        this.device();
      }
    };
    GSP.resize.register(this.resizeHandler);
  }
  device() {
    if (!this.dataset.responsive) return;
    this.responsive = Object.assign(
      { desktop: true, mobile: true },
      JSON.parse(this.dataset.responsive)
    );
    this.classList.add("has-responsive");
    if (GSP.core.isDeviceDown("md")) {
      this.resetHeight();
      if (this.responsive.mobile) {
        const heightOnMobile = this.dataset.maxHeightMobile;
        if (heightOnMobile) {
          this.height = heightOnMobile;
        }
        this.init();
        this.classList.add("on-mobile");
      }
    }
    if (GSP.core.isDeviceUp("md")) {
      this.resetHeight();
      if (this.responsive.desktop) {
        const heightOnDesktop = this.dataset.maxHeight;
        if (heightOnDesktop) {
          this.height = heightOnDesktop;
        }
        this.init();
        this.classList.add("on-desktop");
      }
    }
  }
  init() {
    const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight);
    const contentHeight = this.contentEl.scrollHeight;
    const maxHeight = lineHeight * this.lineClamp;
    if (contentHeight <= maxHeight) {
      this.buttonEl.style.display = "none";
      return;
    }
    this.classList.remove(this.classes.isDisabled);
    this.contentEl.classList.remove(this.toggleClass);
    this.showLess();
  }
  showMore() {
    this.contentEl.classList.remove(this.toggleClass);
    this.classList.remove(this.classes.isCollapsed);
    this.changeButton(this.hideText);
    this.resetHeight();
  }
  showLess() {
    this.contentEl.classList.add(this.toggleClass);
    this.classList.add(this.classes.isCollapsed);
    this.changeButton(this.showText);
    this.setHeight();
  }
  changeButton(text) {
    const btnAnimation = this.buttonEl.classList.contains("btn-animation");
    if (btnAnimation) {
      this.buttonEl.querySelector(".path-front").textContent = text;
      this.buttonEl.querySelector(".path-back").textContent = text;
    } else {
      this.buttonEl.querySelector(this.selectors.buttonText).textContent = text;
    }
  }
  getHeight() {
    var height = 0;
    if (this.modeHeight == "line-height") {
      const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight);
      const lines = parseInt(window.getComputedStyle(this.contentEl).getPropertyValue("--line-clamp"));
      height = lineHeight * lines;
    }
    if (this.modeHeight == "height") {
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const maxAllowedHeight = this.height;
      height = viewportHeight * (maxAllowedHeight / 100);
    }
    return height;
  }
  setHeight() {
    const maxHeight = this.getHeight();
    this.contentEl.style.setProperty("max-height", maxHeight + "px");
  }
  resetHeight() {
    this.contentEl.style.removeProperty("max-height");
  }
  onClick(evt) {
    evt.preventDefault();
    if (this.contentEl.classList.contains(this.toggleClass)) {
      this.showMore();
    } else {
      this.showLess();
    }
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
}
customElements.define("read-more", ReadMoreElement);
class mobileNavigationBar extends HTMLElement {
  constructor() {
    super();
    document.body.classList.add("has-mobile-navigation-bar");
    this.setHeight();
  }
  setHeight() {
    const _self = this;
    document.documentElement.style.setProperty("--gsp-mobile-navigation-bar-height", _self.clientHeight + "px");
    $(document).on("after_prevent_transition_resize", function() {
      setTimeout(function() {
        document.documentElement.style.setProperty("--gsp-mobile-navigation-bar-height", _self.clientHeight + "px");
      }, 100);
    });
  }
}
customElements.define("mobile-navigation-bar", mobileNavigationBar);
class ScrollingCardsMosaicElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="ScrollingCardsMosaicSlider"]'
    };
    this.sliderInstance = null;
    this.abortController = new AbortController();
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    this.destroySlider();
    if (this.scrollHandler) {
      GSP.scroll.unregister(this.scrollHandler);
    }
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.section = gspTheme.helper.getSection(this);
    this.sectionHeader = this.section.querySelector(".gsp-section-header__wrap");
    this.sectionWrapper = this.section.querySelector(".gsp-section__wrap");
    this.isHeaderSticky = this.dataset.headerSticky === "true";
    this.isScrollParallax = this.dataset.scrollParallax === "true";
    this.initParallax();
    this.initSticky();
    this.initSlider();
    this.setSliderOptions();
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
  }
  initSticky() {
    if (this.isHeaderSticky && this.sectionHeader && this.sectionWrapper) {
      GSP.sticky.setSticky(this.sectionHeader, this.sectionWrapper);
      this.startOffset = parseFloat(getComputedStyle(this.sectionHeader).paddingBottom);
      this.maxBlur = 2;
    }
  }
  initParallax() {
    if (this.isScrollParallax) {
      this.parallaxLayers = this.querySelectorAll(".gsp-block__wrap .parallax");
      this.speedMap = [
        [0],
        [0.1, 0],
        [0, 0.25, 0],
        [0, 0.1, -0.15, 0],
        [0, 0.1, -0.25, -0.05, 0],
        [0, 0.15, -0.15, 0.05, -0.05, 0],
        [0, 0.15, -0.05, 0.05, -0.05, 0.05, 0],
        [0, 0.15, -0.25, 0, -0.05, 0.05, -0.1, 0]
      ];
      this.speedMapIndex = Math.min(this.parallaxLayers.length, 8) - 1;
    }
  }
  updateMediaLayout() {
    this.destroySlider();
    this.destroyScroll();
    this.resetStyleSticky();
    this.resetStyleParallax();
    if (GSP.config.device.isMobile()) {
      this.initSlider();
    } else {
      if (this.isScrollParallax || this.isHeaderSticky) {
        this.registerScroll();
      }
    }
  }
  registerScroll() {
    if (this.scrollHandler) {
      GSP.scroll.unregister(this.scrollHandler);
    }
    this.scrollHandler = ({ scroll }) => {
      this.processScroll(scroll);
    };
    GSP.scroll.register(this.scrollHandler);
  }
  destroyScroll() {
    if (this.scrollHandler) {
      GSP.scroll.unregister(this.scrollHandler);
    }
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true
    };
  }
  destroySlider() {
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
      this.sliderInstance = null;
    }
  }
  initSlider() {
    if (this.sliderInstance) {
      return;
    }
    this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
  }
  processScroll(scrollY) {
    if (GSP.config.device.isMobile()) {
      return;
    }
    const sectionRect = this.section.getBoundingClientRect();
    const sectionTop = sectionRect.top + scrollY;
    if (this.isHeaderSticky) {
      const scrollDistance = this.sectionHeader.clientHeight;
      const relativeScroll = scrollY - (sectionTop + this.startOffset);
      const progress = Math.min(Math.max(relativeScroll / scrollDistance, 0), 1);
      const blurPx = progress * this.maxBlur;
      this.sectionHeader.style.filter = `blur(${blurPx.toFixed(2)}px)`;
    }
    if (this.isScrollParallax) {
      let speedIndex = 0;
      this.parallaxLayers.forEach((layer) => {
        const speed = parseFloat(layer.getAttribute("data-speed")) || this.speedMap[this.speedMapIndex][speedIndex % 8];
        speedIndex++;
        if (sectionRect.top < 0) {
          const translateY = (scrollY - sectionTop) * speed;
          layer.style.transform = `translate3d(0, ${translateY.toFixed(2)}px, 0)`;
        } else {
          layer.style.transform = "";
        }
      });
    }
  }
  resetStyleSticky() {
    if (this.isHeaderSticky && this.sectionHeader) {
      this.sectionHeader.style.filter = "";
    }
  }
  resetStyleParallax() {
    if (this.isScrollParallax && this.parallaxLayers.length) {
      this.parallaxLayers.forEach((layer) => {
        layer.style.transform = "";
      });
    }
  }
}
customElements.define("scrolling-cards-mosaic", ScrollingCardsMosaicElement);
class ScrollingCardsStackedElement extends HTMLElement {
  constructor() {
    super();
    this.sliderInstance = null;
    this.sliderThumb = null;
    this.abortController = new AbortController();
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    this.destroySlider();
    if (this.scrollHandler) {
      GSP.scroll.unregister(this.scrollHandler);
    }
  }
  init() {
    this.cardListsWrap = this.querySelector(".gsp-scrolling-cards-stacked__card-list-wrap");
    this.cardLists = this.querySelector(".gsp-scrolling-cards-stacked__card-list");
    this.cards = this.querySelectorAll(".gsp-scrolling-cards-stacked__card-list .gsp-block");
    this.totalCards = this.cards.length;
    this.thumbsWrap = this.querySelector(".gsp-scrolling-cards-stacked__thumbnail-slider");
    this.thumbnail = this.querySelector(".gsp-scrolling-cards-stacked__thumbnail");
    this.thumbs = this.querySelectorAll(".gsp-scrolling-cards-stacked__thumbnail-item");
    this.counter = this.querySelector(".gsp-scrolling-cards-stacked__counter-index");
    this.section = gspTheme.helper.getSection(this);
    this.sectionHeader = this.section.querySelector(".gsp-section-header__wrap");
    this.sectionWrapper = this.section.querySelector(".gsp-section__wrap");
    this.isHeaderSticky = true;
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
    this.thumbClickProcess();
    this.processDesignMode();
    this.readMoreProcess();
  }
  processDesignMode() {
    if (Shopify.designMode) {
      const ownerElement = this;
      document.addEventListener("shopify:block:select", function(event) {
        const block = document.querySelector(".gsp-block__" + event.detail.blockId);
        const blockWrap = block.closest(".gsp-scrolling-cards-stacked__card-list");
        if (!blockWrap) {
          return;
        }
        const blocks = blockWrap.querySelectorAll(".gsp-block");
        const index = Array.from(blocks).indexOf(block);
        if (ownerElement.cardListsWrap.swiper) {
          ownerElement.cardListsWrap.swiper.slideTo(index);
        } else {
          if (index < ownerElement.thumbs.length) {
            const currentThumb = ownerElement.thumbs[index];
            currentThumb.click();
          }
        }
      });
    }
  }
  readMoreProcess() {
    this.cards.forEach((card) => {
      const readMore = card.querySelector(".gsp-scrolling-cards-stacked__read-more button");
      const descWrap = card.querySelector(".gsp-scrolling-cards-stacked__desc-wrap");
      const listText = card.querySelector(".gsp-scrolling-cards-stacked__list-text");
      readMore.addEventListener("click", () => {
        const isOpen = descWrap.classList.contains("is-open");
        if (!isOpen) {
          listText.style.maxHeight = listText.scrollHeight + "px";
          descWrap.classList.add("is-open");
        } else {
          listText.style.maxHeight = 0;
          descWrap.classList.remove("is-open");
        }
        this.cardListsWrap.swiper.updateAutoHeight();
        const currentSwiper = this.cardListsWrap.swiper;
        const duration = 300;
        const startTime = performance.now();
        function updateLoop(currentTime) {
          const elapsed = currentTime - startTime;
          currentSwiper.updateAutoHeight();
          if (elapsed < duration) {
            requestAnimationFrame(updateLoop);
          } else {
            currentSwiper.updateAutoHeight();
          }
        }
        requestAnimationFrame(updateLoop);
      }, {
        signal: this.abortController.signal
      });
    });
  }
  updateMediaLayout() {
    this.thumbs.forEach((thumb, i) => {
      if (i === 0) {
        thumb.classList.add("swiper-slide-thumb-active");
      } else {
        thumb.classList.remove("swiper-slide-thumb-active");
      }
    });
    this.resetStyle();
    this.destroySlider();
    this.destroyScroll();
    if (GSP.config.device.isMobile()) {
      this.initSlider();
    } else {
      this.registerScroll();
    }
    this.processScroll(GSP.scroll.getScroll());
  }
  resetStyle() {
    this.cards.forEach((card, i) => {
      card.style.transform = "";
      card.style.filter = ``;
      card.style.opacity = "";
      card.style.zIndex = "";
    });
  }
  registerScroll() {
    if (this.scrollHandler) {
      GSP.scroll.unregister(this.scrollHandler);
    }
    this.scrollHandler = ({ scroll }) => {
      this.processScroll(scroll);
    };
    GSP.scroll.register(this.scrollHandler);
  }
  destroyScroll() {
    if (this.scrollHandler) {
      GSP.scroll.unregister(this.scrollHandler);
    }
  }
  destroySlider() {
    if (this.sliderThumb) {
      this.sliderThumb.destroy(true, true);
      this.sliderThumb = null;
      this.thumbsWrap.classList.remove("swiper");
      this.thumbsWrap.classList.remove("swiper-thumbs");
      this.thumbnail.classList.remove("swiper-wrapper");
      this.thumbs.forEach((thumb) => {
        thumb.classList.remove("swiper-slide");
      });
    }
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
      this.sliderInstance = null;
      this.cardListsWrap.classList.remove("swiper");
      this.cardLists.classList.remove("swiper-wrapper");
      this.cards.forEach((card) => {
        card.classList.remove("swiper-slide");
      });
    }
  }
  initSlider() {
    if (this.sliderInstance) {
      return;
    }
    this.thumbsWrap.classList.add("swiper");
    this.thumbnail.classList.add("swiper-wrapper");
    this.thumbs.forEach((thumb) => {
      thumb.classList.add("swiper-slide");
    });
    this.sliderThumb = new GSP.Swiper.Swiper(this.thumbsWrap, {
      allowTouchMove: true,
      spaceBetween: 6,
      slidesPerView: "auto"
    });
    this.cardListsWrap.classList.add("swiper");
    this.cardLists.classList.add("swiper-wrapper");
    this.cards.forEach((card) => {
      card.classList.add("swiper-slide");
    });
    this.sliderInstance = new GSP.Swiper.Swiper(this.cardListsWrap, {
      autoplay: true,
      autoHeight: true,
      allowTouchMove: true,
      thumbs: {
        swiper: this.sliderThumb
      }
    });
  }
  processScroll(scrollY) {
    if (GSP.config.device.isMobile()) {
      return;
    }
    const clamp = (val, min, max) => Math.min(Math.max(val, min), max);
    const rect = this.section.getBoundingClientRect();
    const bufferOffset = 80;
    const scrollableHeight = this.section.offsetHeight - window.innerHeight - bufferOffset;
    if (scrollableHeight === 0) {
      return;
    }
    const scrolledPixels = -rect.top - bufferOffset;
    const progress = clamp(scrolledPixels / scrollableHeight, 0, 1);
    const totalCards = this.totalCards;
    let activeIndex = Math.floor(progress * totalCards);
    if (activeIndex >= totalCards) activeIndex = totalCards - 1;
    this.counter.textContent = `0${activeIndex + 1}`;
    this.thumbs.forEach((thumb, idx) => {
      if (idx === activeIndex) {
        thumb.classList.add("swiper-slide-thumb-active");
      } else {
        thumb.classList.remove("swiper-slide-thumb-active");
      }
    });
    const stepSegment = 1 / (totalCards - 1);
    const activeProgress = progress / stepSegment;
    const windowHeight = window.innerHeight;
    this.cards.forEach((card, i) => {
      const distanceFromFront = Math.max(0, i - activeProgress);
      const currentScale = 1 - distanceFromFront * 0.04;
      const stackOffsetY = distanceFromFront * 12;
      const currentBrightness = 1 - distanceFromFront * 0.06;
      const currentOpacity = 1 - distanceFromFront * 0.03;
      const slideProgress = Math.max(0, activeProgress - i);
      const translateY = -(slideProgress * windowHeight);
      const finalY = stackOffsetY + translateY;
      card.style.transform = `translate3d(0, ${finalY}px, 0) scale(${currentScale})`;
      card.style.filter = `brightness(${currentBrightness})`;
      card.style.transformOrigin = "bottom center";
      card.style.zIndex = totalCards - i;
      card.style.opacity = currentOpacity;
    });
  }
  thumbClickProcess() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (GSP.config.device.isMobile()) {
          return;
        }
        if (this.thumbs.length < 2) {
          return;
        }
        const targetIndex = parseInt(thumb.getAttribute("data-index"));
        const sectionTop = this.section.offsetTop;
        const scrollableHeight = this.section.offsetHeight - window.innerHeight;
        const stepRatio = targetIndex / (this.totalCards - 1);
        const targetScroll = sectionTop + scrollableHeight * stepRatio;
        const activeThumb = Array.from(this.thumbs).find((t) => t.classList.contains("swiper-slide-thumb-active"));
        const currentIndex = activeThumb ? parseInt(activeThumb.getAttribute("data-index")) : 0;
        const indexDiff = Math.abs(targetIndex - currentIndex);
        let dynamicDuration = 1.2;
        if (indexDiff > 0) {
          dynamicDuration = Math.min(5.5, 0.8 + indexDiff * 0.4);
        }
        GSP.scroll.scrollTo(targetScroll, {
          duration: dynamicDuration,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
        });
      }, {
        signal: this.abortController.signal
      });
    });
  }
}
customElements.define("scrolling-cards-stacked", ScrollingCardsStackedElement);
class StoreSpotlightElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      viewer: '[id^="GalleryViewer"]',
      thumbnails: '[id^="GalleryThumbnails"]'
    };
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
    this.abortController = new AbortController();
    this.sliderInstance = false;
    this.thumbsInstance = false;
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this.resizeHandler) {
      GSP.resize.unregister(this.resizeHandler);
    }
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.elements.thumbnails.addEventListener("gsp:swiper:afterInit", (event) => {
      this.updateContentPadding();
    }, {
      signal: this.abortController.signal
    });
    this.setSliderOptions();
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
    this.resizeHandler = () => {
      this.updateContentPadding();
    };
    GSP.resize.register(this.resizeHandler);
  }
  updateMediaLayout() {
    this.destroySlider();
    if (!GSP.config.device.isMobile()) {
      this.initSlider();
    }
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true,
      simulateTouch: false
    };
    this.thumbsOptions = {
      watchSlidesProgress: true
    };
  }
  initSlider() {
    if (typeof this.sliderInstance !== "object") {
      if (this.elements.thumbnails) {
        if (typeof this.thumbsInstance !== "object") {
          this.thumbsInstance = GSP.carousel.initSwiper(this.elements.thumbnails, this.thumbsOptions);
          this.sliderOptions.thumbs = {
            swiper: this.thumbsInstance
          };
        }
      }
      this.sliderInstance = GSP.carousel.initSwiper(this.elements.viewer, this.sliderOptions);
      this.thumbsInstance.slides.forEach((slide, index) => {
        slide.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.sliderInstance.slideTo(index);
          }
        });
      });
    }
  }
  destroySlider() {
    if (typeof this.thumbsInstance === "object") {
      this.thumbsInstance.destroy();
      this.thumbsInstance = false;
    }
    if (typeof this.sliderInstance === "object") {
      this.sliderInstance.destroy();
      this.sliderInstance = false;
    }
  }
  updateContentPadding() {
    const thumbnail = this.querySelector(".store-spotlight__thumbnail");
    if (thumbnail) {
      this.style.setProperty("--thumbnail-height", `${thumbnail.offsetHeight}px`);
    }
    this.updateViewportOffset();
  }
  updateViewportOffset() {
    if (GSP.config.device.isMobile()) {
      this.style.removeProperty("--store-spotlight-offset");
      return;
    }
    const top = this.getBoundingClientRect().top + window.scrollY;
    this.style.setProperty("--store-spotlight-offset", `${Math.round(top)}px`);
  }
}
customElements.define("store-spotlight", StoreSpotlightElement);
class ShopTheLookElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      productItems: [".shop-the-look__product-list"]
    };
    this.handleUpdateMediaLayout = this.updateMediaLayout.bind(this);
    this.abortController = new AbortController();
    this.sliderInstances = /* @__PURE__ */ new Map();
    this.isMobileLayout = null;
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    this.destroySlider();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.setSliderOptions();
    this.mqlMobile = GSP.config.device.queries.mobile;
    this.mqlMobile.addEventListener("change", this.handleUpdateMediaLayout, {
      signal: this.abortController.signal
    });
    this.updateMediaLayout();
    const myCollapsible = this.querySelector(".accordion");
    myCollapsible.addEventListener("show.bs.collapse", (event) => {
      const index = event.target.dataset.index;
      this.querySelectorAll(".shop-the-look__items .shop-the-look__item").forEach((el) => {
        el.classList.toggle("is-active", el.dataset.index === index);
      });
    });
    myCollapsible.addEventListener("shown.bs.collapse", (event) => {
      if (!GSP.config.device.isMobile()) return;
      const index = event.target.dataset.index;
      this.initOrUpdateSlider(index);
    });
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        const blockEl = event.target.closest("[data-block-id]");
        if (!blockEl) return;
        const index = blockEl.dataset.index;
        const button = this.querySelector(`.accordion-button[data-index="${index}"]`);
        if (button?.classList.contains("collapsed")) {
          button.click();
        }
      });
    }
  }
  updateMediaLayout() {
    const isMobile = GSP.config.device.isMobile();
    if (isMobile === this.isMobileLayout) return;
    this.isMobileLayout = isMobile;
    this.destroySlider();
    if (isMobile) {
      const openBody = this.querySelector(".accordion-collapse.show");
      const index = openBody.dataset.index;
      this.initOrUpdateSlider(index);
    }
  }
  setSliderOptions() {
    this.sliderOptions = {
      autoHeight: true,
      grabCursor: true,
      allowTouchMove: true
    };
  }
  destroySlider() {
    this.sliderInstances.forEach((instance) => {
      if (instance && typeof instance.destroy === "function") {
        instance.destroy(true, true);
      }
    });
    this.sliderInstances.clear();
  }
  initOrUpdateSlider(index) {
    const viewerEl = this.querySelector(`.shop-the-look__product-list[data-index="${index}"] [id^="GalleryViewer"]`);
    if (!viewerEl) return;
    if (this.sliderInstances.has(viewerEl.id)) {
      this.sliderInstances.get(viewerEl.id).update();
      return;
    }
    const instance = GSP.carousel.initSwiper(viewerEl, this.sliderOptions);
    this.sliderInstances.set(viewerEl.id, instance);
  }
}
customElements.define("shop-the-look", ShopTheLookElement);
class PressCardElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      slider: '[id^="PressCardSlider"]'
    };
    this.swiper = null;
    this.options = {};
    this.loopedSlides = 0;
    this._navLocked = false;
    this._navLockTimeout = null;
    this._resizeTimer = null;
    this._lastWidth = 0;
    this.abortController = new AbortController();
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    clearTimeout(this._navLockTimeout);
    clearTimeout(this._resizeTimer);
    this.destroySlider();
  }
  init() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.header_position = this.dataset.headerPosition;
    this.view_mode = this.dataset.viewMode;
    this.overflow = this.dataset.overflow === "true";
    const slider = this.elements.slider;
    const opt = { signal: this.abortController.signal };
    try {
      this.options = JSON.parse(slider.dataset.swiperOptions || "{}");
    } catch (e) {
      this.options = {};
    }
    this.isLoop = this.header_position === "top" && this.overflow;
    slider.addEventListener("gsp:swiper:afterInit", (event) => {
      this.swiper = event.detail.swiper;
      if (this.isLoop) {
        this.initLoop();
      }
    }, opt);
    slider.addEventListener("gsp:swiper:sliderMove", () => this.loopFixDuringDrag(), opt);
    const settle = () => this.releaseNavLockAndFix();
    slider.addEventListener("gsp:swiper:slideChangeTransitionEnd", settle, opt);
    slider.addEventListener("gsp:swiper:transitionEnd", settle, opt);
    window.addEventListener("resize", () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.rebuildLoop(), 250);
    }, opt);
    this.setSliderOptions();
    this.initSlider();
  }
  setSliderOptions() {
    this.sliderOptions = {
      rewind: false,
      centeredSlidesBounds: false
    };
    if (this.isLoop) {
      this.sliderOptions.loop = false;
      this.sliderOptions.breakpoints = this.buildBreakpoints();
    }
  }
  buildBreakpoints() {
    const base = this.options.breakpoints || {};
    const bp = JSON.parse(JSON.stringify(base));
    let slidesPerView = "auto";
    let centeredSlides = true;
    if (this.view_mode === "number") {
      const md = bp["768"] || {};
      if (md["slidesPerView"]) {
        slidesPerView = md["slidesPerView"];
      } else {
        slidesPerView = 3;
      }
      if (slidesPerView % 2 === 0) {
        centeredSlides = false;
      }
    }
    const lg = bp["1024"] || {};
    ["768", "1024"].forEach((key) => {
      bp[key] = {
        ...bp[key],
        centeredSlides,
        centeredSlidesBounds: false,
        slidesPerView
      };
    });
    bp["1280"] = {
      ...lg,
      centeredSlides: !!this.options.centeredSlides,
      centeredSlidesBounds: false
    };
    return bp;
  }
  initSlider() {
    const el = this.elements.slider;
    if (el.swiper) return;
    GSP.carousel.initSwiper(el, this.sliderOptions);
  }
  destroySlider() {
    if (this.swiper && !this.swiper.destroyed) {
      this.destroyLoop();
      this.swiper.destroy(true, true);
    }
    this.swiper = null;
  }
  initLoop() {
    const swiper = this.swiper;
    if (!swiper || swiper.destroyed) return;
    this.destroyLoop();
    this.createLoop();
    if (!this.loopedSlides) return;
    this._lastWidth = document.documentElement.clientWidth;
    this.slideToInitial();
    this.patchSwiper();
  }
  slideToInitial() {
    const swiper = this.swiper;
    const total = this.loopedSlides ? swiper.slides.length - this.loopedSlides * 2 : 0;
    const realIndex = swiper.params.centeredSlides ? Math.ceil(total / 2) - 1 : parseInt(this.options.initialSlide, 10) || 0;
    swiper.slideTo(this.loopedSlides + realIndex, 0, false);
  }
  cloneSlide(slide) {
    const clone = slide.cloneNode(true);
    clone.classList.add("swiper-slide-duplicate");
    clone.setAttribute("data-swiper-slide-index", slide.getAttribute("data-swiper-slide-index"));
    clone.setAttribute("aria-hidden", "true");
    clone.querySelectorAll("[data-shopify-editor-block]").forEach((el) => {
      el.removeAttribute("data-shopify-editor-block");
    });
    return clone;
  }
  createLoop() {
    const swiper = this.swiper;
    if (!swiper || swiper.destroyed) return;
    const { slidesEl, params } = swiper;
    const originals = Array.from(slidesEl.querySelectorAll(`.${params.slideClass}`)).filter((slide) => !slide.classList.contains("swiper-slide-duplicate"));
    const cols = originals.length;
    if (cols < 2) {
      this.loopedSlides = 0;
      return;
    }
    originals.forEach((slide, index) => slide.setAttribute("data-swiper-slide-index", index));
    const widths = originals.map((s) => s.offsetWidth).filter((w) => w > 0);
    if (!widths.length) {
      this.loopedSlides = 0;
      return;
    }
    const viewport = document.documentElement.clientWidth;
    this.loopedSlides = Math.max(Math.ceil(viewport / Math.min(...widths)) + 1, 4);
    const prependSlides = [];
    const appendSlides = [];
    for (let i = 0; i < this.loopedSlides; i += 1) {
      appendSlides.push(originals[i % cols]);
      prependSlides.unshift(originals[(cols - 1 - i % cols + cols) % cols]);
    }
    appendSlides.forEach((slide) => slidesEl.appendChild(this.cloneSlide(slide)));
    for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
      slidesEl.prepend(this.cloneSlide(prependSlides[i]));
    }
    swiper.recalcSlides();
    swiper.updateSlides();
  }
  destroyLoop() {
    const swiper = this.swiper;
    if (!swiper || swiper.destroyed) return;
    swiper.slidesEl.querySelectorAll(".swiper-slide-duplicate").forEach((el) => el.remove());
    swiper.recalcSlides();
    swiper.updateSlides();
    this.loopedSlides = 0;
  }
  rebuildLoop() {
    const swiper = this.swiper;
    if (!swiper || swiper.destroyed || $(swiper.el).is(":visible") === false) return;
    const width = document.documentElement.clientWidth;
    if (width === this._lastWidth) return;
    this._lastWidth = width;
    const active = swiper.slides[swiper.activeIndex];
    let realIndex = active ? parseInt(active.getAttribute("data-swiper-slide-index"), 10) : 0;
    if (Number.isNaN(realIndex)) realIndex = 0;
    this.destroyLoop();
    this.createLoop();
    if (this.loopedSlides) {
      swiper.slideTo(this.loopedSlides + realIndex, 0, false);
    }
  }
  patchSwiper() {
    const swiper = this.swiper;
    if (swiper._pressLoopPatched) return;
    swiper._pressLoopPatched = true;
    const slideNext = swiper.slideNext.bind(swiper);
    const slidePrev = swiper.slidePrev.bind(swiper);
    swiper.slideNext = (...args) => {
      if (this._navLocked) return false;
      this.lockNav();
      return slideNext(...args);
    };
    swiper.slidePrev = (...args) => {
      if (this._navLocked) return false;
      this.lockNav();
      return slidePrev(...args);
    };
    const updateSlidesClasses = swiper.updateSlidesClasses.bind(swiper);
    swiper.updateSlidesClasses = () => {
      updateSlidesClasses();
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
    };
  }
  lockNav() {
    this._navLocked = true;
    clearTimeout(this._navLockTimeout);
    const speed = this.swiper && this.swiper.params && this.swiper.params.speed || 300;
    this._navLockTimeout = setTimeout(() => this.releaseNavLockAndFix(), speed + 200);
  }
  releaseNavLockAndFix() {
    clearTimeout(this._navLockTimeout);
    this.loopFix();
    this._navLocked = false;
  }
  loopFix() {
    const swiper = this.swiper;
    if (!swiper || swiper.destroyed || !this.loopedSlides) return;
    const slides = Array.from(swiper.slides);
    const targetIndex = this.findRealTargetIndex(slides, swiper.activeIndex);
    if (targetIndex === null) {
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      return;
    }
    this.jumpToIndex(targetIndex);
  }
  loopFixDuringDrag() {
    const swiper = this.swiper;
    if (!swiper || swiper.destroyed || !this.loopedSlides) return;
    const max = swiper.maxTranslate();
    const min = swiper.minTranslate();
    if (swiper.translate > min) {
      this.clampDragTranslate(min);
    } else if (swiper.translate < max) {
      this.clampDragTranslate(max);
    }
    swiper.updateActiveIndex();
    const slides = Array.from(swiper.slides);
    const targetIndex = this.findRealTargetIndex(slides, swiper.activeIndex);
    if (targetIndex === null) {
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      return;
    }
    this.jumpToIndex(targetIndex, { isDrag: true });
  }
  clampDragTranslate(value) {
    const swiper = this.swiper;
    const diff = swiper.translate - value;
    if (swiper.touchEventsData) {
      swiper.touchEventsData.startTranslate -= diff;
      swiper.touchEventsData.currentTranslate -= diff;
    }
    swiper.setTranslate(value);
  }
  findRealTargetIndex(slides, activeIndex) {
    const current = slides[activeIndex];
    if (!current || !current.classList.contains("swiper-slide-duplicate")) return null;
    const realIndex = parseInt(current.getAttribute("data-swiper-slide-index"), 10);
    if (Number.isNaN(realIndex)) return null;
    const target = slides.find(
      (s) => !s.classList.contains("swiper-slide-duplicate") && parseInt(s.getAttribute("data-swiper-slide-index"), 10) === realIndex
    );
    if (!target) return null;
    const targetIndex = slides.indexOf(target);
    return targetIndex >= 0 && targetIndex !== activeIndex ? targetIndex : null;
  }
  jumpToIndex(targetIndex, { isDrag = false } = {}) {
    const swiper = this.swiper;
    if (!swiper || swiper.destroyed) return;
    const { slidesGrid, snapGrid, params, activeIndex } = swiper;
    const grid = params.centeredSlides && snapGrid ? snapGrid : slidesGrid;
    const diff = (grid[targetIndex] ?? 0) - (grid[activeIndex] ?? 0);
    swiper.setTransition(0);
    if (isDrag && swiper.touchEventsData) {
      swiper.touchEventsData.startTranslate -= diff;
      swiper.touchEventsData.currentTranslate -= diff;
    }
    swiper.setTranslate(swiper.translate - diff);
    swiper.updateActiveIndex(targetIndex);
    swiper.updateSlidesClasses();
    swiper.animating = false;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
  }
}
customElements.define("press-card", PressCardElement);
window.gspThemeLibs.loadjs = gspTheme.helper.loadFileAssets();
